import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray, NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { IomService } from 'src/app/services/iom.service';
import { SessionService } from 'src/app/services/session.service';
import { AoAnalytics, IoAnalytics, OthersAnalytics, ScopeTree, StandardAnalytics } from 'src/app/models/text-analytics-config';
import { NgxSpinnerService } from 'ngx-spinner';
import { TreeModel, TreeComponent, Ng2TreeSettings } from 'ng2-tree';
import { TopKeyWordsFilter } from 'src/app/models/TopKeyWordsFilter';
import { ScopeSelectorService } from 'src/app/services/ScopeSelectorService';
import { AppConfigService } from 'src/app/services/app-config.service';
import { timeout } from 'rxjs/operators';
import { MultiSelectComponent } from 'ng-multiselect-dropdown';
import { find, get, pull, truncate } from 'lodash';
declare var bootbox: any;
declare var $: any; 

@Component({
  selector: 'app-e2e-textconfig',
  templateUrl: './e2e-textconfig.component.html',
  styleUrls: ['./e2e-textconfig.component.css']
})
export class E2eTextconfigComponent implements OnInit {

  textConfigForm: FormGroup;
  textConfigFormStandard: FormGroup;
  isLoadAoPill = true;
  isLoadIoPill = false;
  isLoadOtherPill = false;
  enableOthers = false;
  enableAo = false;
  enableIo = false;
  DCOthers = false;
  DCIO = false;
  DCAO = false;
  isDataAvailable: boolean = false;
  mindate: any;
  maxdate: any;
  // selectedAlgorithmModel: string = "User Defined + N-Gram Category Name"; //"System Generated: (K-means)";
  // selectedAlgorithmModel_others: string = "User Defined + N-Gram Category Name";//"System Generated: (K-means)";
  selectedAlgoOption: boolean = true;
  selectedAlgoOption_others: boolean = true;
  selectedAlgoOption_io: boolean = true;
  classifiedBasedOn: string = "Short Description";
  selectedSupportGroup_AO: string;
  selectedSupportGroup_IO: string;
  selectedSupportGroup_Others: string;
  LanguageList: any;
  Language: string;
  isDisabled: boolean = false;
  ShowPopup: boolean = true;
  public lstDomainOption = [];
  // public MasterDummyData = [];
  public lstMappingConfig_ao: any;
  public lstFilterMappingConfig_ao: any;

  public lstMappingConfig_io: any;
  public lstFilterMappingConfig_io: any;

  public lstMappingConfig_others: any;
  public lstFilterMappingConfig_others: any;

  public lstFilterMappingConfig_aoSearch: any;
  public lstFilterMappingConfig_ioSearch: any;
  public lstFilterMappingConfig_othSearch: any;

  public searchAssignmentText: string;

  public lstCategorisedBy_ao = [];
  public lstCategorisedBy_io = [];
  public lstCategorisedBy_others = [];

  public lstClassifiedBy = [];
  public lstClassifiedBy_ao = [];
  public lstClassifiedBy_io = []
  public lstClassifiedBy_others = [];

  public lstTicketType_ao = [];
  public lstTicketType_io_all = []
  public lstTicketType_io = [];
  public lstTicketType_others = [];

  public lstapplication_ao = [];
  public lstapplication_io = [];
  public lstapplication_others = [];


  isValidFormSubmitted = false;
  public ignorekeyword: string;
  public lstIgnoreKeys: any;
  public lstIgnoreKeys_others: any;
  public lstIgnoreKeys_io: any;
  //textAnalytics = new TextAnalyticsConfig();
  public check_language: string;
  public check_language_ao: string;
  public check_language_others: string;
  isResolutionDescEnabled_Others_old: boolean;
  isResolutionDescEnabled_AO_old: boolean;
  isResolutionDescEnabled_IO_old: boolean;
  isQualifiedDescEnabled: boolean = null;
  isQualifiedDescEnabled_AO: boolean = null;
  isQualifiedDescEnabled_IO: boolean = null;
  isQualifiedDescEnabled_Others: boolean = null;
  standardAnalytics = new StandardAnalytics();
  aoAnalytics = new AoAnalytics();
  scopeTree = new ScopeTree();
  ioAnalytics = new IoAnalytics();
  othersAnalytics = new OthersAnalytics();
  MasterDummyDataUpload: any;
  categorizedByFlag_ao: boolean = false;
  categorizedByFlag_io: boolean = false;
  categorizedByFlag_others: boolean = false;
  isAddkeywordsEnabled_Others: boolean = true;
  isAddkeywordsEnabled_AO: boolean = true;
  isAddkeywordsEnabled_IO: boolean = true;
  isResolutionDescEnabled_Others: boolean = true;
  isResolutionDescEnabled_AO: boolean = true;
  isResolutionDescEnabled_IO: boolean = false;
  isResolutionDescEnabledTask_Others: boolean = true;
  isResolutionDescEnabledTask_AO: boolean = true;
  isResolutionDescEnabledTask_IO: boolean = true;
  isLongDescEnabled_Others: boolean = true;
  isLongDescEnabled_AO: boolean = true;
  isLongDescEnabled_IO: boolean = false;
  isnoofcluster_IO: boolean = false;
  urlE2EUId: any;
  enableBox_AO = false;
  enableBox_IO = false;
  enableBox_Others = false;
  @ViewChild('treeComponent', { static: false }) treeComponent: TreeComponent;
  tree: TreeModel;
  treeSettings: Ng2TreeSettings = {
    rootIsVisible: true,
  };
  previousSelectedNodeId: any;
  scopeNodeController: any;
  formScope: FormGroup;
  selectedDC = [];
  @ViewChild('selectedAllAoId') selectedAllAoId: ElementRef;
  @ViewChild('selectedAllIoId') selectedAllIoId: ElementRef;
  @ViewChild('selectedAllOthersId') selectedAllOthersId: ElementRef;
  @ViewChild('selectedAllTicket') selectedAllTicket: ElementRef;
  @ViewChild('selectedAllTicketadv') selectedAllTicketadv: ElementRef;
  @ViewChild('selectedAllApplication') selectedAllApplication: ElementRef;
  @ViewChild('selectedSearchAllAoId') selectedSearchAllAoId: ElementRef;
  @ViewChild('selectedSearchAllIoId') selectedSearchAllIoId: ElementRef;
  @ViewChild('selectedSearchAllOthersId') selectedSearchAllOthersId: ElementRef;

  UserOption: any;
  ClassificationTypeId: any;
  deepdiveConfig: any;
  startDate: any;
  endDate: any;
  ticketType: any;
  CMSCheck: boolean;
  public treeData: [];
  public treeDataParent: any;
  isAvanced: boolean;
  InstancePAM: boolean;
  envVar: any;
  selectedTickettype: string = 'Select Ticket Type';
  selectedTickettypeadv: string = 'Select Ticket Type';
  selectedTickettypeadv_ao: string = 'Select Ticket Type';
  selectedTickettypeadv_io: string = 'Select Ticket Type';
  selectedTickettypeadv_others: string = 'Select Ticket Type';
  selectedapplication: string = 'Select Application';
  selectedapplication_ao: string = '';
  selectedapplication_io: string = '';
  selectedapplication_others: string = '';
  searchcheck_ao: boolean=true;
  searchcheck_io: boolean=true;
  searchcheck_others: boolean=true;
  TopKeyWordData_AO: any;
  TopKeyWordData_IO: any;
  TopKeyWordData_Others: any;
  ChartData_AO: any;
  ChartData_IO: any;
  ChartData_Others: any;
  required_ao: boolean = true;
  required_io: boolean = false;
  required_others: boolean = true;
  public topKeyWordStd: TopKeyWordsFilter;
  public topKeyWord_AO: TopKeyWordsFilter;
  public topKeyWord_AO_Pre: TopKeyWordsFilter;
  public topKeyWord_IO: TopKeyWordsFilter;
  public topKeyWord_IO_Pre: TopKeyWordsFilter;
  public topKeyWord_Others: TopKeyWordsFilter;
  public topKeyWord_Others_Pre: TopKeyWordsFilter;
  DoTicketPull: boolean = true;
  BatchId: string = "";
  MaxEndDate: any;
  MinStartDate: any;
  isGetTopWordsEnabled: boolean = true;
  isSkipTopWords: boolean = true;
  proposalId: number;
  WordCloudFilterOptions: string[] = [];
  containerwordCloud_AO: string = "containerwordCloud_AO";
  containerwordCloud_IO: string = "containerwordCloud_IO";
  containerwordCloud_Others: string = "containerwordCloud_Others";
  topKeywordsResponse_History_AO: any = [];
  topKeywordsResponse_History_IO: any = [];
  topKeywordsResponse_History_Others: any = [];
  public instance: boolean = true;
  skrequest: any;
  userType: any;
  prev_language: string = '';
  EnableDQTStd: boolean=false;
  enableDQT: boolean;
  EnableDQTAO: boolean = false;
  EnableDQTIO: boolean = false;
  EnableDQTOth: boolean = false;
  EnableLemmaStd: boolean=false;
  EnableRestrictDDCreation: boolean = false;
  enableRestrictdd: boolean = false;
  enableLemma: boolean;
  enableRestrictDD : boolean;
  EnableLemmaAO: boolean = false;
  EnableLemmaIO: boolean = false;
  EnableLemmaOth: boolean = false;
  LemmaDisableStd: boolean=false;
  LemmaDisableStdIO: boolean=false;
  LemmaDisableAO: boolean=false;
  LemmaDisableIO: boolean=false;
  LemmaDisableOth: boolean=false;
  DQTenableStd: boolean = false;
  DQTenableAO: boolean = false;
  DQTenableIO: boolean = false;
  DQTenableOth: boolean = false;
  enableSearch: boolean = false;
  enableSearchAO: boolean = false;
  enableSearchIO: boolean = false;
  enableSearchOth: boolean = false;
  enableApply: boolean = false;  
  isClearAll:boolean = false;
  aoArr:any = [];
  ioArr:any = [];
  othArr:any = [];
  lstClassifiedByTemp: any = [];
  selectedStdLanguageAO: string = 'Select';
  selectedStdLanguageIO: string= 'Select';
  selectedStdLanguageOthers: string= 'Select';
  LanguageKeywordAO: { Language: string, Keywords: string[]}[] = [];
  LanguageKeywordIO: { Language: string, Keywords: string[]}[] = [];
  LanguageKeywordOthers: { Language: string, Keywords: string[]}[] = [];
  selectedLanguage = [];
  selectedStdLanguage = [];
  selectedLanguage_AO = [];
  selectedLanguage_IO = [];
  selectedLanguage_Other = [];
  dropdownSettings = {};    
  selectedLanguagestd = [];
  selectedLanguageAO:any = [];
  selectedLanguageIO:any = [];
  selectedLanguageOther:any = [];
  public templstClassifiedBy = [];
  public templstClassifiedBy_ao = [];
  public templstClassifiedBy_io = []
  public templstClassifiedBy_others = [];
  public lstIgnoreKeysTemp: any;
  public lstIgnoreKeys_othersTemp: any;
  public lstIgnoreKeys_ioTemp: any;
  
  indexOf = (arr, q) => arr.findIndex(item => q.toLowerCase() === item.toLowerCase());
  DSlevel: boolean;
  prevtab: string;
  enableticketpull: boolean = true;
  constructor(private scopeSelectorService: ScopeSelectorService, private router: Router, private route: ActivatedRoute, private iomService: IomService, public fb: FormBuilder, public SessionService: SessionService, private spinner: NgxSpinnerService, private appConfigService: AppConfigService) {
    /*  **** Loading left tree ************** */
    if (sessionStorage.getItem("Instance") == "PAM") {
      this.instance = false;
    }
    this.formScope = this.fb.group({
      dc: new FormArray([]),
    });
    this.envVar = this.appConfigService.getEnvironment();
    this.pamInstance();
    this.route.queryParams.subscribe(params => {
      //this.urlE2EUId = this.iomService.GetValueFromQueryParams(params, 'e2euid');
      this.urlE2EUId = this.SessionService.getE2EUId();
      if (this.envVar.instanceType == "FDS" && sessionStorage.getItem("Instance") != "PAM") {
        if (this.urlE2EUId != undefined && this.urlE2EUId != '') {
          this.SessionService.setSessionStorageItem('userType', '3');
          if(this.SessionService.getWSUId()!=null){
            this.SessionService.setDeliveryConstructUId(this.SessionService.getWSUId());
          }
          this.spinner.show();
          this.loadDeliveryConstructTree(this.SessionService.getE2EUId(), this.SessionService.getDeliveryConstructUId());
        }
        else {
          this.SessionService.setSessionStorageItem('userType', '1');
        }
        this.LoadStandardAdvance();
        this.SessionService.setSessionStorageItem("SelectedDDLanguage", '');
        this.SessionService.setSessionStorageItem("SelectedLanguage", '');
      }
      else if (sessionStorage.getItem("Instance") == "PAM")
      {
        this.LoadStandardAdvance();
        // if(this.lstClassifiedBy.length == 0)
        // {
        //   this.LoadStandaredAdvance();
        // }
        this.SessionService.setSessionStorageItem('userType', '1');
      }
    }, (error: any) => {
    });
    
    /*  **** /Loading left tree ************** */
  }
  resetDomain() {
    this.isLoadAoPill = false;
    this.isLoadIoPill = false;
    this.isLoadOtherPill = false;
  }

  formMinDate() {
    let year = +this.MasterDummyDataUpload.MinTicketDate.substring(0, 4);
    let month = this.MasterDummyDataUpload.MinTicketDate.substring(5, 7);
    let day = this.MasterDummyDataUpload.MinTicketDate.substring(8, 10);
    return { year: +year, month: +month, day: +day };
  }
  LoadStandardAdvance() {
    this.spinner.show();
    let DCs = [];
    var x;

    // if (this.envVar.instanceType == 'FDS')
    //   x = this.iomService.getPAMDataForTextAnalytics("", 0);
      //x = this.iomService.getFDSDataForTextAnalytics(this.SessionService.getE2EUId()); // fix later
     
    if (sessionStorage.getItem("Instance") == "PAM")
    {
      this.getSelectedDCs();
    }

    for (var i = 0; i < this.selectedDC.length; i++) {
      if (this.selectedDC[i] != 'undefined' && this.selectedDC[i] != 'null' && this.selectedDC[i] != null)
        DCs.push({
         // DeliveryConstructUId: this.selectedDC[i].deliveryConstructUId == 'null' ? null : this.selectedDC[i].deliveryConstructUId,
         DeliveryConstructUId: this.SessionService.getE2EUId(),
          Domain: (this.selectedDC[i].domain == 'undefined' || this.selectedDC[i].domain == 'null') ? '' : this.selectedDC[i].domain
        })// this.selectedDC[i].deliveryConstructUId
    }
    this.spinner.show();
    x = this.iomService.getPAMDataForTextAnalytics(DCs, true);

    x.subscribe(data => {
      // this.spinner.hide();
      if (data != null)
        this.isDataAvailable = true;
      this.MasterDummyDataUpload = data;
      if (this.isDataAvailable == true) {
        this.lstClassifiedBy = this.MasterDummyDataUpload.OpportunityBy;
        this.templstClassifiedBy = this.MasterDummyDataUpload.OpportunityBy;
        this.lstTicketType_ao = this.MasterDummyDataUpload.TicketTypes_AO;
        this.lstTicketType_io_all = this.MasterDummyDataUpload.TicketTypes_IO;
        if (this.envVar.Env == 'FDS_ManualUpload' && this.SessionService.getSessionStorageItem('userType') == '3'){
          this.lstTicketType_io = this.MasterDummyDataUpload.TicketTypes_IO.slice(0,2);
        }
        else{
        this.lstTicketType_io = this.lstTicketType_io_all.filter(x => (x.TicketType == "Servicenow-Incident" || x.TicketType == "Servicenow-Request"));
        }
        this.lstTicketType_others = this.MasterDummyDataUpload.TicketTypes_Others;
        // const formControls_TicketType = this.lstTicketType_ao.map(control => new FormControl(false)); //check
        // const formControls_TicketType_IO = this.lstTicketType_io.map(control => new FormControl(false));
        // const formControls_TicketType_Others = this.lstTicketType_others.map(control => new FormControl(false));
        
        this.lstClassifiedByTemp = this.MasterDummyDataUpload.OpportunityBy.filter(item => item.name !== 'TicketType');
        this.lstClassifiedByTemp.push({'name' : 'Short Description'});
        this.lstClassifiedByTemp.push({'name' : 'Resolution Description'});
        this.lstClassifiedByTemp.push({'name' : 'Long Description'});
       
        this.lstClassifiedBy = this.lstClassifiedByTemp;

        this.textConfigFormStandard = this.fb.group({
          deepdiveConfig: new FormControl('', Validators.required),
          ticketType: new FormControl('Select', Validators.required),
          ticketTypeMulti: new FormControl('Select', Validators.required),
          startDate: new FormControl(''),
          endDate: new FormControl(''),
          selectAllTicket: new FormControl(false),
          ClassifiedBased: new FormControl('Select', Validators.required),
          // ClassifiedBased: new FormControl(''),
          Language: new FormControl('Select', Validators.required)
        })

      }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log('Error Occured !');
      });
      if (sessionStorage.getItem("Instance") == "PAM") {
        this.spinner.hide();
      }
  }
  LoadAdvance() {
    this.spinner.show();
    let DCs = [];
    this.prev_language = 'English';
    this.SessionService.setSessionStorageItem("selectAllAO", "false");
    this.SessionService.setSessionStorageItem("selectAllIO", "false");
    this.SessionService.setSessionStorageItem("selectAllOth", "false");
    this.aoArr = [];
    this.ioArr = [];
    this.othArr = [];
    this.selectedLanguage_AO = [];
    this.selectedLanguage_IO = [];
    this.selectedLanguage_Other = [];
    this.selectedLanguageAO = [];
    this.selectedLanguageIO = [];
    this.selectedLanguageOther = [];
    this.selectedStdLanguageAO = 'Select';
    this.selectedStdLanguageIO = 'Select';
    this.selectedStdLanguageOthers = 'Select';   

    for (var i = 0; i < this.selectedDC.length; i++) {
      if (this.selectedDC[i] != 'undefined' && this.selectedDC[i] != 'null' && this.selectedDC[i] != null)
        DCs.push({
         // DeliveryConstructUId: this.selectedDC[i].deliveryConstructUId == 'null' ? null : this.selectedDC[i].deliveryConstructUId,
         DeliveryConstructUId: this.SessionService.getE2EUId(),
          Domain: (this.selectedDC[i].domain == 'undefined' || this.selectedDC[i].domain == 'null') ? '' : this.selectedDC[i].domain
        })// this.selectedDC[i].deliveryConstructUId
    }
    // DCs = DCs.replace(/,\s*$/, "");
    var DyServiceVar;

    if (this.envVar.instanceType == 'FDS')      
      DyServiceVar = this.iomService.getPAMDataForTextAnalytics(DCs, true);
      //DyServiceVar = this.iomService.getFDSDataForTextAnalytics(this.SessionService.getE2EUId()); // fixed later
    else
      DyServiceVar = this.iomService.getPAMDataForTextAnalytics(DCs, true);
    DyServiceVar.subscribe(data => {
      this.spinner.hide();
      this.lstIgnoreKeys = [];
      this.lstIgnoreKeys_others = [];
      this.lstIgnoreKeys_io = [];
      this.lstIgnoreKeysTemp = [];
      this.lstIgnoreKeys_othersTemp = [];
      this.lstIgnoreKeys_ioTemp = [];
      this.resetDomain();
      if (data != null)
        this.isDataAvailable = true;
      this.MasterDummyDataUpload = data;
      // this.MasterDummyDataUpload = data;
      this.lstDomainOption = [];
      this.isLoadAoPill = false;
      this.isLoadIoPill = false;
      this.isLoadOtherPill = false;
      this.enableAo = false;
      this.enableIo = false;
      this.enableOthers = false;
      if (sessionStorage.getItem("Instance") == "PAM") {
        this.DCAO = true;
        this.DCIO = true;
        this.DCOthers = true;

      }
      if (this.isDataAvailable == true) {
        this.WordCloudFilterOptions = this.MasterDummyDataUpload.WordCloudFilterOptions?.split(',');
        if (this.MasterDummyDataUpload.MappingData_AO.data != null && this.MasterDummyDataUpload.MappingData_AO.data.length > 0 && this.DCAO == true) {
          this.lstDomainOption.push({ name: 'AO', selected: true, disabled: false, msg: '', id: 1 });
          this.isLoadAoPill = true;
          this.enableAo = true;
          this.required_ao = true;
        }
        else
          this.lstDomainOption.push({ name: 'AO', selected: false, disabled: true, msg: 'There are no tickets mapped for this domain', id: 1 });
        if (this.MasterDummyDataUpload.MappingData_IO.data != null && this.MasterDummyDataUpload.MappingData_IO.data.length > 0 && this.DCIO == true) {
          this.lstDomainOption.push({ name: 'IO', selected: true, disabled: false, msg: '', id: 2 });
          if (this.enableAo == false) {
            this.isLoadIoPill = true;
            this.isAddkeywordsEnabled_IO = false;
            this.ChartData_IO = null;
            this.required_io = false;
          }
          this.enableIo = true;
          this.required_io = false;
        }
        else
          this.lstDomainOption.push({ name: 'IO', selected: false, disabled: true, msg: 'There are no tickets mapped for this domain', id: 2 });
        if (this.MasterDummyDataUpload.MappingData_Others.data != null && this.MasterDummyDataUpload.MappingData_Others.data.length > 0 && this.DCOthers == true) {
          this.lstDomainOption.push({ name: 'Others', selected: true, disabled: false, msg: '', id: 3 });
          if (this.enableAo == false && this.enableIo == false)
          this.isLoadOtherPill = true;
          this.required_others = true;
        this.enableOthers = true;
        }
        else
          this.lstDomainOption.push({ name: 'Others', selected: false, disabled: true, msg: 'There are no tickets mapped for this domain', id: 3 });

        // this.lstDomainOption = [
        //   { name: 'AO', selected: true, id: 1 },
        //   { name: 'IO', selected: true, id: 2 },
        //   { name: 'Others', selected: false, id: 3 },
        // ]
        // this.mindate = {
        //   year: +this.MasterDummyDataUpload.MinTicketDate.substring(0, 4),
        //   month: +this.MasterDummyDataUpload.MinTicketDate.substring(5, 7),
        //   day: +this.MasterDummyDataUpload.MinTicketDate.substring(8, 10)
        // };
        // this.maxdate = {
        //   year: +this.MasterDummyDataUpload.MaxTicketDate.substring(0, 4),
        //   month: +this.MasterDummyDataUpload.MaxTicketDate.substring(5, 7),
        //   day: +this.MasterDummyDataUpload.MaxTicketDate.substring(8, 10)
        // };
        let AOdata = [];
        let IOdata = [];
        let Othdata = [];
        this.MasterDummyDataUpload.MappingData_AO.data.forEach((x, i) => {
          AOdata.push({
            name: x.name,
            displayName: x.displayName,
            indexNo: i,
            isChecked: false
          })
        })
        this.MasterDummyDataUpload.MappingData_AO = { FilterName: this.envVar.ClientConfiguration.MappingFilterName,  data: AOdata };
        this.MasterDummyDataUpload.MappingData_IO.data.forEach((x, i) => {
          IOdata.push({
            name: x.name,
            displayName: x.displayName,
            indexNo: i,
            isChecked: false
          })
        })
        this.MasterDummyDataUpload.MappingData_IO = { FilterName: this.envVar.ClientConfiguration.MappingFilterName,  data: IOdata };
        this.MasterDummyDataUpload.MappingData_Others.data.forEach((x, i) => {
          Othdata.push({
            name: x.name,
            displayName: x.displayName,
            indexNo: i,
            isChecked: false
          })
        })
        this.MasterDummyDataUpload.MappingData_Others = { FilterName: this.envVar.ClientConfiguration.MappingFilterName, data: Othdata };
        
        this.lstMappingConfig_ao = this.MasterDummyDataUpload.MappingData_AO;
        this.lstMappingConfig_io = this.MasterDummyDataUpload.MappingData_IO;
        this.lstMappingConfig_others = this.MasterDummyDataUpload.MappingData_Others;

        this.lstTicketType_ao = this.MasterDummyDataUpload.TicketTypes_AO;
        this.lstTicketType_io_all = this.MasterDummyDataUpload.TicketTypes_IO;
        if (this.envVar.Env == 'FDS_ManualUpload' && this.SessionService.getSessionStorageItem('userType') == '3'){
          this.lstTicketType_io = this.MasterDummyDataUpload.TicketTypes_IO.slice(0,2);
        }
        else{
        this.lstTicketType_io = this.lstTicketType_io_all.filter(x => (x.TicketType == "Servicenow-Incident" || x.TicketType == "Servicenow-Request"));
        }
        this.lstTicketType_others = this.MasterDummyDataUpload.TicketTypes_Others;

        this.lstCategorisedBy_ao = this.MasterDummyDataUpload.OpportunityBy.filter(item => item.name !== 'Resolution Description' && item.name !== 'Short Description' && item.name !== 'Long Description');        
        this.lstCategorisedBy_io = this.MasterDummyDataUpload.OpportunityBy.filter(item => item.name !== 'Resolution Description' && item.name !== 'Short Description' && item.name !== 'Long Description');        
        this.lstCategorisedBy_others = this.MasterDummyDataUpload.OpportunityBy.filter(item => item.name !== 'Resolution Description' && item.name !== 'Short Description' && item.name !== 'Long Description');        
        
        this.lstClassifiedByTemp = this.MasterDummyDataUpload.OpportunityBy.filter(item => item.name !== 'TicketType');
        this.lstClassifiedByTemp.push({'name' : 'Short Description'});
        this.lstClassifiedByTemp.push({'name' : 'Resolution Description'});
        this.lstClassifiedByTemp.push({'name' : 'Long Description'});

        this.templstClassifiedBy = this.lstClassifiedByTemp;
        this.templstClassifiedBy_ao = this.lstClassifiedByTemp;
        this.templstClassifiedBy_io = this.lstClassifiedByTemp;
        this.templstClassifiedBy_others = this.lstClassifiedByTemp;

        this.lstClassifiedBy = this.lstClassifiedByTemp;
        this.lstClassifiedBy_ao = this.lstClassifiedByTemp;
        this.lstClassifiedBy_io = this.lstClassifiedByTemp;
        this.lstClassifiedBy_others = this.lstClassifiedByTemp;

        this.lstapplication_ao = this.MasterDummyDataUpload.AMApplications_AO;
        this.lstapplication_io = this.MasterDummyDataUpload.AMApplications_IO;
        this.lstapplication_others = this.MasterDummyDataUpload.AMApplications_Others;
        // create dynamic checkbox controls domain mapping config
        if (this.lstMappingConfig_ao.data == null) {
          this.lstMappingConfig_ao.data = [];
          this.lstMappingConfig_ao.FilterName = '';
        }
        if (this.lstMappingConfig_io.data == null) {
          this.lstMappingConfig_io.data = [];
          this.lstMappingConfig_io.FilterName = '';
        }
        if (this.lstMappingConfig_others.data == null) {
          this.lstMappingConfig_others.data = [];
          this.lstMappingConfig_others.FilterName = '';
        }
        //assing value to place holder of support group
        this.selectedSupportGroup_AO = 'Select ' + this.envVar.ClientConfiguration.MappingFilterName;
        //this.selectedSupportGroup_AO = 'Select ' + this.lstMappingConfig_ao.FilterName;
        this.selectedSupportGroup_IO = 'Select ' + this.lstMappingConfig_io.FilterName;
        this.selectedSupportGroup_Others = 'Select ' + this.lstMappingConfig_others.FilterName;

        const formControls_ao = this.lstMappingConfig_ao['data'].map(control => new FormControl(false));
        const formControls_io = this.lstMappingConfig_io['data'].map(control => new FormControl(false));
        const formControls_others = this.lstMappingConfig_others['data'].map(control => new FormControl(false));
        const formCntrols_domain = this.lstDomainOption.map(control => new FormControl({ value: control.selected, disabled: control.disabled }));
        //const formCntrols_domain = this.lstDomainOption.map(control => new FormControl(control.selected));
        // this.textConfigFormStandard = this.fb.group({
        //   deepdiveConfig: new FormControl('', Validators.required),
        //   ticketType: new FormControl('Select', Validators.required),
        //   startDate: new FormControl(''),
        //   endDate: new FormControl(''),
        // })
        const formControls_application = this.lstapplication_ao.map(control => new FormControl(false));
        const formControls_application_AO = this.lstapplication_ao.map(control => new FormControl(false)); //check
        const formControls_application_IO = this.lstapplication_io.map(control => new FormControl(false));
        const formControls_application_Others = this.lstapplication_others.map(control => new FormControl(false));
        const formControls_TicketType = this.lstTicketType_ao.map(control => new FormControl(false));
        const formControls_TicketType_AO = this.lstTicketType_ao.map(control => new FormControl(false)); //check
        const formControls_TicketType_IO = this.lstTicketType_io.map(control => new FormControl(false));
        const formControls_TicketType_Others = this.lstTicketType_others.map(control => new FormControl(false));
        this.selectedAlgoOption_io = false,

          this.textConfigForm = this.fb.group({
            AOGroup: this.fb.group({
              mappingConfigs: new FormArray(formControls_ao),
              deepdiveConfig: new FormControl('', Validators.required),
              algorithmModel: new FormControl('2', Validators.required),
              noOfCluster: new FormControl(""),
              exitCriteria: new FormControl(""),
              classifiedBasedOn: new FormControl('Short Description'),
              categorisedBy: new FormControl(''),
              ddlMultiselect: new MultiSelectComponent(this.selectedLanguageAO),
              ClassifiedBased: new FormControl('Select', Validators.required),
              ignorekeywordLanguage: new FormControl('Select', Validators.required),
              ticketType: new FormControl('Select', Validators.required),
              ticketTypeMulti: new FormArray(formControls_TicketType_AO),
              appType: new FormControl('Select'),
              applicationType: new FormArray(formControls_application_AO),
              startDate: new FormControl(''),
              endDate: new FormControl(''),
              ignorekeyword: new FormControl(''),
              searchText: new FormControl(''),
              selectAllConfig: new FormControl(false),
              selectAllSearchConfig: new FormControl(false),
              selectAllApplication: new FormControl(false),
              selectAllTicketadv: new FormControl(false),
              topWordOption: new FormControl(this.WordCloudFilterOptions[2]),
              Language: new FormControl('Select', Validators.required)
            }),
            IOGroup: this.fb.group({
              mappingConfigs: new FormArray(formControls_io),
              deepdiveConfig: new FormControl('', Validators.required),
              algorithmModel: new FormControl('2', Validators.required),
              noOfCluster: new FormControl(""),
              exitCriteria: new FormControl(""),
              classifiedBasedOn: new FormControl('Short Description'),
              ignorekeywordLanguage: new FormControl('Select', Validators.required),
              categorisedBy: new FormControl(''),
              ddlMultiselect: new MultiSelectComponent(this.selectedLanguageIO),
              ClassifiedBased: new FormControl('Select', Validators.required),
              ticketType: new FormControl('Select', Validators.required),
              ticketTypeMulti: new FormArray(formControls_TicketType_IO),
              appType: new FormControl('Select'),
              applicationType: new FormArray(formControls_application_IO),
              startDate: new FormControl(''),
              endDate: new FormControl(''),
              ignorekeyword: new FormControl(''),
              searchText: new FormControl(''),
              selectAllConfig: new FormControl(false),
              selectAllSearchConfig: new FormControl(false),
              selectAllApplication: new FormControl(false),
              selectAllTicketadv: new FormControl(false),
              topWordOption: new FormControl(this.WordCloudFilterOptions[2]),
              Language: new FormControl('Select', Validators.required)
            }),
            OthersGroup: this.fb.group({
              mappingConfigs: new FormArray(formControls_others),
              deepdiveConfig: new FormControl('', Validators.required),
              algorithmModel: new FormControl('2', Validators.required),
              noOfCluster: new FormControl(""),
              exitCriteria: new FormControl(""),
              classifiedBasedOn: new FormControl('Short Description'),
              ignorekeywordLanguage: new FormControl('Select', Validators.required),
              categorisedBy: new FormControl(''),
              ddlMultiselect: new MultiSelectComponent(this.selectedLanguageOther),
              ClassifiedBased: new FormControl('Select', Validators.required),
              ticketType: new FormControl('Select', Validators.required),
              ticketTypeMulti: new FormArray(formControls_TicketType_Others),
              appType: new FormControl('Select'),
              applicationType: new FormArray(formControls_application_Others),
              startDate: new FormControl(''),
              endDate: new FormControl(''),
              ignorekeyword: new FormControl(''),
              searchText: new FormControl(''),
              selectAllConfig: new FormControl(false),
              selectAllSearchConfig: new FormControl(false),
              selectAllApplication: new FormControl(false),
              selectAllTicketadv: new FormControl(false),
              topWordOption: new FormControl(this.WordCloudFilterOptions[2]),
              Language: new FormControl('Select', Validators.required)
            }),
            domainOption: new FormArray(formCntrols_domain)

          });
      }
      this.lstFilterMappingConfig_ao = this.lstMappingConfig_ao.data;
      this.lstFilterMappingConfig_io = this.lstMappingConfig_io.data;
      this.lstFilterMappingConfig_others = this.lstMappingConfig_others.data;
      if (this.MasterDummyDataUpload.MappingData_IO.data.length > 0){
        this.GetLanguageCheck_IO('IO');
      }
      $("#advancedModal").modal("show"); // open advance option
      this.isAvanced = true;
      this.enableSearch = false;
      this.spinner.hide();
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log('Error Occured !');
      });
  }
  LoadStandard() {
    this.spinner.show();
    let DCs = [];
   
    var DyServiceVar;
    if (this.envVar.instanceType == 'FDS')      
      DyServiceVar = this.iomService.getPAMDataForTextAnalytics(DCs, true);
      //DyServiceVar = this.iomService.getFDSDataForTextAnalytics(this.SessionService.getE2EUId()); // fixed later
    else
      DyServiceVar = this.iomService.getPAMDataForTextAnalytics(DCs, true);
    DyServiceVar.subscribe(data => {
      this.spinner.hide();
      this.resetDomain();
      if (data != null)
        var Masterdata = data;
        this.lstClassifiedByTemp = Masterdata.OpportunityBy.filter(item => item.name !== 'TicketType');
        this.lstClassifiedByTemp.push({'name' : 'Short Description'});
        this.lstClassifiedByTemp.push({'name' : 'Resolution Description'});        
        this.lstClassifiedByTemp.push({'name' : 'Long Description'});  
        this.lstClassifiedBy = this.lstClassifiedByTemp;
        this.lstClassifiedBy_ao = this.lstClassifiedByTemp;
        this.lstClassifiedBy_io = this.lstClassifiedByTemp;
        this.lstClassifiedBy_others = this.lstClassifiedByTemp;
        
        this.templstClassifiedBy = this.lstClassifiedByTemp;
        this.templstClassifiedBy_ao = this.lstClassifiedByTemp;
        this.templstClassifiedBy_io = this.lstClassifiedByTemp;
        this.templstClassifiedBy_others = this.lstClassifiedByTemp;        
      this.spinner.hide();
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log('Error Occured !');
      });
  }

  ngOnInit(): void {
    this.CMSCheck == false;
    this.dropdownSettings = {
      // singleSelection: false,
      idField: 'DimensionValue',
      textField: 'DimensionValue',
      itemsShowLimit: 2,
      // limitSelection : 2,
      allowSearchFilter: false
    };
    this.getLanguageList();
    this.textConfigForm.get('AOGroup').get('ignorekeywordLanguage').setValue('Select');
    this.textConfigForm.get('IOGroup').get('ignorekeywordLanguage').setValue('Select');
    this.textConfigForm.get('OthersGroup').get('ignorekeywordLanguage').setValue('Select');
    $(document).ready(function () {
      $(window).scroll(function () {
        if ($(this).scrollTop() >= $('.myw-topbar').offset().top)
          $('body').addClass('myw-sticky');
        else
          $('body').removeClass('myw-sticky');
      }).trigger('scroll');

      //TABS
      $('.domain-check input').click(function (e) {
        $('.iom-tab-content').show();
        if (e.currentTarget.checked) {
          $('#' + e.currentTarget.name + '-tab').addClass('show-an');
          if (!$('.nav-item.nav-link.show-an.active').length) {
            $('#' + e.currentTarget.name + '-tab').addClass('active');
            $('#' + e.currentTarget.name).addClass('active');
          }
        }
        else {
          $('#' + e.currentTarget.name + '-tab').removeClass('show-an');
          $('#' + e.currentTarget.name + '-tab').removeClass('active');
          $('#' + e.currentTarget.name).removeClass('active');
          if (!$('.nav-item.nav-link.show-an.active').length && $('.nav-item.nav-link.show-an').length) {
            $('.nav-item.nav-link.show-an').first().addClass('active');
            $('#' + $('.nav-item.nav-link.show-an')[0].id.replace('-tab', '')).addClass('active');
          }
          if (!$('.tab-pane.active').length) {
            $('.iom-tab-content').hide();
          }
        }
      });
      $('.iom-tabs a').click(function (e) {
        $('.iom-tab-content .tab-pane').removeClass('active');
        $('#' + e.currentTarget.id.replace('-tab', '')).addClass('active');
      });

      // $('.iom-sidebar-nav.iom-sidebar-nav-toggle').click(function () {
      //   alert('hi');
      //   $(this).toggleClass('open').next('.iom-sidebar-nav-cont').toggleClass('show');
      // });

      var sdtop = $('.iom-side-menu-section').offset().top;
      $(window).scroll(function () {
        if ($(this).scrollTop() >= sdtop)
          $('.iom-side-menu-section').addClass('iom-menu-sticky-deep');
        else
          $('.iom-side-menu-section').removeClass('iom-menu-sticky-deep');
      }).trigger('scroll');



      $('#SelectAll').click(function () {
        $('.chkbox').prop('checked', $(this).prop('checked'));
      });
      $(document).on("change", ".chkbox", function () {
        //$('.chkbox').change(function () {
        if (!$(this).prop('checked')) {
          $('#SelectAll').prop('checked', false);
        }
      });
      // $('#SelectAll').click(function () {
      //   $('.chkbox').prop('checked', $(this).prop('checked'));
      // });
      // $('.chkbox').change(function () {
      //   if (!$(this).prop('checked')) {
      //     $('#SelectAll').prop('checked', false);
      //   }
      // });



    });
    $('.supportgrp-optnext').click(function () {
      $(".select-domain").hide();
      $(".validate-section").hide();
      $(".suportgrp-section").show();
    });
    this.SessionService.setSessionStorageItem("selectAllAO", "false");
    this.SessionService.setSessionStorageItem("selectAllIO", "false");
    this.SessionService.setSessionStorageItem("selectAllOth", "false");
    $(document).ready(function () {
      $('.iom-dropdown .dropdown-menu .new').click(function (e) {
        e.stopPropagation();
      });
    });
  }




  checkUncheckChild(event) {
    $(event.currentTarget).closest("a").siblings(".iom-sidebar-nav-cont").find(':checkbox').each(function () {
      if(this.id == 'CMS')
        $(this).prop('checked', false);
     else if (this.id != 'DS')
        $(this).prop('checked', $(event.currentTarget).is(':checked'));
      else
        $(this).prop('checked', false);
    });
    if (event.currentTarget.id == 'DS' || event.currentTarget.id == 'CMS') {
      $(event.currentTarget).prop('checked', false);
      //$(event.currentTarget).click(false);
    }
    //get selected dc count
    if(this.textConfigFormStandard.value.Language != 'Chinese')
    {
    this.LemmaDisableStd = false;
    }
    this. LemmaDisableStdIO = false;
    if (this.envVar.Env == 'FDS_ManualUpload' && this.SessionService.getSessionStorageItem('userType') == '3'){

    this.selectedDC = [];
    var DcsArr = [];
    var allVals = [];
    $.each($('input[name=\'dc\']:checked'), function () {
    allVals.push($(this).val());
    });
    if(allVals.length==1)
    {
    DcsArr = allVals[0].split('~^~');
    if(DcsArr[6] == 'IO')
    {
      if(this.textConfigFormStandard.value.Language == 'Select' || this.textConfigFormStandard.value.Language == 'English' || this.textConfigFormStandard.value.Language == 'Chinese')
      {
      this.LemmaDisableStd = true;
      this. LemmaDisableStdIO = true;
      }
    }
    }
    }
    }

  dispalyChaild(event) {
    $(event.currentTarget).toggleClass('open').toggleClass('active').next('.iom-sidebar-nav-cont').toggleClass('show');
  }

  searchAssignment(tab: string) {
    let text;
    let sao = '';
    switch (tab) {
      case 'ao':
        this.lstFilterMappingConfig_ao = null;
        text = this.textConfigForm.value.AOGroup.searchText != undefined && this.textConfigForm.value.AOGroup.searchText != '' ? this.textConfigForm.value.AOGroup.searchText.toString().toLowerCase().trim() : '';
        if (text == '') {
          this.lstFilterMappingConfig_ao = this.lstMappingConfig_ao.data;
          this.searchcheck_ao = true;
          setTimeout(() => {
            this.lstFilterMappingConfig_ao.forEach((x, i) => {
              if (x.isChecked) {
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
                $('#aoSearch_' + x.indexNo).prop('checked', true);
              }
              else{
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = false;
                $('#aoSearch_' + x.indexNo).prop('checked', false);
              }
            });
            this.selectedSearchAllAoId.nativeElement.checked = false;
            this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
            if (this.lstFilterMappingConfig_ao != null) {
              this.lstFilterMappingConfig_ao.forEach((x, i) => {
                if (x.isChecked)
                  sao += sao == '' ? x.name : ',' + x.name;
              });
            }
            if ((sao !== '' && sao !== undefined) && this.textConfigForm.value.AOGroup.mappingConfigs.length === sao.split(',').filter(value => value !== 'All').length) {
              this.selectedAllAoId.nativeElement.checked = true;                 
              this.textConfigForm.value.AOGroup.selectAllConfig = true;
              this.SessionService.setSessionStorageItem("selectAllAO","true");          
          }
          else{
            this.selectedAllAoId.nativeElement.checked = false;                 
            this.textConfigForm.value.AOGroup.selectAllConfig = false;
            this.SessionService.setSessionStorageItem("selectAllAO","false");   
          }
          }, 100); 
        }
        else {
          this.lstFilterMappingConfig_aoSearch = null;
          $('#selectAllSearchAO').prop('checked', false);
          this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
          text != '' ? this.lstFilterMappingConfig_ao = this.lstMappingConfig_ao.data.filter(row => {
            return (row.name != undefined ? row.name.toLowerCase().trim().includes(text) : false);
          }) :
            this.lstFilterMappingConfig_ao == undefined ? this.lstFilterMappingConfig_ao = null : '';
            if(this.lstFilterMappingConfig_ao.length != 0){
              this.lstFilterMappingConfig_aoSearch = this.lstFilterMappingConfig_ao;
            }          
          this.searchcheck_ao = false;
        }
        break;
      case 'io':
        this.lstFilterMappingConfig_io = null;
        text = this.textConfigForm.value.IOGroup.searchText != undefined && this.textConfigForm.value.IOGroup.searchText != '' ? this.textConfigForm.value.IOGroup.searchText.toString().toLowerCase().trim() : '';
        if (text == '') {
          this.lstFilterMappingConfig_io = this.lstMappingConfig_io.data;
          this.searchcheck_io = true;
          setTimeout(() => {
            this.lstFilterMappingConfig_io.forEach((x, i) => {
              if (x.isChecked) {
                this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
                $('#ioSearch_' + x.indexNo).prop('checked', true);
              }
              else {
                this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = false;
                $('#ioSearch_' + x.indexNo).prop('checked', false);
              }
            });
            this.selectedSearchAllIoId.nativeElement.checked = false;
            this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;

            if (this.lstFilterMappingConfig_io != null) {
              this.lstFilterMappingConfig_io.forEach((x, i) => {
                if (x.isChecked)
                  sao += sao == '' ? x.name : ',' + x.name;
              });
            }
            if ((sao !== '' && sao !== undefined) && this.textConfigForm.value.IOGroup.mappingConfigs.length === sao.split(',').filter(value => value !== 'All').length) {
              this.selectedAllIoId.nativeElement.checked = true;                 
              this.textConfigForm.value.IOGroup.selectAllConfig = true;
              this.SessionService.setSessionStorageItem("selectAllIO","true");          
          }
          else{
            this.selectedAllIoId.nativeElement.checked = false;                 
            this.textConfigForm.value.IOGroup.selectAllConfig = false;
            this.SessionService.setSessionStorageItem("selectAllIO","false");   
          }
          }, 100); 
        }
        else {
          this.lstFilterMappingConfig_ioSearch = null;
          $('#selectAllSearchIO').prop('checked', false);
          this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;
          text != '' ? this.lstFilterMappingConfig_io = this.lstMappingConfig_io.data.filter(row => {
            return (row.name != undefined ? row.name.toLowerCase().trim().includes(text) : false);
          }) :
            this.lstFilterMappingConfig_io == undefined ? this.lstFilterMappingConfig_io = null : '';
            if(this.lstFilterMappingConfig_io.length != 0){
              this.lstFilterMappingConfig_ioSearch = this.lstFilterMappingConfig_io;
            }           
          this.searchcheck_io = false;
        }
        break;
      case 'others':
        this.lstFilterMappingConfig_others = null;
        text = this.textConfigForm.value.OthersGroup.searchText != undefined && this.textConfigForm.value.OthersGroup.searchText != '' ? this.textConfigForm.value.OthersGroup.searchText.toString().toLowerCase().trim() : '';
        if (text == '') {
          this.lstFilterMappingConfig_others = this.lstMappingConfig_others.data;
          this.searchcheck_others = true;
          setTimeout(() => {
            this.lstFilterMappingConfig_others.forEach((x, i) => {
              if (x.isChecked) {
                this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
                $('#othSearch_' + x.indexNo).prop('checked', true);
              }
              else {
                this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = false;
                $('#othSearch_' + x.indexNo).prop('checked', false);
              }
            });
            this.selectedSearchAllOthersId.nativeElement.checked = false;
            this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;

            if (this.lstFilterMappingConfig_others != null) {
              this.lstFilterMappingConfig_others.forEach((x, i) => {
                if (x.isChecked)
                  sao += sao == '' ? x.name : ',' + x.name;
              });
            }
            if ((sao !== '' && sao !== undefined) && this.textConfigForm.value.OthersGroup.mappingConfigs.length === sao.split(',').filter(value => value !== 'All').length) {
              this.selectedAllOthersId.nativeElement.checked = true;                 
              this.textConfigForm.value.OthersGroup.selectAllConfig = true;
              this.SessionService.setSessionStorageItem("selectAllOth","true");          
          }
          else{
            this.selectedAllOthersId.nativeElement.checked = false;                 
            this.textConfigForm.value.OthersGroup.selectAllConfig = false;
            this.SessionService.setSessionStorageItem("selectAllOth","false");   
          }
          }, 100); 
        }
        else {
          this.lstFilterMappingConfig_othSearch = null;
          $('#selectAllSearchOth').prop('checked', false);
          this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;
          text != '' ? this.lstFilterMappingConfig_others = this.lstMappingConfig_others.data.filter(row => {
            return (row.name != undefined ? row.name.toLowerCase().trim().includes(text) : false);
          }) :
            this.lstFilterMappingConfig_others == undefined ? this.lstFilterMappingConfig_others = null : '';
            if(this.lstFilterMappingConfig_others.length != 0){
              this.lstFilterMappingConfig_othSearch = this.lstFilterMappingConfig_others;
            }            
          this.searchcheck_others = false;
        }
        break;
      default:
        break;
    }
  }

  algorithmChange(flag: boolean, tab: string, categorizedByFlag: boolean, isAddkeywordsEnabled: boolean, isResolutionDescEnabled: boolean, algoModel: string) {
    switch (tab) {
      case 'ao':
        this.selectedAlgoOption = flag;
        this.categorizedByFlag_ao = categorizedByFlag;
        this.isAddkeywordsEnabled_AO = isAddkeywordsEnabled;
        this.isResolutionDescEnabled_AO = isResolutionDescEnabled;
        if(this.selectedLanguage_AO.join('|').toString().includes('Chinese'))
        {
          this.LemmaDisableAO = true;
          this.EnableLemmaAO = false;
        }
        else{
          this.LemmaDisableAO = false;
        }
        if (flag && !categorizedByFlag) {
          this.required_ao = true;
          this.textConfigForm.get('AOGroup').get('categorisedBy').setValue('');
        }
        else if (categorizedByFlag) {
          this.required_ao = false;
          this.textConfigForm.get('AOGroup').get('noOfCluster').setValue('');
          this.textConfigForm.get('AOGroup').get('exitCriteria').setValue('');
        }
        else {
          this.required_ao = false;
          this.textConfigForm.get('AOGroup').get('noOfCluster').setValue('');
          this.textConfigForm.get('AOGroup').get('exitCriteria').setValue('');
          this.textConfigForm.get('AOGroup').get('categorisedBy').setValue('');
        }
        // this.getStopKeyWords('AO', "AO");
        // if (flag == false)
        //   this.textConfigForm.value.AOGroup.algorithmModel.setValue("User Defined");
        // else
        //   this.textConfigForm.value.AOGroup.algorithmModel.setValue("System Generated: (K-means)");
        break;
      case 'io':
        this.LemmaDisableIO = false;
        this.EnableLemmaIO = false;
        this.selectedAlgoOption_io = flag;
        this.categorizedByFlag_io = categorizedByFlag;
        this.isAddkeywordsEnabled_IO = isAddkeywordsEnabled;      
        //this.textConfigForm.value.IOGroup.algorithmModel.setValue('3');
        if (algoModel == "regression" || this.selectedLanguage_IO.join('|').toString().includes('Chinese')) {
          this.LemmaDisableIO = true;          
          this.isResolutionDescEnabled_IO = false;          
        }
        else {         
          if (this.selectedLanguage_IO.join('|').toString().includes('English')) {
            this.LemmaDisableIO = false;
          }                    
          this.isResolutionDescEnabled_IO = this.isResolutionDescEnabled_IO_old;
        }  
        this.textConfigForm.value.IOGroup.noOfCluster = '';
        if (flag && !categorizedByFlag) {
          this.required_io = true;
          this.textConfigForm.get('IOGroup').get('categorisedBy').setValue('');
        }
        else if (categorizedByFlag) {
          this.required_io = false;
          this.textConfigForm.get('IOGroup').get('noOfCluster').setValue('');
          this.textConfigForm.get('IOGroup').get('exitCriteria').setValue('');
        }
        else {
          this.required_io = false;
          this.textConfigForm.get('IOGroup').get('noOfCluster').setValue('');
          this.textConfigForm.get('IOGroup').get('exitCriteria').setValue('');
          this.textConfigForm.get('IOGroup').get('categorisedBy').setValue('');
        }
        if (this.isAddkeywordsEnabled_IO) {
          this.textConfigForm.get('IOGroup').get('classifiedBasedOn').setValue('Short Description');
        }
        this.getStopKeyWords('IO', "IO", false);
        // if (flag == false)
        //   this.textConfigForm.value.AOGroup.algorithmModel.setValue("User Defined");
        // else
        //   this.textConfigForm.value.AOGroup.algorithmModel.setValue("System Generated: (K-means)");
        break;
      case 'others':
        this.selectedAlgoOption_others = flag;
        this.categorizedByFlag_others = categorizedByFlag;
        this.isAddkeywordsEnabled_Others = isAddkeywordsEnabled;
        this.isResolutionDescEnabled_Others = isResolutionDescEnabled;
        if(this.selectedLanguage_Other.join('|').toString().includes('Chinese'))
        {
          this.LemmaDisableOth = true;
          this.EnableLemmaOth = false;
        }
        else{
          this.LemmaDisableOth = false;
        }
        if (flag && !categorizedByFlag) {
          this.required_others = true;
          this.textConfigForm.get('OthersGroup').get('categorisedBy').setValue('');
        }
        else if (categorizedByFlag) {
          this.required_others = false;
          this.textConfigForm.get('OthersGroup').get('noOfCluster').setValue('');
          this.textConfigForm.get('OthersGroup').get('exitCriteria').setValue('');
        }
        else {
          this.required_others = false;
          this.textConfigForm.get('OthersGroup').get('noOfCluster').setValue('');
          this.textConfigForm.get('OthersGroup').get('exitCriteria').setValue('');
          this.textConfigForm.get('OthersGroup').get('categorisedBy').setValue('');
        }
        //this.getStopKeyWords('Others', "Others");
        // if (flag == false)
        //   this.textConfigForm.value.OthersGroup.algorithmModel.setValue("User Defined");
        // else
        //   this.textConfigForm.value.OthersGroup.algorithmModel.setValue("System Generated: (K-means)");
        break;
      default:
        break;
    }

  }

  // ClassifiedBasedONChange(value: string, domain: string) {
  //   this.classifiedBasedOn = value;
  //   switch (domain) {
  //     case 'AO':
  //       this.textConfigForm.get('AOGroup').get('classifiedBasedOn').setValue(this.classifiedBasedOn);
  //       break;
  //     case 'IO':
  //       this.textConfigForm.get('IOGroup').get('classifiedBasedOn').setValue(this.classifiedBasedOn);
  //       break;
  //     case 'Others':
  //       this.textConfigForm.get('OthersGroup').get('classifiedBasedOn').setValue(this.classifiedBasedOn);
  //       break;
  //     default:
  //       break;
  //   }
  //   if (this.isAddkeywordsEnabled_IO == false && domain == "IO") {
  //     return;
  //   }
  //   this.LoadWordCloudDataFromHistory(domain);
  // }

  loadAoPill() {
    this.isLoadAoPill = true;
    this.isLoadIoPill = false;
    this.isLoadOtherPill = false;
  }

  loadIoPill() {
    debugger;
    this.isLoadAoPill = false;
    this.isLoadIoPill = true;
    this.isLoadOtherPill = false;
    //this.textConfigForm.value.IOGroup.algorithmModel.setValue('3');
    if (this.textConfigForm.value.IOGroup.algorithmModel == "3") {
      this.isnoofcluster_IO = false;
      this.isAddkeywordsEnabled_IO = false;
      this.isResolutionDescEnabled_IO = false;
    }
    else if (this.textConfigForm.value.IOGroup.algorithmModel == "2") {
      this.selectedAlgoOption_io = true;
      this.required_io = true;
    }
  }

  loadOtherPill() {
    this.isLoadAoPill = false;
    this.isLoadIoPill = false;
    this.isLoadOtherPill = true;
  }

  // navigateToDeepDive() {
  //   this.router.navigate(['deepdive']);
  // }

  CreateDeepdiveStandard() {
    let that = this;
   
    if (this.ValidateFormStandard()) {
      if(this.isQualifiedDescEnabled !=null && !this.isQualifiedDescEnabled)
      {
        bootbox.alert('Selected value is not qualified for the categorized description.');
        return false;
      }
      this.standardAnalytics.UserOption = "1";
      this.standardAnalytics.deepdiveConfig = this.textConfigFormStandard.value.deepdiveConfig;
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
        this.standardAnalytics.ticketType = this.textConfigFormStandard.value.ticketType == 'Select' ? '0' : this.textConfigFormStandard.value.ticketType;
      else
        this.standardAnalytics.ticketType = this.textConfigFormStandard.value.ticketTypeMulti
          .map((checked, index) => checked ? this.lstTicketType_ao[index].ServiceType : null)
          .filter(value => value !== null).join('~^~');
      this.standardAnalytics.startDate = this.textConfigFormStandard.value.startDate != '' ? JSON.stringify(this.textConfigFormStandard.value.startDate) : '';
      this.standardAnalytics.endDate = this.textConfigFormStandard.value.endDate != '' ? JSON.stringify(this.textConfigFormStandard.value.endDate) : '';
      this.standardAnalytics.ClassifiedBased = this.textConfigFormStandard.value.ClassifiedBased != '' ? this.textConfigFormStandard.value.ClassifiedBased : '';
      this.enableDQT = this.EnableDQTStd;
      this.enableLemma = this.EnableLemmaStd;
      this.spinner.show();
      var DyServiceVar;
      if (this.envVar.instanceType == 'FDS' && sessionStorage.getItem("Instance") != "PAM") {
        sessionStorage.setItem('selectedProposalId', '0'); //FDS
        DyServiceVar = this.iomService.CreateDeepdiveFDSStandardATR<any>(this.standardAnalytics.UserOption, this.standardAnalytics.deepdiveConfig, this.standardAnalytics.startDate, this.standardAnalytics.endDate, this.standardAnalytics.ticketType, this.selectedDC, this.SessionService.getE2EUId(), sessionStorage.getItem('selectedProposalId'), this.SessionService.getUserName(),this.standardAnalytics.ClassifiedBased ,"applicationName", this.envVar.EnableLanguage ?  this.selectedStdLanguage.join('|') : 'English' ,this.enableDQT,this.enableLemma);
      }
      else if(sessionStorage.getItem("Instance") == "PAM") 
      {
        sessionStorage.setItem('selectedProposalId', '0');//SAAS
        DyServiceVar = this.iomService.CreateDeepdivePAMStandardATR<any>(this.standardAnalytics.UserOption, this.standardAnalytics.deepdiveConfig, this.standardAnalytics.startDate, this.standardAnalytics.endDate, this.standardAnalytics.ticketType, this.selectedDC, this.SessionService.getE2EUId(), sessionStorage.getItem('selectedProposalId'), this.SessionService.getUserName(),this.standardAnalytics.ClassifiedBased , "applicationName", this.envVar.EnableLanguage ?  this.selectedStdLanguage.join('|') : 'English',this.enableDQT,this.enableLemma,this.enableRestrictdd);
      }
      else {
        sessionStorage.setItem('selectedProposalId', '0');
        DyServiceVar = this.iomService.CreateDeepdivePAMStandard<any>(this.standardAnalytics.UserOption, this.standardAnalytics.deepdiveConfig, this.standardAnalytics.startDate, this.standardAnalytics.endDate, this.standardAnalytics.ticketType, this.selectedDC, this.SessionService.getE2EUId(), sessionStorage.getItem('selectedProposalId'), this.SessionService.getUserName(), "applicationName");
      }
      DyServiceVar.subscribe(data => {
        this.spinner.hide();
        if (data) {
          if (data.Result.indexOf('success') > -1) {
            bootbox.alert(data.Result, function () {
              that.SessionService.removeSessionValue('CreateDDInput');
              that.router.navigate(['deepdive'], { queryParams: { 'E2EUId': that.SessionService.getE2EUId(), 'CMSUId': that.SessionService.getCMSUId(), 'WSUId': that.SessionService.getWSUId() } });
            });
          }
          else {
            bootbox.alert(data.Result);
          }
        }
      },
        (err: HttpErrorResponse) => {
          this.spinner.hide();
          console.log('Error Occured !');
          bootbox.alert('deepdive creation failed');
        });
    }
    if (this.BatchId != "") {
      this.clearStagingTicketsByCloudId(this.textConfigFormStandard.value.deepdiveConfig);
    }
  }

  ValidateFormStandard() {
    if (!this.getSelectedDCs()) {
      if(this.envVar.instanceType != 'FDS' && sessionStorage.getItem("Instance") != "PAM"){
        bootbox.alert('Please select delivery construct.');
        return false;
      }
     else{
      if(this.envVar.Env == 'FDS_ManualUpload'){
        bootbox.alert('Please select delivery construct.');
        return false;
      }
     }
    }
    if (this.textConfigFormStandard.value.deepdiveConfig == '' || this.textConfigFormStandard.value.deepdiveConfig == undefined) {
      bootbox.alert('Please enter deep dive name.');
      return false;
    }
    if (this.selectedStdLanguage.length == 0) {
      if(this.envVar.EnableLanguage == true){
        bootbox.alert('Please select Ticket Language.');
        return false;
      }      
    }
    if (this.textConfigFormStandard.value.ClassifiedBased == 'Select' || this.textConfigFormStandard.value.ClassifiedBased == undefined) {
        bootbox.alert('Please select Classified Based on');
        return false;
    }
    if (this.textConfigFormStandard.value.deepdiveConfig.length > 50) {
      bootbox.alert('Deep dive name size should not be greater than 50 characters!');
      return false;
    }
    if ((/^[a-zA-Z0-9_ -]*$/.test(this.textConfigFormStandard.value.deepdiveConfig)) == false) {
      bootbox.alert('Deep dive name have some invalid characters!');
      return false;
    }
    else if (this.textConfigFormStandard.value.deepdiveConfig.match(/^[0-9\s_ -]*$/)) {
      bootbox.alert('Deep dive name should be alphanumeric!');
      return false;
    }
    if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false) {
      if (this.textConfigFormStandard.value.ticketType == 'Select' || this.textConfigFormStandard.value.ticketType == undefined) {
        bootbox.alert('Please select TicketType.');
        return false;
      }
    }
    else {
      if (this.selectedTickettype == 'Select Ticket Type' || this.selectedTickettype == undefined) {
        bootbox.alert('Please select TicketType.')
        return false;
      }
    }
    if (this.textConfigFormStandard.value.startDate == '' || this.textConfigFormStandard.value.startDate == undefined) {
      bootbox.alert('Please select start date.');
      return false;
    }
    if (this.textConfigFormStandard.value.endDate == '' || this.textConfigFormStandard.value.endDate == undefined) {
      bootbox.alert('Please select end date.');
      return false;
    }
    if (this.textConfigFormStandard.value.startDate != '' && this.textConfigFormStandard.value.endDate != '') {
      let fd = this.textConfigFormStandard.value.startDate;
      let ed = this.textConfigFormStandard.value.endDate;
      const fdate = new Date(fd.year, fd.month - 1, fd.day);
      const edate = new Date(ed.year, ed.month - 1, ed.day);
      if (fdate > edate) {
        bootbox.alert('End Date should be greater than or equal to Start Date.');
        return false;
      }
    }   
    if (this.selectedDC != null) {
      for (var i = 0; i < this.selectedDC.length; i++) {
        if (this.envVar.instanceType == 'FDS') {
          if (this.selectedDC[i].deliveryConstructType == "CMS") {
            this.CMSCheck = true;
            bootbox.alert('Cannot create a deepdive with CMS as delivery');
            return false;
          }
        }
        else {
          if (this.selectedDC[i].deliveryConstructType == "DS") {
            this.CMSCheck = true;
            bootbox.alert('Cannot create a deepdive with DS as delivery');
            return false;
          }
        }
      }
    }
    return true;
  }

  ValidateFormStandardQualified() {
    if (!this.getSelectedDCs()) {
      if(this.envVar.instanceType != 'FDS' && sessionStorage.getItem("Instance") != "PAM"){
        bootbox.alert('Please select delivery construct.');
        return false;
      }
     else{
      if(this.envVar.Env == 'FDS_ManualUpload'){
        bootbox.alert('Please select delivery construct.');
        return false;
      }
     }
    }
    
    if (this.selectedStdLanguage.length == 0) {
      if(this.envVar.EnableLanguage == true){
        bootbox.alert('Please select Ticket Language.');
        return false;
      }      
    }
      if (this.textConfigFormStandard.value.ticketType == 'Select' || this.textConfigFormStandard.value.ticketType == undefined) {
        bootbox.alert('Please select TicketType.');
        return false;
      }
    if (this.textConfigFormStandard.value.startDate == '' || this.textConfigFormStandard.value.startDate == undefined) {
      bootbox.alert('Please select start date.');
      return false;
    }
    if (this.textConfigFormStandard.value.endDate == '' || this.textConfigFormStandard.value.endDate == undefined) {
      bootbox.alert('Please select end date.');
      return false;
    }
    if (this.textConfigFormStandard.value.startDate != '' && this.textConfigFormStandard.value.endDate != '') {
      let fd = this.textConfigFormStandard.value.startDate;
      let ed = this.textConfigFormStandard.value.endDate;
      const fdate = new Date(fd.year, fd.month - 1, fd.day);
      const edate = new Date(ed.year, ed.month - 1, ed.day);
      if (fdate > edate) {
        bootbox.alert('End Date should be greater than or equal to Start Date.');
        return false;
      }
    }   
    if (this.selectedDC != null) {
      for (var i = 0; i < this.selectedDC.length; i++) {
        if (this.envVar.instanceType == 'FDS') {
          if (this.selectedDC[i].deliveryConstructType == "CMS") {
            this.CMSCheck = true;
            bootbox.alert('Cannot create a deepdive with CMS as delivery');
            return false;
          }
        }
        else {
          if (this.selectedDC[i].deliveryConstructType == "DS") {
            this.CMSCheck = true;
            bootbox.alert('Cannot create a deepdive with DS as delivery');
            return false;
          }
        }
      }
    }
    return true;
  }


  CreateDeepdive() {
    let that = this;
    
    // capturing Form data
    this.UserOption = 2 // Advanced Flow
    if (this.ValidateForm()) {
    //   if(this.isQualifiedDescEnabled !=null && !this.isQualifiedDescEnabled)
    // {
    //   bootbox.alert('Selected value is not qualified for the categorized description.');
    //   return false;
    // }
      this.isValidFormSubmitted = false;
      if (this.isSkipTopWords)
        this.BatchId = '';
      // assigning domain option
      let domainOption = this.textConfigForm.getRawValue().domainOption
        .map((checked, index) => checked ? this.lstDomainOption[index].name : null)
        .filter(value => value !== null).join();
      // assigning AO Analytics configuration
      this.aoAnalytics.mappingConfigFilter = this.envVar.ClientConfiguration.MappingFilterName;
      this.aoAnalytics.mappingConfigData = this.textConfigForm.value.AOGroup.mappingConfigs
        .map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
        .filter(value => value !== null).join('~^~');
      this.aoAnalytics.deepdiveConfig = this.textConfigForm.value.AOGroup.deepdiveConfig;
      this.aoAnalytics.selectedAlgorithm = this.textConfigForm.value.AOGroup.algorithmModel;
      this.aoAnalytics.noOfCluster = this.textConfigForm.value.AOGroup.noOfCluster;
      this.aoAnalytics.exitCriteria = this.textConfigForm.value.AOGroup.exitCriteria;
      this.aoAnalytics.classifiedBasedON = this.textConfigForm.value.AOGroup.ClassifiedBased;      
      this.aoAnalytics.Language = this.envVar.EnableLanguage ?  this.selectedLanguage_AO.join('|') : 'English';
      this.aoAnalytics.enableDQT = this.EnableDQTAO;
      this.aoAnalytics.IsLemmaEnabled = this.EnableLemmaAO;
      this.aoAnalytics.categorisedBy = this.textConfigForm.value.AOGroup.categorisedBy == 'Select' ? null : this.textConfigForm.value.AOGroup.categorisedBy;
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
        this.aoAnalytics.ticketType = this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType;
      else
        this.aoAnalytics.ticketType = this.textConfigForm.value.AOGroup.ticketTypeMulti
          .map((checked, index) => checked ? this.lstTicketType_ao[index].ServiceType : null)
          .filter(value => value !== null).join('~^~');
      if (this.envVar.ClientConfiguration.isMultiSelectAppName == false)
        //this.aoAnalytics.applicationName = this.textConfigForm.value.AOGroup.appType == 'Select' ? '' : this.textConfigForm.value.AOGroup.appType;
        this.aoAnalytics.applicationName = 'All';
      else
        this.aoAnalytics.applicationName = this.textConfigForm.value.AOGroup.applicationType
          .map((checked, index) => checked ? this.lstapplication_ao[index].name : null)
          .filter(value => value !== null).join('~^~');
      this.aoAnalytics.startDate = this.textConfigForm.value.AOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.startDate) : '';
      this.aoAnalytics.endDate = this.textConfigForm.value.AOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.endDate) : '';
      this.aoAnalytics.ignoreKeywords = this.LanguageKeywordAO;
      var ticketType;
      var ApplicationName;
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
        ticketType = this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType;
      else
        ticketType = this.textConfigForm.value.AOGroup.ticketTypeMulti
          .map((checked, index) => checked ? this.lstTicketType_ao[index].ServiceType : null)
          .filter(value => value !== null).join('~^~');
      if (this.envVar.ClientConfiguration.isMultiSelectAppName == false)
        // ApplicationName = this.aoAnalytics.applicationName = this.textConfigForm.value.AOGroup.appType == 'Select' ? '' : this.textConfigForm.value.AOGroup.appType;
        ApplicationName = 'All';
      else
        ApplicationName = this.aoAnalytics.applicationName = this.textConfigForm.value.AOGroup.applicationType
          .map((checked, index) => checked ? this.lstapplication_ao[index].name : null)
          .filter(value => value !== null).join('~^~');

      this.topKeyWord_AO = new TopKeyWordsFilter(this.BatchId, this.isSkipTopWords,
        this.textConfigForm.value.AOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.startDate) : '',
        this.textConfigForm.value.AOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.endDate) : '',
        0,
        "AO",
        this.textConfigForm.value.AOGroup.ClassifiedBased,
        
        this.ticketType,
        this.textConfigForm.value.AOGroup.mappingConfigs
          .map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
          .filter(value => value !== null).join('~^~'),
        this.selectedDC, "SupportGroupName", "", ApplicationName,this.envVar.EnableLanguage ?  this.selectedLanguage_AO.join('|') : 'English');
      //this.textAnalytics.aoAnalytics = this.aoAnalytics;

      // assigning IO Analytics
      this.ioAnalytics.mappingConfigFilter = this.lstMappingConfig_io.FilterName;
      this.ioAnalytics.mappingConfigData = this.textConfigForm.value.IOGroup.mappingConfigs
        .map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
        .filter(value => value !== null).join('~^~');
      this.ioAnalytics.selectedAlgorithm = this.textConfigForm.value.IOGroup.algorithmModel;
      this.ioAnalytics.noOfCluster = this.textConfigForm.value.IOGroup.noOfCluster;
      this.ioAnalytics.exitCriteria = this.textConfigForm.value.IOGroup.exitCriteria;
      this.ioAnalytics.classifiedBasedON = this.textConfigForm.value.IOGroup.ClassifiedBased;
      this.ioAnalytics.deepdiveConfig = this.textConfigForm.value.IOGroup.deepdiveConfig;
      this.ioAnalytics.Language = this.envVar.EnableLanguage ?  this.selectedLanguage_IO.join('|') : 'English' ;
      this.ioAnalytics.enableDQT = this.EnableDQTIO;
      this.ioAnalytics.IsLemmaEnabled = this.EnableLemmaIO;
      this.ioAnalytics.categorisedBy = this.textConfigForm.value.IOGroup.categorisedBy == 'Select' ? null : this.textConfigForm.value.IOGroup.categorisedBy;
      //check // this.ioAnalytics.ticketType = this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType;
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
        this.ioAnalytics.ticketType = this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType;
      else
        this.ioAnalytics.ticketType = this.textConfigForm.value.IOGroup.ticketTypeMulti
          .map((checked, index) => checked ? this.lstTicketType_io[index].ServiceType : null)
          .filter(value => value !== null).join('~^~');
      if (this.envVar.ClientConfiguration.isMultiSelectAppName == false)
        //this.ioAnalytics.applicationName = this.textConfigForm.value.IOGroup.appType == 'Select' ? '' : this.textConfigForm.value.IOGroup.appType;
        this.ioAnalytics.applicationName = 'All';
      else
        this.ioAnalytics.applicationName = this.textConfigForm.value.IOGroup.applicationType
          .map((checked, index) => checked ? this.lstapplication_io[index].name : null)
          .filter(value => value !== null).join('~^~');
      this.ioAnalytics.startDate = this.textConfigForm.value.IOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.startDate) : '';
      this.ioAnalytics.endDate = this.textConfigForm.value.IOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.endDate) : '';
      this.ioAnalytics.ignoreKeywords = this.LanguageKeywordIO;
      var ticketType;
      var ApplicationName;
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
        ticketType = this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType;
      else
        ticketType = this.textConfigForm.value.IOGroup.ticketTypeMulti
          .map((checked, index) => checked ? this.lstTicketType_io[index].ServiceType : null)
          .filter(value => value !== null).join('~^~');
      if (this.envVar.ClientConfiguration.isMultiSelectAppName == false)
        // ApplicationName = this.ioAnalytics.applicationName = this.textConfigForm.value.IOGroup.appType == 'Select' ? '' : this.textConfigForm.value.IOGroup.appType;
        ApplicationName = 'All';
      else
        ApplicationName = this.ioAnalytics.applicationName = this.textConfigForm.value.IOGroup.applicationType
          .map((checked, index) => checked ? this.lstapplication_io[index].name : null)
          .filter(value => value !== null).join('~^~');
      this.topKeyWord_IO = new TopKeyWordsFilter(this.BatchId, this.isSkipTopWords,
        this.textConfigForm.value.IOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.startDate) : '',
        this.textConfigForm.value.IOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.endDate) : '',
        0,
        "IO",
        this.textConfigForm.value.IOGroup.ClassifiedBased,
        
        this.ticketType,
        this.textConfigForm.value.IOGroup.mappingConfigs
          .map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
          .filter(value => value !== null).join('~^~'),
        this.selectedDC, "SupportGroupName", "", ApplicationName,this.envVar.EnableLanguage ?  this.selectedLanguage_IO.join('|') : 'English');
      //this.ioAnalytics.selectedAlgorithm = 2;
      //this.textAnalytics.ioAnalytics = this.ioAnalytics;

      // assigning Others Analytics configuration
      this.othersAnalytics.mappingConfigFilter = this.lstMappingConfig_others.FilterName;
      this.othersAnalytics.mappingConfigData = this.textConfigForm.value.OthersGroup.mappingConfigs
        .map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
        .filter(value => value !== null).join('~^~');
      this.othersAnalytics.deepdiveConfig = this.textConfigForm.value.OthersGroup.deepdiveConfig;
      this.othersAnalytics.selectedAlgorithm = this.textConfigForm.value.OthersGroup.algorithmModel;
      this.othersAnalytics.noOfCluster = this.textConfigForm.value.OthersGroup.noOfCluster;
      this.othersAnalytics.exitCriteria = this.textConfigForm.value.OthersGroup.exitCriteria;
      this.othersAnalytics.classifiedBasedON = this.textConfigForm.value.OthersGroup.ClassifiedBased;
      this.othersAnalytics.Language = this.envVar.EnableLanguage ?  this.selectedLanguage_Other.join('|') : 'English';
      this.othersAnalytics.enableDQT = this.EnableDQTOth;
      this.othersAnalytics.IsLemmaEnabled = this.EnableLemmaOth;
      this.othersAnalytics.categorisedBy = this.textConfigForm.value.OthersGroup.categorisedBy == 'Select' ? null : this.textConfigForm.value.OthersGroup.categorisedBy;
      //check //this.othersAnalytics.ticketType = this.textConfigForm.value.OthersGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.ticketType;
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
        this.othersAnalytics.ticketType = this.textConfigForm.value.OthersGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.ticketType;
      else
        this.othersAnalytics.ticketType = this.textConfigForm.value.OthersGroup.ticketTypeMulti
          .map((checked, index) => checked ? this.lstTicketType_others[index].ServiceType : null)
          .filter(value => value !== null).join('~^~');
      if (this.envVar.ClientConfiguration.isMultiSelectAppName == false)
        //this.othersAnalytics.applicationName = this.textConfigForm.value.OthersGroup.appType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.appType;
        this.othersAnalytics.applicationName = 'All';
      else
        this.othersAnalytics.applicationName = this.textConfigForm.value.OthersGroup.applicationType
          .map((checked, index) => checked ? this.lstapplication_others[index].name : null)
          .filter(value => value !== null).join('~^~');
      this.othersAnalytics.startDate = this.textConfigForm.value.OthersGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.startDate) : '';
      this.othersAnalytics.endDate = this.textConfigForm.value.OthersGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.endDate) : '';
      this.othersAnalytics.ignoreKeywords = this.LanguageKeywordOthers;
      var ticketType;
      var ApplicationName;
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
        ticketType = this.textConfigForm.value.OthersGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.ticketType;
      else
        ticketType = this.textConfigForm.value.OthersGroup.ticketTypeMulti
          .map((checked, index) => checked ? this.lstTicketType_ao[index].ServiceType : null)
          .filter(value => value !== null).join('~^~');
      if (this.envVar.ClientConfiguration.isMultiSelectAppName == false)
        // ApplicationName = this.othersAnalytics.applicationName = this.textConfigForm.value.OthersGroup.appType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.appType;
        ApplicationName = 'All';
      else
        ApplicationName = this.othersAnalytics.applicationName = this.textConfigForm.value.OthersGroup.applicationType
          .map((checked, index) => checked ? this.lstapplication_others[index].name : null)
          .filter(value => value !== null).join('~^~');
      this.topKeyWord_Others = new TopKeyWordsFilter(this.BatchId, this.isSkipTopWords,
        this.textConfigForm.value.OthersGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.startDate) : '',
        this.textConfigForm.value.OthersGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.endDate) : '',
        0,
        "Others",
        this.textConfigForm.value.OthersGroup.ClassifiedBased,
        
        this.ticketType,
        this.textConfigForm.value.OthersGroup.mappingConfigs
          .map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
          .filter(value => value !== null).join('~^~'),
        this.selectedDC, "SupportGroupName", "", ApplicationName,this.envVar.EnableLanguage ?  this.selectedLanguage_Other.join('|') : 'English');
      //this.textAnalytics.othersAnalytics = this.othersAnalytics;
      // end Capturing Form data
      this.spinner.show();
      var DyServiceVar;
      if (this.envVar.instanceType == 'FDS' && sessionStorage.getItem("Instance") != "PAM") {
        sessionStorage.setItem('selectedProposalId', '0'); //FDS
        DyServiceVar = this.iomService.CreateDeepdiveFDSATR<any>(domainOption, this.UserOption, this.aoAnalytics, this.ioAnalytics, this.othersAnalytics, this.MasterDummyDataUpload.DisplayResolutionDesc, this.selectedDC, this.SessionService.getE2EUId(), sessionStorage.getItem('selectedProposalId'), this.SessionService.getUserName(), this.topKeyWord_AO, this.topKeyWord_IO, this.topKeyWord_Others, this.aoAnalytics.applicationName)
      }
      else if(sessionStorage.getItem("Instance") == "PAM")
      {
        sessionStorage.setItem('selectedProposalId', '0'); //SAAS
        DyServiceVar = this.iomService.CreateDeepdivePAMATR<any>(domainOption, this.UserOption, this.aoAnalytics, this.ioAnalytics, this.othersAnalytics, this.MasterDummyDataUpload.DisplayResolutionDesc, this.selectedDC, this.SessionService.getE2EUId(), sessionStorage.getItem('selectedProposalId'), this.SessionService.getUserName(), this.topKeyWord_AO, this.topKeyWord_IO, this.topKeyWord_Others, this.aoAnalytics.applicationName)
      }
      else {
        sessionStorage.setItem('selectedProposalId', '0');
        DyServiceVar = this.iomService.CreateDeepdivePAM<any>(domainOption, this.UserOption, this.aoAnalytics, this.ioAnalytics, this.othersAnalytics, this.MasterDummyDataUpload.DisplayResolutionDesc, this.selectedDC, this.SessionService.getE2EUId(), sessionStorage.getItem('selectedProposalId'), this.SessionService.getUserName(), this.topKeyWord_AO, this.topKeyWord_IO, this.topKeyWord_Others, this.aoAnalytics.applicationName)
      }
      DyServiceVar.subscribe(data => {
        if (data) {
          this.spinner.hide();
          if (data.Result.indexOf('success') > -1) {
            $("#btnAdvanceClose").click();
            bootbox.alert(data.Result, function () {
              that.SessionService.removeSessionValue('CreateDDInput');
              that.router.navigate(['deepdive'], { queryParams: { 'E2EUId': that.SessionService.getE2EUId(), 'CMSUId': that.SessionService.getCMSUId(), 'WSUId': that.SessionService.getWSUId() } });
            });
          }
          else {
            bootbox.alert(data.Result);
          }
        }
      },
        (err: HttpErrorResponse) => {
          this.spinner.hide();
          console.log('Error Occured !');
          bootbox.alert('deepdive creation failed');
        });
    }
  }

  DQTCheckStd(value:boolean){
    this.EnableDQTStd = value;
  }
  DQTCheckAdv(value:boolean,DQTdomain){
    if(DQTdomain=='AO'){
      this.EnableDQTAO = value;
    }
    else if(DQTdomain == 'IO'){
      this.EnableDQTIO = value;
    }
    else if(DQTdomain == 'Oth'){
      this.EnableDQTOth = value;
    }
  }
  LemmaCheckStd(value:boolean){
    this.EnableLemmaStd = value;
  }
  RestrictDDCheck(value: boolean) {
    this.enableRestrictdd = value;
  }
  LemmaCheckAdv(value:boolean,Lemmadomain){
    if(Lemmadomain=='AO'){
      this.EnableLemmaAO = value;
      this.GetLanguageCheck_AO('AO', false);
    }
    else if(Lemmadomain == 'IO'){
      this.EnableLemmaIO = value;
      // this.GetLanguageCheck_IO('IO');
      this.check_language = this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English';
      this.getStopwords('IO',this.userType,this.proposalId,this.ticketType,this.check_language);
    }
    else if(Lemmadomain == 'Oth'){
      this.EnableLemmaOth = value;
      this.GetLanguageCheck_Others('Others', false);
    }
  }
  ValidateForm() {
    let domain = this.textConfigForm.getRawValue().domainOption
      .map((checked, index) => checked ? this.lstDomainOption[index].name : null)
      .filter(value => value !== null).join();
    if (domain.includes('AO')) {
      this.loadValues('ao');
      let AO_config = this.textConfigForm.value.AOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
        .filter(value => value !== null).join();
      if (AO_config == '' || AO_config == undefined) {
        bootbox.alert('Please select ' + this.envVar.ClientConfiguration.MappingFilterName + ' Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.deepdiveConfig == '' || this.textConfigForm.value.AOGroup.deepdiveConfig == undefined) {
        bootbox.alert('Please enter deep dive name Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.deepdiveConfig.length > 50) {
        bootbox.alert('Deep dive name (Apps) size should not be greater than 50 characters!');
        return false;
      }
      if ((/^[a-zA-Z0-9_ -&]*$/.test(this.textConfigForm.value.AOGroup.deepdiveConfig)) == false) {
        bootbox.alert('Deep dive name (Apps) have some invalid characters!');
        return false;
      }
      else if (this.textConfigForm.value.AOGroup.deepdiveConfig.match(/^[0-9\s_ -]*$/)) {
        bootbox.alert('Deep dive name (Apps) should be alphanumeric!');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && this.textConfigForm.value.AOGroup.noOfCluster === "") {
        bootbox.alert("Please provide No of clusters (Apps)");
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && this.textConfigForm.value.AOGroup.exitCriteria === "") {
        bootbox.alert("Please provide Allowed maximum % of unclassified tickets (Apps)");
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && (/^[0-9]*$/.test(this.textConfigForm.value.AOGroup.noOfCluster.toString())) == false) {
        bootbox.alert("No of Cluster (Apps) must be a numeric!");
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && this.textConfigForm.value.AOGroup.noOfCluster > 99) {
        bootbox.alert('No of Cluster (Apps) should not be greater than 99!');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && this.textConfigForm.value.AOGroup.noOfCluster <= 0) {
        bootbox.alert('No of Cluster (Apps) should be greater than 0!');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && (/^[0-9]*$/.test(this.textConfigForm.value.AOGroup.exitCriteria.toString())) == false) {
        bootbox.alert("Allowed maximum % of unclassified tickets (Apps) must be a numeric!");
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && this.textConfigForm.value.AOGroup.exitCriteria <= 0) {
        bootbox.alert("Allowed maximum % of unclassified tickets (Apps) should be greater than 0!");
        return false;
      }
      if (this.textConfigForm.value.AOGroup.algorithmModel == 2 && this.textConfigForm.value.AOGroup.exitCriteria > 100) {
        bootbox.alert("Allowed maximum % of unclassified tickets (Apps) should not be greater than 100!");
        return false;
      }
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false) {
        if (this.textConfigForm.value.AOGroup.ticketType == 'Select' || this.textConfigForm.value.AOGroup.ticketType == undefined) {
          bootbox.alert('Please select TicketType for Apps.');
          return false;
        }
      }
      else {
        if (this.selectedTickettypeadv_ao == 'Select Ticket Type' || this.selectedTickettypeadv_ao == undefined) {
          bootbox.alert('Please select TicketType for Apps.')
          return false;
        }
      }
      // if (this.envVar.ClientConfiguration.isMultiSelectAppName == false) {
      //   if (this.textConfigForm.value.AOGroup.applicationName == 'Select' || this.textConfigForm.value.AOGroup.applicationName == undefined) {
      //     bootbox.alert('Please select Application Name for Apps.');
      //     return false;
      //   }
      // }
      // else {
      //   if (this.selectedapplication_ao == 'Select Application' || this.selectedapplication_ao == undefined) {
      //     bootbox.alert('Please select Application Name for Apps.')
      //     return false;
      //   }
      // }
      // if (this.selectedapplication == 'Select Application' || this.selectedapplication == undefined) {
      //     bootbox.alert('Please select Application for Apps.')
      //      return false;
      // } 
      if (this.selectedLanguage_AO.length == 0 || this.selectedLanguage_AO == undefined) {
        if(this.envVar.EnableLanguage == true){
          bootbox.alert('Please select Ticket Language for Apps.');
          return false;
        }       
      } 
      if (this.textConfigForm.value.AOGroup.ClassifiedBased == '' || this.textConfigForm.value.AOGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.AOGroup.ClassifiedBased == undefined) {
          bootbox.alert('Please select Classified Based on for Apps.');
          return false;
      } 
      if(this.isQualifiedDescEnabled_AO !=null && !this.isQualifiedDescEnabled_AO)
      {
      bootbox.alert('Selected value is not qualified for the categorized description for Apps.');
      return false;
      }
      if (this.textConfigForm.value.AOGroup.startDate == '' || this.textConfigForm.value.AOGroup.startDate == undefined) {
        bootbox.alert('Please select start date for Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.endDate == '' || this.textConfigForm.value.AOGroup.endDate == undefined) {
        bootbox.alert('Please select end date for Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.startDate != '' && this.textConfigForm.value.AOGroup.endDate != '') {
        let fd = this.textConfigForm.value.AOGroup.startDate;
        let ed = this.textConfigForm.value.AOGroup.endDate;
        const fdate = new Date(fd.year, fd.month - 1, fd.day);
        const edate = new Date(ed.year, ed.month - 1, ed.day);
        if (fdate > edate) {
          bootbox.alert('End Date should be greater than or equal to Start Date For Apps.');
          return false;
        }
      }
    }
    if (domain.includes('IO')) {
      this.loadValues('io');
      let IO_config = this.textConfigForm.value.IOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
        .filter(value => value !== null).join();
      if (IO_config == '' || IO_config == undefined) {
        bootbox.alert('Please select ' + this.lstMappingConfig_io.FilterName + ' Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.deepdiveConfig == '' || this.textConfigForm.value.IOGroup.deepdiveConfig == undefined) {
        bootbox.alert('Please enter deep dive name Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.deepdiveConfig.length > 50) {
        bootbox.alert('Deep dive name (Infra) size should not be greater than 50 characters!');
        return false;
      }
      if ((/^[a-zA-Z0-9_ -&]*$/.test(this.textConfigForm.value.IOGroup.deepdiveConfig)) == false) {
        bootbox.alert('Deep dive name (Infra) have some invalid characters!');
        return false;
      }
      else if (this.textConfigForm.value.IOGroup.deepdiveConfig.match(/^[0-9\s_ -]*$/)) {
        bootbox.alert('Deep dive name (Infra) should be alphanumeric!');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && this.textConfigForm.value.IOGroup.noOfCluster === "") {
        bootbox.alert("Please provide No of Clusters (Infra)");
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && this.textConfigForm.value.IOGroup.noOfCluster === "") {
        bootbox.alert("Please provide Allowed maximum % of unclassified tickets (Infra)");
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && (/^[0-9]*$/.test(this.textConfigForm.value.IOGroup.noOfCluster.toString())) == false) {
        bootbox.alert("No of Cluster (Infra) must be a numeric!");
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && this.textConfigForm.value.IOGroup.noOfCluster > 99) {
        bootbox.alert('No of Cluster (Infra) should not be greater than 99!');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && (/^[0-9]*$/.test(this.textConfigForm.value.IOGroup.exitCriteria.toString())) == false) {
        bootbox.alert("Allowed maximum % of unclassified tickets (Infra) must be a numeric!");
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && this.textConfigForm.value.IOGroup.exitCriteria <= 0) {
        bootbox.alert("Allowed maximum % of unclassified tickets (Infra) should be greater than 0!");
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && this.textConfigForm.value.IOGroup.exitCriteria > 100) {
        bootbox.alert("Allowed maximum % of unclassified tickets (Infra) should not be greater than 100!");
        return false;
      }
      if (this.textConfigForm.value.IOGroup.algorithmModel == 2 && this.textConfigForm.value.IOGroup.noOfCluster <= 0) {
        bootbox.alert('No of Cluster (Infra) should be greater than 0!');
        return false;
      }
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false) {
        if (this.textConfigForm.value.IOGroup.ticketType == 'Select' || this.textConfigForm.value.IOGroup.ticketType == undefined) {
          bootbox.alert('Please select TicketType for Infra.');
          return false;
        }
      }
      else {
        if (this.selectedTickettypeadv_io == 'Select Ticket Type' || this.selectedTickettypeadv_io == undefined) {
          bootbox.alert('Please select TicketType for Infra.')
          return false;
        }
      }
      // if (this.envVar.ClientConfiguration.isMultiSelectAppName == false) {
      //   if (this.textConfigForm.value.IOGroup.applicationName == 'Select' || this.textConfigForm.value.IOGroup.applicationName == undefined) {
      //     bootbox.alert('Please select Application Name for Infra.');
      //     return false;
      //   }
      // }
      // else {
      //   if (this.selectedapplication_io == 'Select Application' || this.selectedapplication_io == undefined) {
      //     bootbox.alert('Please select Application Name for Infra.')
      //     return false;
      //   }
      // }
      // if (this.textConfigForm.value.IOGroup.ticketType == 'Select' || this.textConfigForm.value.IOGroup.ticketType == undefined) {
      //   bootbox.alert('Please select TicketType for Infra.');
      //   return false;
      // }
      if (this.selectedLanguage_IO.length == 0 || this.selectedLanguage_IO == undefined) {
        if(this.envVar.EnableLanguage == true){
          bootbox.alert('Please select Ticket Language for Infra.');
          return false;
        }               
      }
      if (this.textConfigForm.value.IOGroup.ClassifiedBased == '' || this.textConfigForm.value.IOGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.IOGroup.ClassifiedBased == undefined) {
        bootbox.alert('Please select Classified Based on for Infra.');
        return false;
    } 
    if(this.isQualifiedDescEnabled_IO !=null && !this.isQualifiedDescEnabled_IO)
    {
      bootbox.alert('Selected value is not qualified for the categorized description for Infra.');
      return false;
    }
      if (this.textConfigForm.value.IOGroup.startDate == '' || this.textConfigForm.value.IOGroup.startDate == undefined) {
        bootbox.alert('Please select start date for Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.endDate == '' || this.textConfigForm.value.IOGroup.endDate == undefined) {
        bootbox.alert('Please select end date for Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.startDate != '' && this.textConfigForm.value.IOGroup.endDate != '') {
        let fd = this.textConfigForm.value.IOGroup.startDate;
        let ed = this.textConfigForm.value.IOGroup.endDate;
        const fdate = new Date(fd.year, fd.month - 1, fd.day);
        const edate = new Date(ed.year, ed.month - 1, ed.day);
        if (fdate > edate) {
          bootbox.alert('End Date should be greater than or equal to Start Date For Infra.');
          return false;
        }
      }
    }
    if (domain.includes('Others')) {
      this.loadValues('others');
      let Others_config = this.textConfigForm.value.OthersGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
        .filter(value => value !== null).join();
      if (Others_config == '' || Others_config == undefined) {
        bootbox.alert('Please select ' + this.lstMappingConfig_others.FilterName + ' Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.deepdiveConfig == '' || this.textConfigForm.value.OthersGroup.deepdiveConfig == undefined) {
        bootbox.alert('Please enter deep dive name Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.deepdiveConfig.length > 50) {
        bootbox.alert('Deep dive name (Others) size should not be greater than 50 characters!');
        return false;
      }
      if ((/^[a-zA-Z0-9_ -&]*$/.test(this.textConfigForm.value.OthersGroup.deepdiveConfig)) == false) {
        bootbox.alert('Deep dive name (Others) have some invalid characters!');
        return false;
      }
      else if (this.textConfigForm.value.OthersGroup.deepdiveConfig.match(/^[0-9\s_ -]*$/)) {
        bootbox.alert('Deep dive name (Others) should be alphanumeric!');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && this.textConfigForm.value.OthersGroup.noOfCluster === "") {
        bootbox.alert("Please provide No of Clusters (Others)");
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && this.textConfigForm.value.OthersGroup.noOfCluster === "") {
        bootbox.alert("Please provide Allowed maximum % of unclassified tickets (Others)");
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && (/^[0-9]*$/.test(this.textConfigForm.value.OthersGroup.noOfCluster.toString())) == false) {
        bootbox.alert("No of Cluster (Others) must be a numeric!");
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && this.textConfigForm.value.OthersGroup.noOfCluster > 99) {
        bootbox.alert('No of Cluster (Others) should not be greater than 99!');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && (/^[0-9]*$/.test(this.textConfigForm.value.OthersGroup.exitCriteria.toString())) == false) {
        bootbox.alert("Allowed maximum % of unclassified tickets (Others) must be a numeric!");
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && this.textConfigForm.value.OthersGroup.exitCriteria <= 0) {
        bootbox.alert("Allowed maximum % of unclassified tickets (Others) should be greater than 0!");
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && this.textConfigForm.value.OthersGroup.exitCriteria > 100) {
        bootbox.alert("Allowed maximum % of unclassified tickets (Others) should not be greater than 100!");
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.algorithmModel == 2 && this.textConfigForm.value.OthersGroup.noOfCluster <= 0) {
        bootbox.alert('No of Cluster (Others) should be greater than 0!');
        return false;
      }
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false) {
        if (this.textConfigForm.value.OthersGroup.ticketType == 'Select' || this.textConfigForm.value.OthersGroup.ticketType == undefined) {
          bootbox.alert('Please select TicketType for Others.');
          return false;
        }
      }
      else {
        if (this.selectedTickettypeadv_others == 'Select Ticket Type' || this.selectedTickettypeadv_others == undefined) {
          bootbox.alert('Please select TicketType for Others.')
          return false;
        }
      }
      // if (this.envVar.ClientConfiguration.isMultiSelectAppName == false) {
      //   if (this.textConfigForm.value.OthersGroup.applicationName == 'Select' || this.textConfigForm.value.OthersGroup.applicationName == undefined) {
      //     bootbox.alert('Please select Application Name for Others.');
      //     return false;
      //   }
      // }
      // else {
      //   if (this.selectedapplication_others == 'Select Application' || this.selectedapplication_others == undefined) {
      //     bootbox.alert('Please select Application Name for Others.')
      //     return false;
      //   }
      // }
      // if (this.textConfigForm.value.OthersGroup.ticketType == 'Select' || this.textConfigForm.value.OthersGroup.ticketType == undefined) {
      //   bootbox.alert('Please select TicketType for Others.');
      //   return false;
      // }
      if (this.selectedLanguage_Other.length == 0 || this.selectedLanguage_Other == undefined) {
        if(this.envVar.EnableLanguage == true){
          bootbox.alert('Please select Ticket Language for Others.');
          return false;
        }         
      }
      if (this.textConfigForm.value.OthersGroup.ClassifiedBased == '' || this.textConfigForm.value.OthersGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.OthersGroup.ClassifiedBased == undefined) {
        bootbox.alert('Please select Classified Based on for Others.');
        return false;
    } 
    if(this.isQualifiedDescEnabled_Others !=null && !this.isQualifiedDescEnabled_Others)
    {
    bootbox.alert('Selected value is not qualified for the categorized description for Others.');
    return false;
    }
      if (this.textConfigForm.value.OthersGroup.startDate == '' || this.textConfigForm.value.OthersGroup.startDate == undefined) {
        bootbox.alert('Please select start date for Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.endDate == '' || this.textConfigForm.value.OthersGroup.endDate == undefined) {
        bootbox.alert('Please select end date for Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.startDate != '' && this.textConfigForm.value.OthersGroup.endDate != '') {
        let fd = this.textConfigForm.value.OthersGroup.startDate;
        let ed = this.textConfigForm.value.OthersGroup.endDate;
        const fdate = new Date(fd.year, fd.month - 1, fd.day);
        const edate = new Date(ed.year, ed.month - 1, ed.day);
        if (fdate > edate) {
          bootbox.alert('End Date should be greater than or equal to Start Date For Others.');
          return false;
        }
      }

    }
    if (!this.getSelectedDCs()) {
      bootbox.alert('Please select DC.');
      return false;
    }
    return true;
  }

  ValidateFormForTopKeyWords(domain: string) {
    if (domain == 'AO') {
      this.loadValues('ao');
      let AO_config = this.textConfigForm.value.AOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
        .filter(value => value !== null).join();
      if (AO_config == '' || AO_config == undefined) {
        bootbox.alert('Please select ' + this.lstMappingConfig_ao.FilterName + ' Apps.');
        return false;
      }
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false) {
        if (this.textConfigForm.value.AOGroup.ticketType == 'Select' || this.textConfigForm.value.AOGroup.ticketType == undefined) {
          bootbox.alert('Please select TicketType for Apps.');
          return false;
        }
      }
      else {
        if (this.selectedTickettypeadv_ao == 'Select Ticket Type' || this.selectedTickettypeadv_ao == undefined) {
          bootbox.alert('Please select TicketType for Apps.')
          return false;
        }
      }
      // if (this.envVar.ClientConfiguration.isMultiSelectAppName == false) {
      //   if (this.textConfigForm.value.AOGroup.applicationName == 'Select' || this.textConfigForm.value.AOGroup.applicationName == undefined) {
      //     bootbox.alert('Please select Application Name for Apps.');
      //     return false;
      //   }
      // }
      // else {
      //   if (this.selectedapplication_ao == 'Select Application' || this.selectedapplication_ao == undefined) {
      //     bootbox.alert('Please select Application Name for Apps.')
      //     return false;
      //   }
      // }
      // if (this.textConfigForm.value.AOGroup.ticketType == 'Select Ticket Type' || this.textConfigForm.value.AOGroup.ticketType == undefined) {
      //   bootbox.alert('Please select TicketType for Apps.');
      //   return false;
      // }
      if (this.textConfigForm.value.AOGroup.startDate == '' || this.textConfigForm.value.AOGroup.startDate == undefined) {
        bootbox.alert('Please select start date for Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.endDate == '' || this.textConfigForm.value.AOGroup.endDate == undefined) {
        bootbox.alert('Please select end date for Apps.');
        return false;
      }
      if (this.selectedLanguage_AO.length == 0 || this.selectedLanguage_AO == undefined) {
        if(this.envVar.EnableLanguage == true){
          bootbox.alert('Please select Ticket Language for Apps.');
          return false;
        }       
      }
      if (this.textConfigForm.value.AOGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.AOGroup.ClassifiedBased == undefined|| this.textConfigForm.value.AOGroup.ClassifiedBased == '') {
        bootbox.alert('Please select Classified Based on for Apps.');
        return false;
      }
      if (this.textConfigForm.value.AOGroup.startDate != '' && this.textConfigForm.value.AOGroup.endDate != '') {
        let fd = this.textConfigForm.value.AOGroup.startDate;
        let ed = this.textConfigForm.value.AOGroup.endDate;
        const fdate = new Date(fd.year, fd.month - 1, fd.day);
        const edate = new Date(ed.year, ed.month - 1, ed.day);
        if (fdate > edate) {
          bootbox.alert('End Date should be greater than or equal to Start Date For Apps.');
          return false;
        }
      }
    }
    else if (domain == 'IO') {
      this.loadValues('io');
      let IO_config = this.textConfigForm.value.IOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
        .filter(value => value !== null).join();
      if (IO_config == '' || IO_config == undefined) {
        bootbox.alert('Please select ' + this.lstMappingConfig_io.FilterName + ' Infra.');
        return false;
      }
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false) {
        if (this.textConfigForm.value.IOGroup.ticketType == 'Select' || this.textConfigForm.value.IOGroup.ticketType == undefined) {
          bootbox.alert('Please select TicketType for Infra.');
          return false;
        }
      }
      else {
        if (this.selectedTickettypeadv_io == 'Select Ticket Type' || this.selectedTickettypeadv_io == undefined) {
          bootbox.alert('Please select TicketType for Infra.')
          return false;
        }
      }
      
      // if (this.envVar.ClientConfiguration.isMultiSelectAppName == false) {
      //   if (this.textConfigForm.value.IOGroup.applicationName == 'Select' || this.textConfigForm.value.IOGroup.applicationName == undefined) {
      //     bootbox.alert('Please select Application Name for Infra.');
      //     return false;
      //   }
      // }
      // else {
      //   if (this.selectedapplication_io == 'Select Application' || this.selectedapplication_io == undefined) {
      //     bootbox.alert('Please select Application Name for Infra.')
      //     return false;
      //   }
      // }
      // if (this.textConfigForm.value.IOGroup.ticketType == 'Select' || this.textConfigForm.value.IOGroup.ticketType == undefined) {
      //   bootbox.alert('Please select TicketType for Infra.');
      //   return false;
      // }
      if (this.textConfigForm.value.IOGroup.startDate == '' || this.textConfigForm.value.IOGroup.startDate == undefined) {
        bootbox.alert('Please select start date for Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.endDate == '' || this.textConfigForm.value.IOGroup.endDate == undefined) {
        bootbox.alert('Please select end date for Infra.');
        return false;
      }
      if (this.selectedLanguage_IO.length == 0 || this.selectedLanguage_IO == undefined) {
        if(this.envVar.EnableLanguage == true){
          bootbox.alert('Please select Ticket Language for Infra.');
          return false;
        }        
      }
      if (this.textConfigForm.value.IOGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.IOGroup.ClassifiedBased == undefined|| this.textConfigForm.value.IOGroup.ClassifiedBased == '') {
        bootbox.alert('Please select Classified Based on for Infra.');
        return false;
      }
      if (this.textConfigForm.value.IOGroup.startDate != '' && this.textConfigForm.value.IOGroup.endDate != '') {
        let fd = this.textConfigForm.value.IOGroup.startDate;
        let ed = this.textConfigForm.value.IOGroup.endDate;
        const fdate = new Date(fd.year, fd.month - 1, fd.day);
        const edate = new Date(ed.year, ed.month - 1, ed.day);
        if (fdate > edate) {
          bootbox.alert('End Date should be greater than or equal to Start Date For Infra.');
          return false;
        }
      }
    }
    else {
      this.loadValues('others');
      let Others_config = this.textConfigForm.value.OthersGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
        .filter(value => value !== null).join();
      if (Others_config == '' || Others_config == undefined) {
        bootbox.alert('Please select ' + this.lstMappingConfig_others.FilterName + ' Others.');
        return false;
      }
      if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false) {
        if (this.textConfigForm.value.OthersGroup.ticketType == 'Select' || this.textConfigForm.value.OthersGroup.ticketType == undefined) {
          bootbox.alert('Please select TicketType for Others.');
          return false;
        }
      }
      else {
        if (this.selectedTickettypeadv_others == 'Select Ticket Type' || this.selectedTickettypeadv_others == undefined) {
          bootbox.alert('Please select TicketType for Others.')
          return false;
        }
      }
      // if (this.envVar.ClientConfiguration.isMultiSelectAppName == false) {
      //   if (this.textConfigForm.value.OthersGroup.applicationName == 'Select' || this.textConfigForm.value.OthersGroup.applicationName == undefined) {
      //     bootbox.alert('Please select Application Name for Others.');
      //     return false;
      //   }
      // }
      // else {
      //   if (this.selectedapplication_others == 'Select Application' || this.selectedapplication_others == undefined) {
      //     bootbox.alert('Please select Application Name for Others.')
      //     return false;
      //   }
      // }
      // if (this.textConfigForm.value.OthersGroup.ticketType == 'Select' || this.textConfigForm.value.OthersGroup.ticketType == undefined) {
      //   bootbox.alert('Please select TicketType for Others.');
      //   return false;
      // }
      if (this.textConfigForm.value.OthersGroup.startDate == '' || this.textConfigForm.value.OthersGroup.startDate == undefined) {
        bootbox.alert('Please select start date for Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.endDate == '' || this.textConfigForm.value.OthersGroup.endDate == undefined) {
        bootbox.alert('Please select end date for Others.');
        return false;
      }
      if (this.selectedLanguage_Other.length == 0 || this.selectedLanguage_Other == undefined) {
        if(this.envVar.EnableLanguage == true){
          bootbox.alert('Please select Ticket Language for Others.');
        return false;
        }          
      }
      if (this.textConfigForm.value.OthersGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.OthersGroup.ClassifiedBased == undefined|| this.textConfigForm.value.OthersGroup.ClassifiedBased == '') {
        bootbox.alert('Please select Classified Based on for Others.');
        return false;
      }
      if (this.textConfigForm.value.OthersGroup.startDate != '' && this.textConfigForm.value.OthersGroup.endDate != '') {
        let fd = this.textConfigForm.value.OthersGroup.startDate;
        let ed = this.textConfigForm.value.OthersGroup.endDate;
        const fdate = new Date(fd.year, fd.month - 1, fd.day);
        const edate = new Date(ed.year, ed.month - 1, ed.day);
        if (fdate > edate) {
          bootbox.alert('End Date should be greater than or equal to Start Date For Others.');
          return false;
        }
      }

    }
    if (!this.getSelectedDCs()) {
      bootbox.alert('Please select delivery construct.');
      return false;
    }
    return true;
  }

  SelectDoamin() {
    this.resetDomain();
    const selectedDomain = this.textConfigForm.getRawValue().domainOption
      .map((checked, index) => checked ? this.lstDomainOption[index].name : null)
      .filter(value => value !== null);
      if(selectedDomain.includes('AO') || selectedDomain.includes('IO') || selectedDomain.includes('Others')){
        if (selectedDomain.includes('AO')) {
          this.enableAo = true;
          this.isLoadAoPill = true;
        }
        else {
          this.enableAo = false;
          this.isLoadIoPill = false;
          this.isLoadOtherPill = false;
        }
        if (selectedDomain.includes('IO')) {
          this.enableIo = true;
          if (this.isLoadAoPill == false && this.isLoadOtherPill == false) {
            this.isLoadIoPill = true;
            // this.isAddkeywordsEnabled_IO = false;
            // this.isnoofcluster_IO = false;
            // this.ChartData_IO = null;
          }
        }
        else {
          this.enableIo = false;
          //this.textConfigForm.get('IOGroup').get('algorithmModel').setValue('3');
          this.isAddkeywordsEnabled_IO = true;
          this.isnoofcluster_IO = true;
        }
    
        if (selectedDomain.includes('Others')) {
          this.enableOthers = true;
          if (this.isLoadAoPill == false && this.isLoadIoPill == false) {
            //this.textConfigForm.get('IOGroup').get('algorithmModel').setValue('3');
            this.isLoadOtherPill = true;
          }
        }
        else {
          this.enableOthers = false;
          //this.textConfigForm.get('IOGroup').get('algorithmModel').setValue('3');
        }
      }
   else{
    bootbox.alert("Please select atleast one domain to create Deepdives");
   }
  }
  addIgnoreKeyword(section) {
    if (section == "ao") {
      this.textConfigForm.value.AOGroup.ignorekeyword = this.textConfigForm.value.AOGroup.ignorekeyword.trim();
      if (this.IsEmpty(this.textConfigForm.value.AOGroup.ignorekeyword)) {
        bootbox.alert("keyword should not be empty");
      }
      else if(this.selectedStdLanguageAO == null || this.selectedStdLanguageAO == undefined || this.selectedStdLanguageAO == 'Select')
      {
        bootbox.alert("Please select language to add keyword");
      }
      // else if (/[0-9]/.test(this.textConfigForm.value.AOGroup.ignorekeyword)) {
      //   bootbox.alert("Keyword must have alphabets only")
      // }
      //else if (/^[a-zA-Z]*$/.test(this.textConfigForm.value.AOGroup.ignorekeyword) == false) {
      //  bootbox.alert("Keyword must be a single word and should contain alphabets only")
      //}
      else if (/[@!#$%^&*()\-+={}\[\]|\\/'";:`.,~№?<>]+/i.test(this.textConfigForm.value.AOGroup.ignorekeyword) == true || this.textConfigForm.value.AOGroup.ignorekeyword.indexOf(' ') >= 0) {
        bootbox.alert("Keyword must be a single word and should contain alphabets only")
      }      
      else if (this.indexOf(this.lstIgnoreKeys, this.textConfigForm.value.AOGroup.ignorekeyword.trim()+'('+this.selectedStdLanguageAO+')') >= 0) {
        bootbox.alert("\"" + this.textConfigForm.value.AOGroup.ignorekeyword + "\" KeyWord(s) already exists");
      }
      else {
        if(this.EnableLemmaAO)
        {
          if (this.selectedLanguage_AO.length == 0 || this.selectedLanguage_AO == undefined) {
            if(this.envVar.EnableLanguage == true){
              bootbox.alert('Please select Ticket Language for Apps.');
              return false;
            }       
          }
          else{ 
          let that = this;
          bootbox.dialog({
            message: 'The entered text will be added in the lemmatized form',
            buttons: {
              sucess: {
                label: 'Yes',
                className: 'btn-primary',
                callback: function () {
                    that.spinner.show();
                    var Language = that.envVar.EnableLanguage ? that.selectedStdLanguageAO : 'English'
                    that.iomService.GetLemmaKeywords('','','', that.textConfigForm.value.AOGroup.ignorekeyword,Language).subscribe((data: any) => {
                    that.spinner.hide();
                    
                      if (data.response.Result == "Success") {
                        var LemmaString = data.response.LemmaResponse.StopKeyWords_Lemma;
                        if (that.indexOf(that.lstIgnoreKeys, LemmaString) >= 0) {
                          bootbox.alert("\"" + LemmaString + "\" KeyWord(s) already exists");
                        }
                        else{
                         that.lstIgnoreKeys = [
                        ...that.lstIgnoreKeys,
                        LemmaString+'('+that.selectedStdLanguageAO+')'
                      ];
                      that.pushLanguageWiseKeyword(LemmaString,'ao');
                      }
                      that.enableBox_AO = true;
                      that.textConfigForm.controls.AOGroup.patchValue({ ignorekeyword: '' });
                      }
                      else {
                        that.textConfigForm.controls.AOGroup.patchValue({ ignorekeyword: '' });
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      }
                    },
                      (err: HttpErrorResponse) => {
                        that.spinner.hide();
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      });
                }
              },
              cancel: {
                label: 'No',
                className: 'btn-secondary',
                callback: function () {
                    that.lstIgnoreKeys = [
                      ...that.lstIgnoreKeys,
                      that.textConfigForm.value.AOGroup.ignorekeyword
                    ];
                    that.lstIgnoreKeysTemp = [
                      ...that.lstIgnoreKeysTemp,
                      that.textConfigForm.value.AOGroup.ignorekeyword
                    ];
                    that.enableBox_AO = true;
                    that.textConfigForm.controls.AOGroup.patchValue({ ignorekeyword: '' });
                }
              }
            },
            onEscape: function () {
              //on escape
          }
          });
        }
        }
        else{
        this.lstIgnoreKeys = [
          ...this.lstIgnoreKeys,
          this.textConfigForm.value.AOGroup.ignorekeyword+'('+this.selectedStdLanguageAO+')'
        ];
        this.lstIgnoreKeysTemp = [
          ...this.lstIgnoreKeysTemp,
          this.textConfigForm.value.AOGroup.ignorekeyword+'('+this.selectedStdLanguageAO+')'
        ];
        this.pushLanguageWiseKeyword(this.textConfigForm.value.AOGroup.ignorekeyword,'ao');       
        this.enableBox_AO = true;
        this.textConfigForm.controls.AOGroup.patchValue({ ignorekeyword: '' });
      }
      }
    }
    else if (section == "io") {
      this.textConfigForm.value.IOGroup.ignorekeyword = this.textConfigForm.value.IOGroup.ignorekeyword.trim();
      if (this.IsEmpty(this.textConfigForm.value.IOGroup.ignorekeyword)) {
        bootbox.alert("keyword should not be empty");
      }
      else if(this.selectedStdLanguageIO == null || this.selectedStdLanguageIO == undefined || this.selectedStdLanguageIO == 'Select')
      {
        bootbox.alert("Please select language to add keyword");
      }
      //else if (/^[a-zA-Z]*$/.test(this.textConfigForm.value.IOGroup.ignorekeyword) == false) {
      //  bootbox.alert("Keyword must be a single word and should contain alphabets only")
      //}
      else if (/[@!#$%^&*()\-+={}\[\]|\\/'";:`.,~№?<>]+/i.test(this.textConfigForm.value.IOGroup.ignorekeyword) == true || this.textConfigForm.value.IOGroup.ignorekeyword.indexOf(' ') >= 0) {
        bootbox.alert("Keyword must be a single word and should contain alphabets only")
      }
      else if (this.indexOf(this.lstIgnoreKeys_io, this.textConfigForm.value.IOGroup.ignorekeyword.trim()) >= 0) {
        bootbox.alert("\"" + this.textConfigForm.value.IOGroup.ignorekeyword + "\" KeyWord(s) already exists");
      }
      else {
        if(this.EnableLemmaIO)
        {
          if (this.selectedLanguage_IO.length == 0 || this.selectedLanguage_IO == undefined) {
            if(this.envVar.EnableLanguage == true){
              bootbox.alert('Please select Ticket Language for Infra.');
              return false;
            }       
          }
          else{ 
          let that = this;
          bootbox.dialog({
            message: 'The entered text will be added in the lemmatized form',
            buttons: {
              sucess: {
                label: 'Yes',
                className: 'btn-primary',
                callback: function () {
                    that.spinner.show();
                    var Language = that.envVar.EnableLanguage ? that.selectedStdLanguageIO : 'English'
                    that.iomService.GetLemmaKeywords('','','', that.textConfigForm.value.IOGroup.ignorekeyword,Language).subscribe((data: any) => {
                    that.spinner.hide();
                    
                      if (data.response.Result == "Success") {
                        var LemmaString = data.response.LemmaResponse.StopKeyWords_Lemma;
                        if (that.indexOf(that.lstIgnoreKeys, LemmaString) >= 0) {
                          bootbox.alert("\"" + LemmaString + "\" KeyWord(s) already exists");
                        }
                        else{
                        that.lstIgnoreKeys_io = [
                        ...that.lstIgnoreKeys_io,
                        LemmaString+'('+that.selectedStdLanguageIO+')'
                        ];
                        that.lstIgnoreKeys_ioTemp = [
                          ...that.lstIgnoreKeys_ioTemp,
                          LemmaString+'('+that.selectedStdLanguageIO+')'
                          ];
                        this.pushLanguageWiseKeyword(LemmaString,'io');
                      }
                      that.enableBox_IO = true;
                      that.textConfigForm.controls.IOGroup.patchValue({ ignorekeyword: '' });
                      }
                      else {
                        that.textConfigForm.controls.IOGroup.patchValue({ ignorekeyword: '' });
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      }
                    },
                      (err: HttpErrorResponse) => {
                        that.spinner.hide();
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      });
                }
              },
              cancel: {
                label: 'No',
                className: 'btn-secondary',
                callback: function () {
                    that.lstIgnoreKeys_io = [
                      ...that.lstIgnoreKeys_io,
                      that.textConfigForm.value.IOGroup.ignorekeyword
                    ];
                    that.lstIgnoreKeys_ioTemp = [
                      ...that.lstIgnoreKeys_ioTemp,
                      that.textConfigForm.value.IOGroup.ignorekeyword
                    ];
                    that.enableBox_IO = true;
                    that.textConfigForm.controls.IOGroup.patchValue({ ignorekeyword: '' });
                }
              }
            },
            onEscape: function () {
              //on escape
          }
          });
        }
        }
        else{
        this.lstIgnoreKeys_io = [
          ...this.lstIgnoreKeys_io,
          this.textConfigForm.value.IOGroup.ignorekeyword+'('+this.selectedStdLanguageIO+')'
        ];
        this.lstIgnoreKeys_ioTemp = [
          ...this.lstIgnoreKeys_ioTemp,
          this.textConfigForm.value.IOGroup.ignorekeyword+'('+this.selectedStdLanguageIO+')'
        ];
        this.pushLanguageWiseKeyword(this.textConfigForm.value.IOGroup.ignorekeyword,'io');
        this.enableBox_IO = true;
        this.textConfigForm.controls.IOGroup.patchValue({ ignorekeyword: '' });
      }
      }
    }
    else {
      this.textConfigForm.value.OthersGroup.ignorekeyword = this.textConfigForm.value.OthersGroup.ignorekeyword.trim();
      if (this.IsEmpty(this.textConfigForm.value.OthersGroup.ignorekeyword)) {
        bootbox.alert("keyword should not be empty");
      }
      else if(this.selectedStdLanguageOthers == null || this.selectedStdLanguageOthers == undefined || this.selectedStdLanguageOthers == 'Select')
      {
        bootbox.alert("Please select language to add keyword");
      }
      //else if (/^[a-zA-Z]*$/.test(this.textConfigForm.value.OthersGroup.ignorekeyword) == false) {
      //  bootbox.alert("Keyword must be a single word and should contain alphabets only")
      //}
      else if (/[@!#$%^&*()\-+={}\[\]|\\/'";:`.,~№?<>]+/i.test(this.textConfigForm.value.OthersGroup.ignorekeyword) == true || this.textConfigForm.value.OthersGroup.ignorekeyword.indexOf(' ') >= 0) {
        bootbox.alert("Keyword must be a single word and should contain alphabets only")
      }
      else if (this.indexOf(this.lstIgnoreKeys_others, this.textConfigForm.value.OthersGroup.ignorekeyword.trim()) >= 0) {
        bootbox.alert("\"" + this.textConfigForm.value.OthersGroup.ignorekeyword + "\" KeyWord(s) already exists");
      }
      else {
        if(this.EnableLemmaOth)
        {
          if (this.selectedLanguage_Other.length == 0 || this.selectedLanguage_Other == undefined) {
            if(this.envVar.EnableLanguage == true){
              bootbox.alert('Please select Ticket Language for Others.');
              return false;
            }       
          }
          else{ 
          let that = this;
          bootbox.dialog({
            message: 'The entered text will be added in the lemmatized form',
            buttons: {
              sucess: {
                label: 'Yes',
                className: 'btn-primary',
                callback: function () {
                    that.spinner.show();
                    var Language = that.envVar.EnableLanguage ? that.selectedStdLanguageOthers : 'English'
                    that.iomService.GetLemmaKeywords('','','', that.textConfigForm.value.OthersGroup.ignorekeyword,Language).subscribe((data: any) => {
                    that.spinner.hide();
                    
                      if (data.response.Result == "Success") {
                        var LemmaString = data.response.LemmaResponse.StopKeyWords_Lemma;
                        if (that.indexOf(that.lstIgnoreKeys, LemmaString) >= 0) {
                          bootbox.alert("\"" + LemmaString + "\" KeyWord(s) already exists");
                        }
                        else{
                        that.lstIgnoreKeys_others = [
                        ...that.lstIgnoreKeys_others,
                        LemmaString+'('+that.selectedStdLanguageOthers+')'
                      ];
                      that.lstIgnoreKeys_othersTemp = [
                        ...that.lstIgnoreKeys_othersTemp,
                         LemmaString+'('+that.selectedStdLanguageOthers+')'
                        ];
                      this.pushLanguageWiseKeyword(LemmaString,'others');
                      }
                        that.enableBox_Others = true;
                        that.textConfigForm.controls.OthersGroup.patchValue({ ignorekeyword: '' });
                      }
                      else {
                        that.textConfigForm.controls.OthersGroup.patchValue({ ignorekeyword: '' });
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      }
                    },
                      (err: HttpErrorResponse) => {
                        that.spinner.hide();
                        bootbox.alert("Timeout. Please Refresh and Try again");
                      });
                 
                }
              },
              cancel: {
                label: 'No',
                className: 'btn-secondary',
                callback: function () {
                    that.lstIgnoreKeys_others = [
                      ...that.lstIgnoreKeys_others,
                      that.textConfigForm.value.OthersGroup.ignorekeyword
                    ];
                    that.lstIgnoreKeys_othersTemp = [
                      ...that.lstIgnoreKeys_othersTemp,
                      that.textConfigForm.value.OthersGroup.ignorekeyword
                    ];
                    that.enableBox_Others = true;
                    that.textConfigForm.controls.OthersGroup.patchValue({ ignorekeyword: '' });
                }
              }
            },
            onEscape: function () {
              //on escape
          }
          });
        }
        }
        else{
        this.lstIgnoreKeys_others = [
          ...this.lstIgnoreKeys_others,
          this.textConfigForm.value.OthersGroup.ignorekeyword+'('+this.selectedStdLanguageOthers+')'
        ];
        this.lstIgnoreKeys_othersTemp = [
          ...this.lstIgnoreKeys_othersTemp,
          this.textConfigForm.value.OthersGroup.ignorekeyword+'('+this.selectedStdLanguageOthers+')'
        ];
        this.pushLanguageWiseKeyword(this.textConfigForm.value.OthersGroup.ignorekeyword,'others');
        this.enableBox_Others = true;
        this.textConfigForm.controls.OthersGroup.patchValue({ ignorekeyword: '' });
      }
      }
      //this.textConfigForm.value.OthersGroup.ignorekeyword.setValue('');
    }
  }
  RemoveKeyword(word, section) {
    if (section == 'ao') {
      this.pullLanguageWiseKeyword(word,'ao');
      this.lstIgnoreKeys = this.lstIgnoreKeys.filter(e => e !== word);
      this.lstIgnoreKeysTemp = this.lstIgnoreKeys;
      if (this.lstIgnoreKeys.length <= 0)
        this.enableBox_AO = false;
    }
    else if (section == 'io') {
      this.pullLanguageWiseKeyword(word,'io');
      this.lstIgnoreKeys_io = this.lstIgnoreKeys_io.filter(e => e !== word);
      this.lstIgnoreKeys_ioTemp = this.lstIgnoreKeys_io;
      if (this.lstIgnoreKeys_io.length <= 0)
        this.enableBox_IO = false;
    }
    else {
      this.pullLanguageWiseKeyword(word,'others');
      this.lstIgnoreKeys_others = this.lstIgnoreKeys_others.filter(e => e !== word);
      this.lstIgnoreKeys_othersTemp = this.lstIgnoreKeys_others;
      if (this.lstIgnoreKeys_others.length <= 0)
        this.enableBox_Others = false;
    }
  }

  selectAllConfig(tab: string) {
    this.ShowPopup = false;
    let all;
    switch (tab) {
      case 'ao':
        $(".newao .dropdown-menu ").addClass('show');
        $(".newao .iom-dropdown-toggle").addClass('show');
        all = this.textConfigForm.value.AOGroup.selectAllConfig;
        if (all) {
          this.selectedAllAoId.nativeElement.checked = true;
          (this.textConfigForm.get('AOGroup').get('mappingConfigs') as FormArray).controls.map(
            control => control.setValue(true));
            if (this.lstFilterMappingConfig_ao != null && this.lstFilterMappingConfig_ao != undefined) {
              this.lstFilterMappingConfig_ao.forEach((x, i) => {
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
                $('#aoSearch_' + x.indexNo).prop('checked', true);
                x.isChecked = true;
              });
            }
        }
        else {
          this.selectedAllAoId.nativeElement.checked = false;
          (this.textConfigForm.get('AOGroup').get('mappingConfigs') as FormArray).controls.map(
            control => control.setValue(false));
            if (this.lstFilterMappingConfig_ao != null && this.lstFilterMappingConfig_ao != undefined) {
              this.lstFilterMappingConfig_ao.forEach((x, i) => {
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = false;
                $('#aoSearch_' + x.indexNo).prop('checked', false);
                x.isChecked = false;
              });
            }
        }
        const sao = this.textConfigForm.value.AOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
          .filter(value => value !== null).join();

        if (sao !== '' && sao !== undefined && this.enableSearchAO == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        //this.selectedAoAssignedId.nativeElement.classList.remove('show');
        break;
      case 'io':
        $(".newio .dropdown-menu ").addClass('show');
        $(".newio .iom-dropdown-toggle").addClass('show');
        all = this.textConfigForm.value.IOGroup.selectAllConfig;
        if (all) {
          (this.textConfigForm.get('IOGroup').get('mappingConfigs') as FormArray).controls.map(
            control => control.setValue(true));
            if (this.lstFilterMappingConfig_io != null && this.lstFilterMappingConfig_io != undefined) {
              this.lstFilterMappingConfig_io.forEach((x, i) => {
                this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
                $('#aoSearch_' + x.indexNo).prop('checked', true);
                x.isChecked = true;
              });
            }
        }
        else {
          (this.textConfigForm.get('IOGroup').get('mappingConfigs') as FormArray).controls.map(
            control => control.setValue(false));
            if (this.lstFilterMappingConfig_io != null && this.lstFilterMappingConfig_io != undefined) {
              this.lstFilterMappingConfig_io.forEach((x, i) => {
                this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = false;
                $('#aoSearch_' + x.indexNo).prop('checked', false);
                x.isChecked = false;
              });
            }
        }
        // tslint:disable-next-line: max-line-length
        const sio = this.textConfigForm.value.IOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
          .filter(value => value !== null).join();
        if (sio !== '' && sio !== undefined && this.enableSearchIO == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        //this.selectedIoAssignedId.nativeElement.classList.remove('show');
        break;
      case 'others':
        $(".newoth .dropdown-menu ").addClass('show');
        $(".newoth .iom-dropdown-toggle").addClass('show');
        all = this.textConfigForm.value.OthersGroup.selectAllConfig;
        if (all) {
          (this.textConfigForm.get('OthersGroup').get('mappingConfigs') as FormArray).controls.map(
            control => control.setValue(true));
            if (this.lstFilterMappingConfig_others != null && this.lstFilterMappingConfig_others != undefined) {
              this.lstFilterMappingConfig_others.forEach((x, i) => {
                this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
                $('#aoSearch_' + x.indexNo).prop('checked', true);
                x.isChecked = true;
              });
            }
        }
        else {
          (this.textConfigForm.get('OthersGroup').get('mappingConfigs') as FormArray).controls.map(
            control => control.setValue(false));
            if (this.lstFilterMappingConfig_others != null && this.lstFilterMappingConfig_others != undefined) {
              this.lstFilterMappingConfig_others.forEach((x, i) => {
                this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = false;
                $('#aoSearch_' + x.indexNo).prop('checked', false);
                x.isChecked = false;
              });
            }
        }
        // tslint:disable-next-line: max-line-length
        const sothers = this.textConfigForm.value.OthersGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
          .filter(value => value !== null).join();
        if (sothers !== '' && sothers !== undefined && this.enableSearchOth == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        //this.selectedOthersAssignedId.nativeElement.classList.remove('show');
        break;
      default:
        break;
    }

  }

  selectConfig(tab: string, value: string) {
    let all;
    this.ShowPopup = false;
    switch (tab) {
      case 'ao':
        $(".newao .dropdown-menu ").addClass('show');
        $(".newao .iom-dropdown-toggle").addClass('show');
        if (this.lstFilterMappingConfig_aoSearch != null && this.lstFilterMappingConfig_aoSearch != undefined) {
          this.lstFilterMappingConfig_aoSearch.forEach((x, i) => {
            if (x.name == value) {
              x.isChecked = x.isChecked == true ? false : true;
            }
            if (x.isChecked) {
              this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
              $('#aoSearch_' + x.indexNo).prop('checked', true);
            }
          });
        }
        // tslint:disable-next-line: max-line-length
        let sao = this.textConfigForm.value.AOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        if (sao.split(',').length == this.textConfigForm.value.AOGroup.mappingConfigs.length) {
          // console.log('inside if');
          //  this.searchcheck_ao=true;
        }
        // tslint:disable-next-line: max-line-length
        if ((sao !== '' && sao !== undefined) && this.textConfigForm.value.AOGroup.mappingConfigs.length === sao.split(',').filter(value => value !== 'All').length) {
          this.selectedAllAoId.nativeElement.checked = true;
          this.searchcheck_ao = true;
          $(".dropdown-menu .new").removeClass('show');
          //  console.log('inside second if');
          sao = 'All';
        } else {
          this.selectedAllAoId.nativeElement.checked = false;
        }

        if (sao !== '' && sao !== undefined && this.enableSearchAO == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        //  toggle dropdown in standalone
        // this.selectedAoAssignedId.nativeElement.classList.remove('show');
        break;
      case 'io':
        $(".newio .dropdown-menu ").addClass('show');
        $(".newio .iom-dropdown-toggle").addClass('show');
        if (this.lstFilterMappingConfig_ioSearch != null && this.lstFilterMappingConfig_ioSearch != undefined) {
          this.lstFilterMappingConfig_ioSearch.forEach((x, i) => {
            if (x.name == value) {
              x.isChecked = x.isChecked == true ? false : true;
            }
            if (x.isChecked) {
              this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
              $('#ioSearch_' + x.indexNo).prop('checked', true);
            }
          });
        }
        // tslint:disable-next-line: max-line-length
        let sio = this.textConfigForm.value.IOGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        if (sio.split(',').length == this.textConfigForm.value.IOGroup.mappingConfigs.length) {
          this.searchcheck_io = true;
        }
        // tslint:disable-next-line: max-line-length
        if ((sio !== '' && sio !== undefined) && this.textConfigForm.value.IOGroup.mappingConfigs.length === sio.split(',').filter(value => value !== 'All').length) {
          this.selectedAllIoId.nativeElement.checked = true;
          sio = 'All';
          $(".dropdown-menu .new").removeClass('show');
        } else {
          this.selectedAllIoId.nativeElement.checked = false;
        }

        if (sao !== '' && sao !== undefined && this.enableSearchIO == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        //  toggle dropdown in standalone
        //this.selectedIoAssignedId.nativeElement.classList.remove('show');
        break;
      case 'others':
        $(".newoth .dropdown-menu ").addClass('show');
        $(".newoth .iom-dropdown-toggle").addClass('show');
        if (this.lstFilterMappingConfig_othSearch != null && this.lstFilterMappingConfig_othSearch != undefined) {
          this.lstFilterMappingConfig_othSearch.forEach((x, i) => {
            if (x.name == value) {
              x.isChecked = x.isChecked == true ? false : true;
            }
            if (x.isChecked) {
              this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
              $('#othSearch_' + x.indexNo).prop('checked', true);
            }
          });
        }
        // tslint:disable-next-line: max-line-length
        let sothers = this.textConfigForm.value.OthersGroup.mappingConfigs.map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        if (sothers.split(',').length == this.textConfigForm.value.OthersGroup.mappingConfigs.length) {
          this.searchcheck_others = true;
        }
        // tslint:disable-next-line: max-line-length
        if ((sothers !== '' && sothers !== undefined) && this.textConfigForm.value.OthersGroup.mappingConfigs.length === sothers.split(',').filter(value => value !== 'All').length) {
          this.selectedAllOthersId.nativeElement.checked = true;
          sothers = 'All';
          $(".dropdown-menu .new").removeClass('show');
        } else {
          this.selectedAllOthersId.nativeElement.checked = false;
        }

        if (sao !== '' && sao !== undefined && this.enableSearchOth == true) {
          this.enableApply = true;
          this.isClearAll = true;
        }
        //  toggle dropdown in standalone
        //this.selectedOthersAssignedId.nativeElement.classList.remove('show');
        break;
      default:
        break;
    }
}
  CancelTicketUpload() {
    this.SessionService.setSessionStorageItem('CreateDDInput', null);
    if (this.BatchId != "") {
      this.clearStagingTicketsByCloudId(this.textConfigFormStandard.value.deepdiveConfig);
    }
    this.unloadDOM();
    setTimeout(() => {
      this.router.navigate(['deepdive'], { queryParams: { 'E2EUId': this.SessionService.getE2EUId(), 'CMSUId': this.SessionService.getCMSUId(), 'WSUId': this.SessionService.getWSUId() } });
    }, 100);
  }
  loadDeliveryConstructTree(e2EUID, deliverystructureUID) {
    this.scopeSelectorService.getLeftDeliveryConstructsForLeftTree(e2EUID, deliverystructureUID)
      .subscribe((res: any) => {
        if (res) {
          //this.tree = res;
          this.treeData = res.DeliveryStructureData.Children;
          this.treeDataParent = {
            "DeliveryConstruct": res.DeliveryStructureData.DeliveryConstruct,
            "DeliveryConstructType": res.DeliveryStructureData.DeliveryConstructType,
            "DeliveryConstructUId": res.DeliveryStructureData.DeliveryConstructUId,
            "ParentDeliveryConstructType": res.DeliveryStructureData.ParentDeliveryConstructType,
            "ParentDeliveryConstructUId": res.DeliveryStructureData.ParentDeliveryConstructUId,
            "Status": res.DeliveryStructureData.Status,
            "Domain": res.DeliveryStructureData.Domain,
            "WorkstreamTypeID": res.DeliveryStructureData.WorkstreamTypeID,
            "ParentE2EUID": res.DeliveryStructureData.ParentE2EUID,
          };
          if (this.treeDataParent.DeliveryConstructType != 'DS') {
            this.DSlevel = false;
          }
        }
        this.spinner.hide();
        if(this.lstClassifiedBy.length == 0)
        {
          this.LoadStandard();
        }
    
      }, (error: any) => {
        this.spinner.hide();
      });
  }
  // onNodeSelected(e) {
  //   
  //   this.scopeNodeController = this.treeComponent.getControllerByNodeId(e.node.id.toString());
  //   if (this.scopeNodeController != null && this.scopeNodeController != undefined) {
  //     if (this.scopeNodeController.isCollapsed()) {
  //       this.scopeNodeController.expand();
  //     } else {
  //       this.scopeNodeController.collapse();
  //     }
  //   }
  // }
  // onNodeExpanded(e) {
  //   
  //   if (this.previousSelectedNodeId != null && this.previousSelectedNodeId != undefined && this.previousSelectedNodeId != e.node.node.clientUId) {
  //     var controller = this.treeComponent.getControllerByNodeId(this.previousSelectedNodeId);
  //     if (controller) {
  //       controller.collapse();
  //     }
  //   }

  //   this.previousSelectedNodeId = e.node.node.DeliveryConstructUId;
  // }
  // onChange(selecteddc: any, isChecked: boolean) {
  //   //$(this).closest('li').find('li div> label> input[type=checkbox]').prop('checked', $(this).is(':checked'))
  //   //$(".chkboxDis").attr('checked', false);


  //   const dcFormArray = <FormArray>this.formScope.controls.dc;

  //   if (isChecked) {
  //     dcFormArray.push(new FormControl(selecteddc));

  //   } else {
  //     let index = dcFormArray.controls.findIndex(x => x.value == selecteddc.id)
  //     dcFormArray.removeAt(index);
  //   }
  // }

  formatedData(node) {
    return node.dispalyValue + '~^~' + node.id + '~^~' + node.nodeType + '~^~' + node.ParentDeliveryConstructType + '~^~' + node.ParentDeliveryConstructUId + '~^~' + node.Status + '~^~' + node.domain
  }
  getSelectedDCs() {
    // hardcode for ATR integration 
    if (this.envVar.instanceType != 'FDS' || sessionStorage.getItem("Instance") == "PAM") {
      this.selectedDC = [];
      this.selectedDC.push({
        deliveryConstruct: this.SessionService.getDeliveryConstructName(),
        deliveryConstructUId: this.SessionService.getDeliveryConstructUId(),
        deliveryConstructType: '',
        parentDeliveryConstructType: '',
        parentDeliveryConstructUId: '',
        status: '',
        domain: '',
        //workstreamTypeID: DcsArr[6] == 'null' ? null : DcsArr[6],
        parentE2EUID: '',

        // domain: 'AO',
        closureDate: '',
        ClassificationTypeId: 0
      });
      return true;
    }
    else {
      var DcsArr = [];
      this.selectedDC = [];
      var allVals = [];
      $.each($('input[name=\'dc\']:checked'), function () {
        allVals.push($(this).val());
      });
      for (var i = 0; i < allVals.length; i++) {
        DcsArr = allVals[i].split('~^~');
        if (this.envVar.Env == 'FDS_ManualUpload' && this.SessionService.getSessionStorageItem('userType') == '3'){
        if (DcsArr[0] != 'undefined' && DcsArr[0] != 'null' && DcsArr[0] != null) {
          this.selectedDC.push({
            deliveryConstruct: DcsArr[0] == 'null' ? null : DcsArr[0],
          deliveryConstructUId: DcsArr[1] == 'null' ? null : DcsArr[1],
          deliveryConstructType: DcsArr[2] == 'null' ? null : DcsArr[2],
          parentDeliveryConstructType: DcsArr[3] == 'null' ? null : DcsArr[3],
          parentDeliveryConstructUId: DcsArr[4] == 'null' ? null : DcsArr[4],
          status: DcsArr[5] == 'null' ? null : DcsArr[5],
          domain: DcsArr[6],
          workstreamTypeID: DcsArr[7] == 'null' ? null : DcsArr[7],
          closureDate: '',
          ClassificationTypeId: this.getClassificationTypeId_FDS(DcsArr[6])
          });
        }
      }
      else{
        if (DcsArr[0] != 'undefined' && DcsArr[0] != 'null' && DcsArr[0] != null) {
          this.selectedDC.push({
            deliveryConstruct: DcsArr[0] == 'null' ? null : DcsArr[0],
            deliveryConstructUId: DcsArr[1] == 'null' ? null : DcsArr[1],
            deliveryConstructType: DcsArr[2] == 'null' ? null : DcsArr[2],
            parentDeliveryConstructType: DcsArr[3] == 'null' ? null : DcsArr[3],
            parentDeliveryConstructUId: DcsArr[4] == 'null' ? null : DcsArr[4],
            status: DcsArr[5] == 'null' ? null : DcsArr[5],
            domain: DcsArr[6] == 'null' ? null : DcsArr[6],
            //workstreamTypeID: DcsArr[6] == 'null' ? null : DcsArr[6],
            parentE2EUID: DcsArr[7] == 'null' ? null : DcsArr[7],

            // domain: 'AO',
            closureDate: '',
            ClassificationTypeId: this.getClassificationTypeId(DcsArr[6])
          });
        }
      }
      }
    }
    if (this.selectedDC.length != 0)
      return true;
    else
      return false;
  }

  getClassificationTypeId(domain) {
    if (domain == "AO") {
      return "1"
    }
    if (domain == "NA") { return "1" }
    if (domain == "IO") { return "3" } //workstreamTypeID == 10 || workstreamTypeID == 11
  }

  getClassificationTypeId_FDS(deliveryConstructType) {
    if (deliveryConstructType == "AO") {
      return "1"
    }
    if (deliveryConstructType == "NA") { return "1" }
    if (deliveryConstructType == "IO") { return "3" }
  }
  
  // getClassificationTypeId_FDS(domain) {
  //   if (domain == "AO") {
  //     return "1"
  //   }
  //   if (domain == "NA") { return "1" }
  //   if (domain == "IO") { return "3" }
  // }

  // getDomain_FDS(deliveryConstructType, workstreamTypeID) {
  //   if (deliveryConstructType == "WS" && workstreamTypeID != "10" && workstreamTypeID != "11") {
  //     return "AO"
  //   }
  //   if (deliveryConstructType == "EndToEnd" && (workstreamTypeID == "0" || workstreamTypeID == "null")) { return "NA" }
  //   if (deliveryConstructType == "WS" && workstreamTypeID == "10" || workstreamTypeID == "11") { return "IO" }
  // }

  IsEmpty(x) {
    return ((typeof x == 'undefined') || (x === null) || (x === ""));
  }

  checkDCSelection() {    
    this.DCAO = false;
    this.DCIO = false;
    this.DCOthers = false;
    if (this.getSelectedDCs()) {
      if (this.selectedDC != null) {
        if (this.envVar.instanceType == 'FDS') {
          for (var i = 0; i < this.selectedDC.length; i++) {
            if (this.selectedDC[i].domain == "NA") {
              this.DCOthers = true;
            }
            if (this.selectedDC[i].domain == "IO") { //|| this.selectedDC[i].domain == ""
              this.DCIO = true;
            }
            if (this.selectedDC[i].domain == "AO") { //&& (this.selectedDC[i].domain != 10 && this.selectedDC[i].domain != 11)
              this.DCAO = true;
            }
          }
        }
        else {
          for (var i = 0; i < this.selectedDC.length; i++) {
            if (this.selectedDC[i].domain == "NA") {
              this.DCOthers = true;
            }
            if (this.selectedDC[i].domain == "IO") { //|| this.selectedDC[i].domain == 11
              this.DCIO = true;
            }
            if (this.selectedDC[i].domain == "AO") { //&& (this.selectedDC[i].domain != 10 && this.selectedDC[i].domain != 11)
              this.DCAO = true;
            }
          }
        }
      }
      //this.isAvanced = true;
      this.LoadAdvance();
    }
    else {
      bootbox.alert('Please select delivery construct.');
      return false;
    }
  }


  unloadDOM() {
    //this.isAvanced = false;
    setTimeout(() => {
      $("#btnAdvanceClose").click();
    }, 100);
    this.ChartData_AO = null;
    this.ChartData_IO = null;
    this.ChartData_Others = null;
    this.prev_language = '';
    this.check_language = '';
    this.selectedLanguage_AO = [];
    this.selectedLanguage_IO = [];
    this.selectedLanguage_Other = [];
    this.selectedLanguageAO = [];
    this.selectedLanguageIO = [];
    this.selectedLanguageOther = [];
    this.selectedStdLanguageAO = 'Select';
    this.selectedStdLanguageIO = 'Select';
    this.selectedStdLanguageOthers = 'Select';
  }

  pamInstance() {
    if (this.envVar.instanceType == 'FDS' && sessionStorage.getItem("Instance") != "PAM") {
      this.InstancePAM = false;
    } else {
      this.InstancePAM = true;
    }
  }


  selectTicketTypemulti(tab: string) {
    switch (tab) {
      case 'AO':
        let stta = this.textConfigFormStandard.value.ticketTypeMulti.map((checked, index) => checked ? this.lstTicketType_ao[index].TicketType : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        if ((stta !== '' && stta !== undefined) && this.lstTicketType_ao.filter(({ TicketType }) => TicketType !== 'All').length === stta.split(',').filter(value => value !== 'All').length) {
          this.selectedAllTicket.nativeElement.checked = true;
          stta = 'All';
        } else {
          this.selectedAllTicket.nativeElement.checked = false;
        }
        if (stta !== '' && stta !== undefined) { this.selectedTickettype = stta; }
        else { this.selectedTickettype = 'Select Ticket Type'; }
        break;

      case 'IO':
        let stti = this.textConfigFormStandard.value.ticketTypeMulti.map((checked, index) => checked ? this.lstTicketType_io[index].TicketType : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        if ((stti !== '' && stti !== undefined) && this.lstTicketType_io.filter(({ TicketType }) => TicketType !== 'All').length === stti.split(',').filter(value => value !== 'All').length) {
          this.selectedAllTicket.nativeElement.checked = true;
          stti = 'All';
        } else {
          this.selectedAllTicket.nativeElement.checked = false;
        }
        if (stti !== '' && stti !== undefined) { this.selectedTickettype = stti; }
        else { this.selectedTickettype = 'Select Ticket Type'; }
        break;

      case 'Others':
        let stt = this.textConfigFormStandard.value.ticketTypeMulti.map((checked, index) => checked ? this.lstTicketType_others[index].TicketType : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        if ((stt !== '' && stt !== undefined) && this.lstTicketType_others.filter(({ TicketType }) => TicketType !== 'All').length === stt.split(',').filter(value => value !== 'All').length) {
          this.selectedAllTicket.nativeElement.checked = true;
          stt = 'All';
        } else {
          this.selectedAllTicket.nativeElement.checked = false;
        }
        if (stt !== '' && stt !== undefined) { this.selectedTickettype = stt; }
        else { this.selectedTickettype = 'Select Ticket Type'; }
        break;
      default:
        break;
    }
  }

  selectAllTicket(tab: string) {
    let all;
    all = this.textConfigFormStandard.value.selectAllTicket;
    if (all) {
      (this.textConfigFormStandard.get('ticketTypeMulti') as FormArray).controls.map(
        control => control.setValue(true));
    }
    else {
      (this.textConfigFormStandard.get('ticketTypeMulti') as FormArray).controls.map(
        control => control.setValue(false));
    }
    switch (tab) {
      case 'AO':
        let stta = this.textConfigFormStandard.value.ticketTypeMulti.map((checked, index) => checked ? this.lstTicketType_ao[index].TicketType : null)
          .filter(value => value !== null).join();
        if (all)
          this.selectedTickettype = 'All';
        else if (stta != '' && stta != undefined)
          this.selectedTickettype = stta;
        else
          this.selectedTickettype = 'Select Ticket Type';
        break;
      case 'IO':
        let stti = this.textConfigFormStandard.value.ticketTypeMulti.map((checked, index) => checked ? this.lstTicketType_io[index].TicketType : null)
          .filter(value => value !== null).join();
        if (all)
          this.selectedTickettype = 'All';
        else if (stti != '' && stti != undefined)
          this.selectedTickettype = stti;
        else
          this.selectedTickettype = 'Select Ticket Type';
        break;
      case 'Others':
        let stt = this.textConfigFormStandard.value.ticketTypeMulti.map((checked, index) => checked ? this.lstTicketType_others[index].TicketType : null)
          .filter(value => value !== null).join();
        if (all)
          this.selectedTickettype = 'All';
        else if (stt != '' && stt != undefined)
          this.selectedTickettype = stt;
        else
          this.selectedTickettype = 'Select Ticket Type';
        break;
      default:
        break;;
    }
  }

  selectTicketTypemultiadv(tab: string) {
    switch (tab) {
      case 'AO':
        let stta = this.textConfigForm.value.AOGroup.ticketTypeMulti.map((checked, index) => checked ? this.lstTicketType_ao[index].TicketType : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        if ((stta !== '' && stta !== undefined) && this.lstTicketType_ao.filter(({ TicketType }) => TicketType !== 'All').length === stta.split(',').filter(value => value !== 'All').length) {
          this.selectedAllTicketadv.nativeElement.checked = true;
          stta = 'All';
        } else {
          this.selectedAllTicketadv.nativeElement.checked = false;
        }
        if (stta !== '' && stta !== undefined) { this.selectedTickettypeadv_ao = stta; }
        else { this.selectedTickettypeadv_ao = 'Select Ticket Type'; }
        break;
      case 'IO':
        let stti = this.textConfigForm.value.IOGroup.ticketTypeMulti.map((checked, index) => checked ? this.lstTicketType_io[index].TicketType : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        if ((stti !== '' && stti !== undefined) && this.lstTicketType_io.filter(({ TicketType }) => TicketType !== 'All').length === stti.split(',').filter(value => value !== 'All').length) {
          this.selectedAllTicketadv.nativeElement.checked = true;
          stti = 'All';
        } else {
          this.selectedAllTicketadv.nativeElement.checked = false;
        }
        if (stti !== '' && stti !== undefined) { this.selectedTickettypeadv_io = stti; }
        else { this.selectedTickettypeadv_io = 'Select Ticket Type'; }
        break;
      case 'Others':
        let stt = this.textConfigForm.value.OthersGroup.ticketTypeMulti.map((checked, index) => checked ? this.lstTicketType_others[index].TicketType : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        if ((stt !== '' && stt !== undefined) && this.lstTicketType_others.filter(({ TicketType }) => TicketType !== 'All').length === stt.split(',').filter(value => value !== 'All').length) {
          this.selectedAllTicketadv.nativeElement.checked = true;
          stt = 'All';
        } else {
          this.selectedAllTicketadv.nativeElement.checked = false;
        }
        if (stt !== '' && stt !== undefined) { this.selectedTickettypeadv_others = stt; }
        else { this.selectedTickettypeadv_others = 'Select Ticket Type'; }
        break;
    }
  }

  selectAllTicketadv(tab: string) {
    let all;
    switch (tab) {
      case 'AO':
        all = this.textConfigForm.value.AOGroup.selectAllTicketadv;
        if (all) {
          (this.textConfigForm.get('AOGroup').get('ticketTypeMulti') as FormArray).controls.map(
            control => control.setValue(true));
        }
        else {
          (this.textConfigForm.get('AOGroup').get('ticketTypeMulti') as FormArray).controls.map(
            control => control.setValue(false));
        }
        let stta = this.textConfigForm.value.AOGroup.ticketTypeMulti.map((checked, index) => checked ? this.lstTicketType_ao[index].TicketType : null)
          .filter(value => value !== null).join();
        if (all)
          this.selectedTickettypeadv_ao = 'All';
        else if (stta != '' && stta != undefined)
          this.selectedTickettypeadv_ao = stta;
        else
          this.selectedTickettypeadv_ao = 'Select Ticket Type';
        break;
      case 'IO':
        all = this.textConfigForm.value.IOGroup.selectAllTicketadv;
        if (all) {
          (this.textConfigForm.get('IOGroup').get('ticketTypeMulti') as FormArray).controls.map(
            control => control.setValue(true));
        }
        else {
          (this.textConfigForm.get('IOGroup').get('ticketTypeMulti') as FormArray).controls.map(
            control => control.setValue(false));
        }
        let stti = this.textConfigForm.value.IOGroup.ticketTypeMulti.map((checked, index) => checked ? this.lstTicketType_io[index].TicketType : null)
          .filter(value => value !== null).join();
        if (all)
          this.selectedTickettypeadv_io = 'All';
        else if (stti != '' && stti != undefined)
          this.selectedTickettypeadv_io = stti;
        else
          this.selectedTickettypeadv_io = 'Select Ticket Type';
        break;
      case 'Others':
        all = this.textConfigForm.value.OthersGroup.selectAllTicketadv;
        if (all) {
          (this.textConfigForm.get('OthersGroup').get('ticketTypeMulti') as FormArray).controls.map(
            control => control.setValue(true));
        }
        else {
          (this.textConfigForm.get('OthersGroup').get('ticketTypeMulti') as FormArray).controls.map(
            control => control.setValue(false));
        }
        let stt = this.textConfigForm.value.OthersGroup.ticketTypeMulti.map((checked, index) => checked ? this.lstTicketType_others[index].TicketType : null)
          .filter(value => value !== null).join();
        if (all)
          this.selectedTickettypeadv_others = 'All';
        else if (stt != '' && stt != undefined)
          this.selectedTickettypeadv_others = stt;
        else
          this.selectedTickettypeadv_others = 'Select Ticket Type';
        break;
      default:
        break;
    }
  }

  //check
  selectApplication(tab: string) {
    switch (tab) {
      case 'AO':
        let sat = this.textConfigForm.value.AOGroup.applicationType.map((checked, index) => checked ? this.lstapplication_ao[index].name : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        // tslint:disable-next-line: max-line-length
        if ((sat !== '' && sat !== undefined) && this.lstapplication_ao.filter(({ name }) => name !== 'All').length === sat.split(',').filter(value => value !== 'All').length) {
          this.selectedAllApplication.nativeElement.checked = true;
          sat = 'All';
        } else {
          this.selectedAllApplication.nativeElement.checked = false;
        };
        if (sat !== '' && sat !== undefined) { this.selectedapplication_ao = sat; }
        else { this.selectedapplication_ao = 'Select Application'; }
        break;
      case 'IO':
        let sit = this.textConfigForm.value.IOGroup.applicationType.map((checked, index) => checked ? this.lstapplication_io[index].name : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        // tslint:disable-next-line: max-line-length
        if ((sit !== '' && sit !== undefined) && this.lstapplication_io.filter(({ name }) => name !== 'All').length === sit.split(',').filter(value => value !== 'All').length) {
          this.selectedAllApplication.nativeElement.checked = true;
          sit = 'All';
        } else {
          this.selectedAllApplication.nativeElement.checked = false;
        };
        if (sit !== '' && sit !== undefined) { this.selectedapplication_io = sit; }
        else { this.selectedapplication_io = 'Select Application'; }
        break;
      case 'Others':
        let sot = this.textConfigForm.value.OthersGroup.applicationType.map((checked, index) => checked ? this.lstapplication_others[index].name : null)
          .filter(value => value !== null).filter(value => value !== 'All').join();
        // tslint:disable-next-line: max-line-length
        if ((sot !== '' && sot !== undefined) && this.lstapplication_others.filter(({ name }) => name !== 'All').length === sot.split(',').filter(value => value !== 'All').length) {
          this.selectedAllApplication.nativeElement.checked = true;
          sot = 'All';
        } else {
          this.selectedAllApplication.nativeElement.checked = false;
        };
        if (sot !== '' && sot !== undefined) { this.selectedapplication_others = sot; }
        else { this.selectedapplication_others = 'Select Application'; }
        break;
      default:
        break;
    }
  }

  selectAllApplication(tab: string) {
    let all;
    switch (tab) {
      case 'AO':
        all = this.textConfigForm.value.AOGroup.selectAllApplication;
        if (all) {
          (this.textConfigForm.get('AOGroup').get('applicationType') as FormArray).controls.map(
            control => control.setValue(true));
        }
        else {
          (this.textConfigForm.get('AOGroup').get('applicationType') as FormArray).controls.map(
            control => control.setValue(false));
        }
        let sat = this.textConfigForm.value.AOGroup.applicationType.map((checked, index) => checked ? this.lstapplication_ao[index].name : null)
          .filter(value => value !== null).join();
        if (all)
          this.selectedapplication_ao = 'All';
        else if (sat != '' && sat != undefined)
          this.selectedapplication_ao = sat;
        else
          this.selectedapplication_ao = 'Select Application ';
        break;
      case 'IO':
        all = this.textConfigForm.value.IOGroup.selectAllApplication;
        if (all) {
          (this.textConfigForm.get('IOGroup').get('applicationType') as FormArray).controls.map(
            control => control.setValue(true));
        }
        else {
          (this.textConfigForm.get('IOGroup').get('applicationType') as FormArray).controls.map(
            control => control.setValue(false));
        }
        let sit = this.textConfigForm.value.IOGroup.applicationType.map((checked, index) => checked ? this.lstapplication_io[index].name : null)
          .filter(value => value !== null).join();
        if (all)
          this.selectedapplication_io = 'All';
        else if (sit != '' && sit != undefined)
          this.selectedapplication_io = sit;
        else
          this.selectedapplication_io = 'Select Application ';
        break;
      case 'Others':
        all = this.textConfigForm.value.OthersGroup.selectAllApplication;
        if (all) {
          (this.textConfigForm.get('OthersGroup').get('applicationType') as FormArray).controls.map(
            control => control.setValue(true));
        }
        else {
          (this.textConfigForm.get('OthersGroup').get('applicationType') as FormArray).controls.map(
            control => control.setValue(false));
        }
        let sot = this.textConfigForm.value.OthersGroup.applicationType.map((checked, index) => checked ? this.lstapplication_others[index].name : null)
          .filter(value => value !== null).join();
        if (all)
          this.selectedapplication_others = 'All';
        else if (sot != '' && sot != undefined)
          this.selectedapplication_others = sot;
        else
          this.selectedapplication_others = 'Select Application ';
        break;
      default:
        break;
    }
  }

  getStopKeyWords(tab: string, event: any, isQualifiedReset: boolean) {
    if (this.isAddkeywordsEnabled_IO == false && tab == "IO") {
      return;
    }
    this.spinner.show();
    var stopkeyWordsRequest = [];
    let values: { E2EUID: string, CMSUID: string, WSUID: string, FDSType: string, Domain: string };
    if (this.selectedDC != null) {
      let e2euid = this.SessionService.getE2EUId();
      this.selectedDC.forEach((x) => {
        let cmsuid = null;
        let wsuid = null;      
        if (x.deliveryConstructType == "DS" )
          cmsuid = x.deliveryConstructUId;
        else if (x.parentDeliveryConstructType == "DS" || (x.parentDeliveryConstructType == "EndToEnd" && x.domain == "AO"))
          cmsuid = x.deliveryConstructUId;          
        if (x.deliveryConstructType == "DC" || (x.parentDeliveryConstructType == "EndToEnd" && x.domain == "IO"))
          wsuid = x.deliveryConstructUId;         
        if (x.deliveryConstructType == "Client" || x.deliveryConstructType == "EndToEnd") { //check
          values = {
            E2EUID: e2euid,
            CMSUID: null,
            WSUID: null,
            FDSType: (x.deliveryConstructType == "Client" || x.deliveryConstructType == "EndToEnd" || this.envVar.Env == "SAAS_ManualUpload") ? "Client" : x.deliveryConstructType,
            Domain: tab
          };
          stopkeyWordsRequest.push(values);
          if (event != 'IO') {
            this.ticketType = event.target.value;
          }
          else {
            this.ticketType = this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType
          }
        }
        else if (tab == "AO" && x.deliveryConstructType != "Client") {
          values = {
            E2EUID: e2euid,
            CMSUID: cmsuid,
            WSUID: wsuid,
            FDSType: this.envVar.Env == "SAAS_ManualUpload" ? "Client" : (wsuid == null ? "DS" : "DC"),
            Domain: tab
          };
          stopkeyWordsRequest.push(values);
          this.ticketType = (tab == "AO") ? event.target.value : event.target.value;
        }
        else if (tab == "IO") {
          values = {
            E2EUID: e2euid,
            CMSUID: cmsuid,
            WSUID: wsuid,
            FDSType: this.envVar.Env == "SAAS_ManualUpload" ? "Client" : (wsuid == null ? "DS" : "DC"),
            Domain: tab
          };
          stopkeyWordsRequest.push(values);
          if (event != 'IO') {
            this.ticketType = event.target.value;
          }
          else {
            this.ticketType = this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType
          }
        }
        else {
          values = {
            E2EUID: e2euid,
            CMSUID: cmsuid,
            WSUID: wsuid,
            FDSType: this.envVar.Env == "SAAS_ManualUpload" ? "Client" : x.deliveryConstructType,
            Domain: tab
          };
          stopkeyWordsRequest.push(values);
          this.ticketType = (tab == "Others") ? event.target.value : event.target.value;
        }

      });
      if (tab == 'AO'){
        if(isQualifiedReset)
        {
        this.textConfigForm.get('AOGroup').get('ClassifiedBased').setValue('Select');
        if(event !='AO' && event.target.value == "7")
        {
          this.isResolutionDescEnabledTask_AO = false;
          this.textConfigForm.get('AOGroup').get('classifiedBasedOn').setValue('Short Description');
        }
        else{
          this.isResolutionDescEnabledTask_AO = true;
        }
      }
        this.Language = this.envVar.EnableLanguage ? this.selectedLanguage_AO.join('|') : 'English';
        this.lstClassifiedBy_ao = [];  
        this.lstClassifiedBy_ao = this.lstClassifiedByTemp;
        if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false) {
        if (this.textConfigForm.value.AOGroup.ticketType == '7') {
          this.lstClassifiedBy_ao = this.lstClassifiedBy_ao.filter(item => item.name !== 'Resolution Description');
        }
      }
      else {
        if (this.selectedTickettype == '7') {
          this.lstClassifiedBy_ao = this.lstClassifiedBy_ao.filter(item => item.name !== 'Resolution Description');
        }
      }
    }
      else if (tab == 'IO'){   
        if(isQualifiedReset)
        {     
        this.textConfigForm.get('IOGroup').get('ClassifiedBased').setValue(this.textConfigForm.value.IOGroup.ClassifiedBased);
        if(event !='IO' && event.target.value == "7")
        {
          this.isResolutionDescEnabledTask_IO = false;
          this.textConfigForm.get('IOGroup').get('classifiedBasedOn').setValue('Short Description');
        }
        else{
          this.isResolutionDescEnabledTask_IO = true;
        }
      }
        this.Language = this.envVar.EnableLanguage ?  this.selectedLanguage_IO.join('|') : 'English';
        this.lstClassifiedBy_io = [];  
        this.lstClassifiedBy_io = this.lstClassifiedByTemp;
        if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false) {
        if (this.textConfigForm.value.IOGroup.ticketType == '7') {
          this.lstClassifiedBy_io = this.lstClassifiedBy_io.filter(item => item.name !== 'Resolution Description');
        }
      }
      else {
        if (this.selectedTickettype == '7') {
          this.lstClassifiedBy_io = this.lstClassifiedBy_io.filter(item => item.name !== 'Resolution Description');
        }
      }
      }
      else if (tab == 'Others'){
        if(isQualifiedReset)
        {
        this.textConfigForm.get('OthersGroup').get('ClassifiedBased').setValue('Select');
        if(event !='Others' && event.target.value == "7")
        {
          this.isResolutionDescEnabledTask_Others = false;
          this.textConfigForm.get('OthersGroup').get('classifiedBasedOn').setValue('Short Description');
        }
        else{
          this.isResolutionDescEnabledTask_Others = true;
        }
      }
        this.Language = this.envVar.EnableLanguage ? this.selectedLanguage_Other.join('|') : 'English';
        this.lstClassifiedBy_others = [];  
        this.lstClassifiedBy_others = this.lstClassifiedByTemp;
        if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false) {
        if (this.textConfigForm.value.OthersGroup.ticketType == '7') {
          this.lstClassifiedBy_others = this.lstClassifiedBy_others.filter(item => item.name !== 'Resolution Description');
        }
      }
      else {
        if (this.selectedTickettype == '7') {
          this.lstClassifiedBy_others = this.lstClassifiedBy_others.filter(item => item.name !== 'Resolution Description');
        }
      }
      }
    }
    var EnableLemmaVal;
    if (tab == 'AO'){
      EnableLemmaVal = this.EnableLemmaAO;
      this.Language = this.envVar.EnableLanguage ? this.selectedLanguage_AO.join('|') : 'English';
    }
    else if (tab == 'IO'){
      EnableLemmaVal = this.EnableLemmaIO;
      this.Language = this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English';
    }
    else if (tab == 'Others'){
      EnableLemmaVal = this.EnableLemmaOth;
      this.Language = this.envVar.EnableLanguage ? this.selectedLanguage_Other.join('|') : 'English';
    }
    this.userType = parseInt(this.SessionService.getUserType());
    this.proposalId = 0;
    this.iomService.getStopKeywords<any>({ 'StopKeywords': stopkeyWordsRequest, 'userType': parseInt(this.SessionService.getUserType()), 'proposalId':  this.SessionService.getE2EUId(), 'ticketType': this.ticketType, 'Language': this.envVar.EnableLanguage ?  this.Language : 'English','IsLemmaEnabled': EnableLemmaVal ? 1:0}).pipe(timeout(2400000)).subscribe(response => {
      this.spinner.hide();
      //console.log('getStopkeywords', response);
      if (tab == "AO") {  // validate one more scenario if user added stopwords without selecting tickettype 
        if (response != null && response != "" && response != undefined && response.Message != "Execution Failed") {
          this.enableBox_AO = true;
          // this.lstIgnoreKeys = this.lstIgnoreKeys.concat(response.split(', '));
          //this.lstIgnoreKeys = response.trim().split(', ');
          this.lstIgnoreKeys = response.toString().replace(/,\s*$/, "").trim().split(', ');
          this.lstIgnoreKeysTemp = response.toString().replace(/,\s*$/, "").trim().split(',');

          this.LanguageKeywordAO = [];

        var existingstopwords = this.lstIgnoreKeys;
        if(existingstopwords.length>0)
        {
          for (var i = 0; i < existingstopwords.length; i++) {
            this.lstIgnoreKeys[i] = this.lstIgnoreKeys[i].replace(" ","");
            existingstopwords[i] = existingstopwords[i].replace(" ","");
            var Keywords = existingstopwords[i].substring(0, existingstopwords[i].indexOf('('));
            var Language = existingstopwords[i].substring(existingstopwords[i].indexOf('(')+1,existingstopwords[i].indexOf(')'));
            
            let objIndexAO = this.LanguageKeywordAO.findIndex((obj => obj.Language == Language));
              if (objIndexAO != -1) {
              var keywordsTemp: string[] = this.LanguageKeywordAO[objIndexAO].Keywords;
              keywordsTemp.push(Keywords.trim());
              this.LanguageKeywordAO[objIndexAO].Keywords = keywordsTemp;
              }
              else{
              var keywordsTemp: string[] = [];
              keywordsTemp.push(Keywords.trim());
              this.LanguageKeywordAO.push({ Language: Language, Keywords:keywordsTemp });
              }
          }
        }        
        }
        else {
          if(isQualifiedReset)
          {
          this.lstIgnoreKeys = [];
          this.lstIgnoreKeysTemp = [];
          this.LanguageKeywordAO = [];
          }
        }
      }
      else if (tab == "IO") {
        if (response != null && response != "" && response != undefined && response.Message != "Execution Failed") {
          this.enableBox_IO = true;
          // this.lstIgnoreKeys_io = this.lstIgnoreKeys_io.concat(response.split(', '));
          //this.lstIgnoreKeys_io = response.trim().split(', ');
          this.lstIgnoreKeys_io = response.toString().replace(/,\s*$/, "").trim().split(', ');
          this.lstIgnoreKeys_ioTemp = response.toString().replace(/,\s*$/, "").trim().split(',');
        
          this.LanguageKeywordAO = [];

        var existingstopwords = this.lstIgnoreKeys;
        if(existingstopwords.length>0)
        {
          for (var i = 0; i < existingstopwords.length; i++) {
            this.lstIgnoreKeys_io[i] = this.lstIgnoreKeys_io[i].replace(" ","");
            existingstopwords[i] = existingstopwords[i].replace(" ","");
            var Keywords = existingstopwords[i].substring(0, existingstopwords[i].indexOf('('));
            var Language = existingstopwords[i].substring(existingstopwords[i].indexOf('(')+1,existingstopwords[i].indexOf(')'));
            
            let objIndexAO = this.LanguageKeywordAO.findIndex((obj => obj.Language == Language));
              if (objIndexAO != -1) {
              var keywordsTemp: string[] = this.LanguageKeywordAO[objIndexAO].Keywords;
              keywordsTemp.push(Keywords.trim());
              this.LanguageKeywordAO[objIndexAO].Keywords = keywordsTemp;
              }
              else{
              var keywordsTemp: string[] = [];
              keywordsTemp.push(Keywords.trim());
              this.LanguageKeywordAO.push({ Language: Language, Keywords:keywordsTemp });
              }
          }
        }
        }
        else {
          if(isQualifiedReset)
          {
          this.lstIgnoreKeys_io = [];
          this.lstIgnoreKeys_ioTemp = [];
          this.LanguageKeywordIO = [];
          }
        }
      }
      else {
        if (response != null && response != "" && response != undefined && response.Message != "Execution Failed") {
          this.enableBox_Others = true;
          // this.lstIgnoreKeys_others = this.lstIgnoreKeys_others.concat(response.split(', '));
          //this.lstIgnoreKeys_others = response.trim().split(', ');
          this.lstIgnoreKeys_others = response.toString().replace(/,\s*$/, "").trim().split(', ');
          this.lstIgnoreKeys_othersTemp = response.toString().replace(/,\s*$/, "").trim().split(',');
          this.LanguageKeywordOthers = [];
          var existingstopwords=this.lstIgnoreKeys_others;
          if(existingstopwords.length>0)
          {
            for (var i = 0; i < existingstopwords.length; i++) {
              this.lstIgnoreKeys_others[i] = this.lstIgnoreKeys_others[i].replace(" ","");
              existingstopwords[i] = existingstopwords[i].replace(" ","");
              var Keywords = existingstopwords[i].substring(0, existingstopwords[i].indexOf('('));
              var Language = existingstopwords[i].substring(existingstopwords[i].indexOf('(')+1,existingstopwords[i].indexOf(')'));
              
              let objIndexAO = this.LanguageKeywordOthers.findIndex((obj => obj.Language == Language));
                if (objIndexAO != -1) {
                var keywordsTemp: string[] = this.LanguageKeywordOthers[objIndexAO].Keywords;
                keywordsTemp.push(Keywords.trim());
                this.LanguageKeywordOthers[objIndexAO].Keywords = keywordsTemp;
                }
                else{
                var keywordsTemp: string[] = [];
                keywordsTemp.push(Keywords.trim());
                this.LanguageKeywordOthers.push({ Language: Language, Keywords:keywordsTemp });
                }
            }
          }
        }
        else {
          if(isQualifiedReset)
          {
          this.lstIgnoreKeys_others = [];
          this.lstIgnoreKeys_othersTemp = [];
          this.LanguageKeywordOthers = [];
          }
        }
      }

    });


  }

  getTopKeyWords(tab: string,exists: boolean) {
    this.UserOption = 2;
    if (!this.ValidateFormForTopKeyWords(tab)) {
      return false;
    }
    var existingstopwordsAO = this.lstIgnoreKeysTemp;
    var existingstopwordsIO = this.lstIgnoreKeys_ioTemp;
    var existingstopwordsOthers = this.lstIgnoreKeys_othersTemp;

    if (tab == "AO") {
      if(existingstopwordsAO.length>0)
      {
        for (var i = 0; i < existingstopwordsAO.length; i++) {
          existingstopwordsAO[i] =existingstopwordsAO[i].substring(0, existingstopwordsAO[i].indexOf('('));
        }
        this.lstIgnoreKeysTemp = [];
        
        for (var i = 0; i < this.lstIgnoreKeys.length; i++) {
          this.lstIgnoreKeysTemp.push(this.lstIgnoreKeys[i])
        }
      }
    }
    else if (tab == 'IO') {
        if(existingstopwordsIO.length>0)
        {
          for (var i = 0; i < existingstopwordsIO.length; i++) {
            existingstopwordsIO[i] =existingstopwordsIO[i].substring(0, existingstopwordsIO[i].indexOf('('));
          }

          this.lstIgnoreKeys_ioTemp = [];
          for (var i = 0; i < this.lstIgnoreKeys_io.length; i++) {
            this.lstIgnoreKeys_ioTemp.push(this.lstIgnoreKeys_io[i])
          }
        }
    }
    else {
      if(existingstopwordsOthers.length>0)
      {
        for (var i = 0; i < existingstopwordsOthers.length; i++) {
          existingstopwordsOthers[i] =existingstopwordsOthers[i].substring(0, existingstopwordsOthers[i].indexOf('('));
        }
        this.lstIgnoreKeys_othersTemp = [];
        for (var i = 0; i < this.lstIgnoreKeys_others.length; i++) {
          this.lstIgnoreKeys_othersTemp.push(this.lstIgnoreKeys_others[i])
        }
      }
    }
    if (!this.LoadWordCloudDataFromHistory(tab, false)) {
        if(this.prevtab == tab){
          this.enableticketpull = false;
        }
        else{
          this.enableticketpull = true;
        }
      switch (tab) {  
        case 'AO':
          var ticketType;
          var ApplicationName;          
          if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
            ticketType = this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType;
          else
            ticketType = this.textConfigForm.value.AOGroup.ticketTypeMulti
              .map((checked, index) => checked ? this.lstTicketType_ao[index].ServiceType : null)
              .filter(value => value !== null).join('~^~');
          if (this.envVar.ClientConfiguration.isMultiSelectAppName == false)
            // ApplicationName = this.aoAnalytics.applicationName = this.textConfigForm.value.AOGroup.appType == 'Select' ? '' : this.textConfigForm.value.AOGroup.appType;
            ApplicationName = 'All';
          else
            ApplicationName = this.aoAnalytics.applicationName = this.textConfigForm.value.AOGroup.applicationType
              .map((checked, index) => checked ? this.lstapplication_ao[index].name : null)
              .filter(value => value !== null).join('~^~');
          this.topKeyWord_AO = new TopKeyWordsFilter(this.BatchId, false,
            this.textConfigForm.value.AOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.startDate) : '',
            this.textConfigForm.value.AOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.endDate) : '',
            this.textConfigForm.value.AOGroup.topWordOption,
            tab,
            this.textConfigForm.value.AOGroup.ClassifiedBased == 'Select' ? 'Short Description' : this.textConfigForm.value.AOGroup.ClassifiedBased,
            
            ticketType,
            //this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType,
            this.textConfigForm.value.AOGroup.mappingConfigs
              .map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
              .filter(value => value !== null).join('~^~'),
            this.selectedDC, "SupportGroupName", existingstopwordsAO?.join(), ApplicationName,this.envVar.EnableLanguage ?  this.selectedLanguage_AO.join('|') : 'English');
          break;
        case 'IO':
          var ticketType;
          var ApplicationName;          
          if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
            ticketType = this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType;
          else
            ticketType = this.textConfigForm.value.IOGroup.ticketTypeMulti
              .map((checked, index) => checked ? this.lstTicketType_io[index].ServiceType : null)
              .filter(value => value !== null).join('~^~');
          if (this.envVar.ClientConfiguration.isMultiSelectAppName == false)
            // ApplicationName = this.ioAnalytics.applicationName = this.textConfigForm.value.IOGroup.appType == 'Select' ? '' : this.textConfigForm.value.IOGroup.appType;
            ApplicationName = 'All';
          else
            ApplicationName = this.ioAnalytics.applicationName = this.textConfigForm.value.IOGroup.applicationType
              .map((checked, index) => checked ? this.lstapplication_io[index].name : null)
              .filter(value => value !== null).join('~^~');
          this.topKeyWord_IO = new TopKeyWordsFilter(this.BatchId, false,
            this.textConfigForm.value.IOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.startDate) : '',
            this.textConfigForm.value.IOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.endDate) : '',
            this.textConfigForm.value.IOGroup.topWordOption,
            tab,
            this.textConfigForm.value.IOGroup.ClassifiedBased == 'Select' ? 'Short Description' : this.textConfigForm.value.IOGroup.ClassifiedBased,
            
            ticketType,
            this.textConfigForm.value.IOGroup.mappingConfigs
              .map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
              .filter(value => value !== null).join('~^~'),
            this.selectedDC, "SupportGroupName", existingstopwordsIO?.join(), ApplicationName,this.envVar.EnableLanguage ?  this.selectedLanguage_IO.join('|') : 'English' );
          break;
        case 'Others':
          var ticketType;
          var ApplicationName;          
          if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
            ticketType = this.textConfigForm.value.OthersGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.ticketType;
          else
            ticketType = this.textConfigForm.value.OthersGroup.ticketTypeMulti
              .map((checked, index) => checked ? this.lstTicketType_others[index].ServiceType : null)
              .filter(value => value !== null).join('~^~');
          if (this.envVar.ClientConfiguration.isMultiSelectAppName == false)
            // ApplicationName = this.othersAnalytics.applicationName = this.textConfigForm.value.OthersGroup.appType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.appType;
            ApplicationName = 'All';
          else
            ApplicationName = this.othersAnalytics.applicationName = this.textConfigForm.value.OthersGroup.applicationType
              .map((checked, index) => checked ? this.lstapplication_others[index].name : null)
              .filter(value => value !== null).join('~^~');
          this.topKeyWord_Others = new TopKeyWordsFilter(this.BatchId, false,
            this.textConfigForm.value.OthersGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.startDate) : '',
            this.textConfigForm.value.OthersGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.endDate) : '',
            this.textConfigForm.value.OthersGroup.topWordOption,
            tab,
            this.textConfigForm.value.OthersGroup.ClassifiedBased == 'Select' ? 'Short Description' : this.textConfigForm.value.OthersGroup.ClassifiedBased,
            
            ticketType,
            this.textConfigForm.value.OthersGroup.mappingConfigs
              .map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
              .filter(value => value !== null).join('~^~'),
              this.selectedDC, "SupportGroupName", existingstopwordsOthers?.join(),
            ApplicationName,this.envVar.EnableLanguage ?  this.selectedLanguage_Other.join('|') : 'English' );
          break;
      }
      if (tab == "AO") {
        this.checkDoTicketPull(this.textConfigForm.value.AOGroup.startDate, this.textConfigForm.value.AOGroup.endDate, 'AO', exists);
        this.checkMinMaxDate();
        let stopwords = existingstopwordsAO != '' ? existingstopwordsAO.join() : '';                
        this.spinner.show();
        if(this.enableticketpull == true){
          this.DoTicketPull = true
        }
        if(this.DoTicketPull == false)
        {
          this.topKeyWord_AO.BatchId=this.SessionService.getSessionStorageItem('BatchIdGetTopKeyword');
        }
        
        this.iomService.getTopKeyWords(this.SessionService.getUserName(), "AO", this.UserOption, this.SessionService.getE2EUId(), this.topKeyWord_AO, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, parseInt(this.SessionService.getUserType()), stopwords, ApplicationName,this.EnableLemmaAO)
          .pipe(timeout(2400000))
          .subscribe((res: any) => {
            this.spinner.hide();
            if (res != null || res != "") {
              if (res.Result != undefined) {
                if (res.Result.indexOf('Success') > -1) {
                  this.isSkipTopWords = false;
                  this.TopKeyWordData_AO = res;
                  if (this.TopKeyWordData_AO.WordCloudData) {
                    if (JSON.parse(this.TopKeyWordData_AO.WordCloudData).Message == undefined) {
                      this.ChartData_AO = JSON.parse(this.TopKeyWordData_AO.WordCloudData);
                      if (res.TopKeyWordsFilter) {
                        delete res.TopKeyWordsFilter.DeliveryConstructUId;
                        delete res.TopKeyWordsFilter.UserType;
                        delete res.TopKeyWordsFilter.isSkipTopWords;
                        res.TopKeyWordsFilter.responselen = res.TopKeyWordsFilter.responselen.toString();
                      }
                      this.topKeywordsResponse_History_AO.push(res);
                    } else {
                      this.ChartData_AO = null;
                      bootbox.alert(JSON.parse(this.TopKeyWordData_AO.WordCloudData).Message);
                    }
                  }
                  else {
                    this.ChartData_AO = null;
                    bootbox.alert("No TopKeyWords Available");
                  }
                  this.BatchId = res.BatchUID;
                  this.SessionService.setSessionStorageItem('BatchIdGetTopKeyword',  res.BatchUID);
                }
                else {
                  if (res.BatchUID != '') {
                    this.BatchId = res.BatchUID;
                    this.SessionService.setSessionStorageItem('BatchIdGetTopKeyword',  res.BatchUID);
                  }
                  bootbox.alert(res.Result);
                }
              }
              else {
                bootbox.alert(res);
              }
            }
          }, (error: HttpErrorResponse) => {
            this.spinner.hide();
            if (error.message != "Timeout has occurred") {
              bootbox.alert('Error occur while get top keywords.');
            }
          });
      }
      else if (tab == 'IO') {
        this.checkDoTicketPull(this.textConfigForm.value.IOGroup.startDate, this.textConfigForm.value.IOGroup.endDate, 'IO', exists);
        this.checkMinMaxDate();        
        let stopwords = existingstopwordsIO != '' ? existingstopwordsIO.join() : '';
        this.spinner.show();
        if(this.DoTicketPull == false)
        {
          this.topKeyWord_IO.BatchId=this.SessionService.getSessionStorageItem('BatchIdGetTopKeyword');
        }
        this.iomService.getTopKeyWords(this.SessionService.getUserName(), "IO", this.UserOption, this.SessionService.getE2EUId(), this.topKeyWord_IO, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, parseInt(this.SessionService.getUserType()), stopwords, ApplicationName,this.EnableLemmaIO)
          .pipe(timeout(2400000))
          .subscribe((res: any) => {
            this.spinner.hide();
            if (res != null || res != "") {
              if (res.Result != undefined) {
                if (res.Result.indexOf('Success') > -1) {
                  this.TopKeyWordData_IO = res;
                  this.isSkipTopWords = false;
                  if (this.TopKeyWordData_IO.WordCloudData) {
                    if (JSON.parse(this.TopKeyWordData_IO.WordCloudData).Message == undefined) {
                      this.ChartData_IO = JSON.parse(this.TopKeyWordData_IO.WordCloudData);
                      if (res.TopKeyWordsFilter) {
                        delete res.TopKeyWordsFilter.DeliveryConstructUId;
                        delete res.TopKeyWordsFilter.UserType;
                        delete res.TopKeyWordsFilter.isSkipTopWords;
                        res.TopKeyWordsFilter.responselen = res.TopKeyWordsFilter.responselen.toString();
                      }
                      this.topKeywordsResponse_History_IO.push(res);
                    } else {
                      this.ChartData_IO = null;
                      bootbox.alert(JSON.parse(this.TopKeyWordData_IO.WordCloudData).Message);
                    }
                  }
                  else {
                    this.ChartData_IO = null;
                    bootbox.alert("No TopKeyWords Available");
                  }
                  this.BatchId = res.BatchUID;
                  this.SessionService.setSessionStorageItem('BatchIdGetTopKeyword',  res.BatchUID);
                }
                else {
                  if (res.BatchUID != '') {
                    this.BatchId = res.BatchUID;
                    this.SessionService.setSessionStorageItem('BatchIdGetTopKeyword',  res.BatchUID);
                  }
                  bootbox.alert(res.Result);
                }
              }
              else {
                bootbox.alert(res);
              }
            }
          }, (error: HttpErrorResponse) => {
            this.spinner.hide();
            if (error.message != "Timeout has occurred") {
              bootbox.alert('Error occur while get top keywords.');
            }
          });
      }
      else {
        this.checkDoTicketPull(this.textConfigForm.value.OthersGroup.startDate, this.textConfigForm.value.OthersGroup.endDate, 'Others', exists);
        this.checkMinMaxDate();        
        let stopwords = existingstopwordsOthers != '' ? existingstopwordsOthers.join() : '';
        this.spinner.show();
        if(this.DoTicketPull == false)
        {
        this.topKeyWord_Others.BatchId=this.SessionService.getSessionStorageItem('BatchIdGetTopKeyword');
        }
        this.iomService.getTopKeyWords(this.SessionService.getUserName(), "Others", this.UserOption, this.SessionService.getE2EUId(), this.topKeyWord_Others, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, parseInt(this.SessionService.getUserType()), stopwords, ApplicationName,this.EnableLemmaOth)
          .pipe(timeout(2400000))
          .subscribe((res: any) => {
            this.spinner.hide();
            if (res != null || res != "") {
              if (res.Result != undefined) {
                if (res.Result.indexOf('Success') > -1) {
                  this.TopKeyWordData_Others = res;
                  this.isSkipTopWords = false;
                  if (this.TopKeyWordData_Others.WordCloudData) {
                    if (JSON.parse(this.TopKeyWordData_Others.WordCloudData).Message == undefined) {
                      this.ChartData_Others = JSON.parse(this.TopKeyWordData_Others.WordCloudData);
                      if (res.TopKeyWordsFilter) {
                        delete res.TopKeyWordsFilter.DeliveryConstructUId;
                        delete res.TopKeyWordsFilter.UserType;
                        delete res.TopKeyWordsFilter.isSkipTopWords;
                        res.TopKeyWordsFilter.responselen = res.TopKeyWordsFilter.responselen.toString();
                      }
                      this.topKeywordsResponse_History_Others.push(res);
                    } else {
                      this.ChartData_Others = null;
                      bootbox.alert(JSON.parse(this.TopKeyWordData_Others.WordCloudData).Message);
                    }
                  }
                  else {
                    this.ChartData_Others = null;
                    bootbox.alert("No TopKeyWords Available");
                  }
                  this.BatchId = res.BatchUID;
                  this.SessionService.setSessionStorageItem('BatchIdGetTopKeyword',  res.BatchUID);
                }
                else {
                  if (res.BatchUID != '') {
                    this.BatchId = res.BatchUID;
                    this.SessionService.setSessionStorageItem('BatchIdGetTopKeyword',  res.BatchUID);
                  }
                  bootbox.alert(res.Result);
                }
              }
              else {
                bootbox.alert(res);
              }
            }
          }, (error: HttpErrorResponse) => {
            this.spinner.hide();
            if (error.message != "Timeout has occurred") {
              bootbox.alert('Error occur while get top keywords.');
            }
          });
      }
    }
    this.prevtab = tab;
  }
  onDateSelected(domain, event) {
    if (this.isAddkeywordsEnabled_IO == false && domain == "IO") {
      return;
    }
    this.LoadWordCloudDataFromHistory(domain);
  }
  LoadWordCloudDataFromHistory(domain, isOnChangeEvent = true) {
    let isExists = false;
    let historyObj = null;
    let currentObj = null;
    switch (domain) {
      case 'AO':
        this.ChartData_AO = null;
        if (isOnChangeEvent) {
          this.textConfigForm.get('AOGroup').get('topWordOption').setValue(this.WordCloudFilterOptions[2]);
        }
        if (this.topKeywordsResponse_History_AO && this.topKeywordsResponse_History_AO.length > 0) {
          currentObj = new TopKeyWordsFilter(this.BatchId, true,
            this.textConfigForm.value.AOGroup.startDate != '' ? this.ConvertToDateFormat(this.textConfigForm.value.AOGroup.startDate) : '',
            this.textConfigForm.value.AOGroup.endDate != '' ? this.ConvertToDateFormat(this.textConfigForm.value.AOGroup.endDate) : '',
            this.textConfigForm.value.AOGroup.topWordOption,
            "AO",
            this.textConfigForm.value.AOGroup.ClassifiedBased.replace(/ /g, ''),
            
            this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType,
            this.textConfigForm.value.AOGroup.mappingConfigs
              .map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
              .filter(value => value !== null).join(),
            null, this.lstMappingConfig_ao.FilterName.split('|')[0], this.lstIgnoreKeys?.join(), "",this.envVar.EnableLanguage ?  this.selectedLanguage_AO.join('|') : 'English');
          delete currentObj.isSkipTopWords;
          for (let index = 0; index < this.topKeywordsResponse_History_AO.length; index++) {
            if (JSON.stringify(currentObj) == JSON.stringify(this.topKeywordsResponse_History_AO[index].TopKeyWordsFilter)) {
              isExists = true;
              historyObj = this.topKeywordsResponse_History_AO[index];
              break;
            }
          }
          if (isExists) {
            this.ChartData_AO = JSON.parse(historyObj.WordCloudData);
            this.BatchId = historyObj.BatchUID;
          }
          else {
            this.ChartData_AO = null;
            this.BatchId = "";
          }
        }
        break;
      case "IO":
        this.ChartData_IO = null;
        if (isOnChangeEvent) {
          this.textConfigForm.get('IOGroup').get('topWordOption').setValue(this.WordCloudFilterOptions[2]);
        }
        if (this.topKeywordsResponse_History_IO && this.topKeywordsResponse_History_IO.length > 0) {
          currentObj = new TopKeyWordsFilter(this.BatchId, true,
            this.textConfigForm.value.IOGroup.startDate != '' ? this.ConvertToDateFormat(this.textConfigForm.value.IOGroup.startDate) : '',
            this.textConfigForm.value.IOGroup.endDate != '' ? this.ConvertToDateFormat(this.textConfigForm.value.IOGroup.endDate) : '',
            this.textConfigForm.value.IOGroup.topWordOption,
            "IO",
            this.textConfigForm.value.IOGroup.ClassifiedBased.replace(/ /g, ''),
           
            this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType,
            this.textConfigForm.value.IOGroup.mappingConfigs
              .map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
              .filter(value => value !== null).join(),
            null, this.lstMappingConfig_io.FilterName.split('|')[0], this.lstIgnoreKeys_io?.join(), "",this.envVar.EnableLanguage ?  this.selectedLanguage_IO.join('|') : 'English');
          delete currentObj.isSkipTopWords;
          for (let index = 0; index < this.topKeywordsResponse_History_IO.length; index++) {
            if (JSON.stringify(currentObj) == JSON.stringify(this.topKeywordsResponse_History_IO[index].TopKeyWordsFilter)) {
              isExists = true;
              historyObj = this.topKeywordsResponse_History_IO[index];
              break;
            }
          }
          if (isExists) {
            this.ChartData_IO = JSON.parse(historyObj.WordCloudData);
            this.BatchId = historyObj.BatchUID;
          }
          else {
            this.ChartData_IO = null;
          }
        }
        break;
      case "Others":
        this.ChartData_Others = null;
        if (isOnChangeEvent) {
          this.textConfigForm.get('OthersGroup').get('topWordOption').setValue(this.WordCloudFilterOptions[2]);
        }
        if (this.topKeywordsResponse_History_Others && this.topKeywordsResponse_History_Others.length > 0) {
          currentObj = new TopKeyWordsFilter(this.BatchId, true,
            this.textConfigForm.value.OthersGroup.startDate != '' ? this.ConvertToDateFormat(this.textConfigForm.value.OthersGroup.startDate) : '',
            this.textConfigForm.value.OthersGroup.endDate != '' ? this.ConvertToDateFormat(this.textConfigForm.value.OthersGroup.endDate) : '',
            this.textConfigForm.value.OthersGroup.topWordOption,
            'Others',
            this.textConfigForm.value.OthersGroup.ClassifiedBased.replace(/ /g, ''),
            
            this.textConfigForm.value.OthersGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.ticketType,
            this.textConfigForm.value.OthersGroup.mappingConfigs
              .map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
              .filter(value => value !== null).join(),
            null, this.lstMappingConfig_others.FilterName.split('|')[0], this.lstIgnoreKeys_others?.join(), "",this.envVar.EnableLanguage ?  this.selectedLanguage_Other.join('|') : 'English');
          delete currentObj.isSkipTopWords;
          for (let index = 0; index < this.topKeywordsResponse_History_Others.length; index++) {
            if (JSON.stringify(currentObj) == JSON.stringify(this.topKeywordsResponse_History_Others[index].TopKeyWordsFilter)) {
              isExists = true;
              historyObj = this.topKeywordsResponse_History_Others[index];
              break;
            }
          }
          if (isExists) {
            this.ChartData_Others = JSON.parse(historyObj.WordCloudData);
            this.BatchId = historyObj.BatchUID;
          }
          else {
            this.ChartData_Others = null;
          }
        }
        break;
      default:
        break;
    }
    return isExists;
  }
  ConvertToDateFormat(dateObj: any) {
    return dateObj.month + "/" + dateObj.day + "/" + dateObj.year;
  }
  getLanguageList(){
    // this.LanguageList = ['English'];
    this.iomService.GetLanguageList().subscribe(data => {
      this.LanguageList = data;
    }, (err: HttpErrorResponse) => {
      console.log(err) 
    })
  }
  checkMinMaxDate() {
    var sdates = [];
    var edates = [];
    let startDate_ao = this.textConfigForm.value.AOGroup.startDate;
    let endDate_ao = this.textConfigForm.value.AOGroup.endDate;
    let startDate_io = this.textConfigForm.value.IOGroup.startDate;
    let endDate_io = this.textConfigForm.value.IOGroup.endDate;
    let startDate_others = this.textConfigForm.value.OthersGroup.startDate;
    let endDate_others = this.textConfigForm.value.OthersGroup.endDate;

    if (startDate_ao != '')
      sdates.push(new Date(startDate_ao.year, startDate_ao.month - 1, startDate_ao.day));
    if (startDate_io != '')
      sdates.push(new Date(startDate_io.year, startDate_io.month - 1, startDate_io.day));
    if (startDate_others != '')
      sdates.push(new Date(startDate_others.year, startDate_others.month - 1, startDate_others.day));

    if (endDate_ao != '')
      edates.push(new Date(endDate_ao.year, endDate_ao.month - 1, endDate_ao.day));
    if (endDate_io != '')
      edates.push(new Date(endDate_io.year, endDate_io.month - 1, endDate_io.day));
    if (startDate_others != '')
      edates.push(new Date(endDate_others.year, endDate_others.month - 1, endDate_others.day));

    var minDate = new Date(Math.min.apply(null, sdates));
    var maxDate = new Date(Math.max.apply(null, edates));
    //Adding + one here because getmonth s always returning months bewteen 0 -11
    this.MinStartDate = JSON.stringify({ "year": minDate.getFullYear(), "month": minDate.getMonth() + 1, "day": minDate.getDate() });
    this.MaxEndDate = JSON.stringify({ "year": maxDate.getFullYear(), "month": maxDate.getMonth() + 1, "day": maxDate.getDate() });
  }
  checkDoTicketPull(startDate, endDate, tab: string, exists) {
    this.DoTicketPull = false;
    var curStartDate = new Date(startDate.year, startDate.month - 1, startDate.day);
    var curEndDate = new Date(endDate.year, endDate.month - 1, endDate.day);
    if(exists == true && this.TopKeyWordData_AO != undefined){
      this.TopKeyWordData_AO.WordCloudData = "";
    }
    if(exists == true && this.TopKeyWordData_IO != undefined){
      this.TopKeyWordData_IO.WordCloudData = "";
    }
    if(exists == true && this.TopKeyWordData_Others != undefined){
      this.TopKeyWordData_Others.WordCloudData = "";
    }
    if (this.TopKeyWordData_AO != undefined && this.TopKeyWordData_AO.WordCloudData != "" && this.TopKeyWordData_AO.WordCloudData != undefined) {
      if (curStartDate < new Date(this.TopKeyWordData_AO.MinStartDate) || curStartDate > new Date(this.TopKeyWordData_AO.MaxEndDate)) {
        this.DoTicketPull = true;
        this.BatchId = "";
      }
      else if (curEndDate < new Date(this.TopKeyWordData_AO.MinStartDate) || curEndDate > new Date(this.TopKeyWordData_AO.MaxEndDate)) {
        this.DoTicketPull = true;
        this.BatchId = "";
      }
    }
    else if (this.TopKeyWordData_IO != undefined && this.TopKeyWordData_IO.WordCloudData != "" && this.TopKeyWordData_IO.WordCloudData != undefined) {
      if (curStartDate < new Date(this.TopKeyWordData_IO.MinStartDate) || curStartDate > new Date(this.TopKeyWordData_IO.MaxEndDate)) {
        this.DoTicketPull = true;
        this.BatchId = "";
      }
      else if (curEndDate < new Date(this.TopKeyWordData_IO.MinStartDate) || curEndDate > new Date(this.TopKeyWordData_IO.MaxEndDate)) {
        this.DoTicketPull = true;
        this.BatchId = "";
      }
    }
    else if (this.TopKeyWordData_Others != undefined && this.TopKeyWordData_Others.WordCloudData != "" && this.TopKeyWordData_Others.WordCloudData != undefined) {
      var curStartDate = new Date(startDate.year, startDate.month - 1, startDate.day);
      var curEndDate = new Date(endDate.year, endDate.month - 1, endDate.day);
      if (curStartDate < new Date(this.TopKeyWordData_Others.MinStartDate) || curStartDate > new Date(this.TopKeyWordData_Others.MaxEndDate)) {
        this.DoTicketPull = true;
        this.BatchId = "";
      }
      else if (curEndDate < new Date(this.TopKeyWordData_Others.MinStartDate) || curEndDate > new Date(this.TopKeyWordData_Others.MaxEndDate)) {
        this.DoTicketPull = true;
        this.BatchId = "";
      }
    }
    else {
      this.DoTicketPull = true;
      this.BatchId = "";
    }
  }
  getToltipForTree(deliveryConstructType: any, workstreamTypeID: any) {
    if (deliveryConstructType == "DS") {
      return "Delivery Construct Type: " + deliveryConstructType;
    }
    else if (deliveryConstructType == "DC") {
      return "Delivery Construct Type: " + deliveryConstructType;
    }
    // else if (deliveryConstructType != "EndToEnd" && workstreamTypeID != null && workstreamTypeID != 10 && workstreamTypeID != 11) {
    //   return "Delivery Construct Type: WS(AO)";
    // }
    // else {
    //   return "Delivery Construct Type: WS(IO)";
    // }
  }

  clearStagingTicketsByCloudId(FileName) {
    this.iomService.DeleteExcelFile(FileName);
  }
  
  GetLanguageCheck_Std(Language : string){
    this.textConfigFormStandard.get('ClassifiedBased').setValue('Select');
    var check_language = this.envVar.EnableLanguage ? this.selectedStdLanguage.join('|') : 'English';   
    if (check_language.includes('Chinese'))
    {
      this.LemmaDisableStd = true;
      this.EnableLemmaStd = false;
    }
    else{
      if(!(check_language.includes('English')))
      {
      this.LemmaDisableStd = false;
      }
      else 
      {
        if(this.LemmaDisableStdIO !=true) {
          this.LemmaDisableStd = false;
        }
        else{
          this.LemmaDisableStd = true;
        }
      }
    }         
    if (check_language.includes('English')){
     this.DQTenableStd = false;
    //  this.EnableRestrictDDCreation = false;
   }
    else{
    this.DQTenableStd = true;
    // this.EnableRestrictDDCreation = true;
    this.enableRestrictdd = false;
    }
    // if(this.selectedStdLanguage.join('|').includes("|"))
    // {
    //   this.lstClassifiedBy = [];
    // }
    // else{
    //   this.lstClassifiedBy = this.templstClassifiedBy;
    // }
  }
  GetLanguageCheck_AO(tab: string, resetClassified : boolean){    
    if(resetClassified){
      this.textConfigForm.get('AOGroup').get('ClassifiedBased').setValue('Select');
    }
    this.check_language_ao = this.envVar.EnableLanguage ? this.selectedLanguage_AO.join('|') : 'English';    
    this.getStopwords(tab,this.userType,this.proposalId,this.ticketType,this.check_language_ao);
    // this.iomService.getStopKeywords_standalone<any>(stopkeyWordsRequest, userType, proposalId, ticketType,Language).pipe(timeout(2400000)).subscribe(response => {
    if(this.check_language_ao.includes('Chinese'))
    {
        this.LemmaDisableAO = true;
        this.EnableLemmaAO = false;
    }
    else{
        this.LemmaDisableAO = false;
    }

    if(this.check_language_ao.includes('English')){
      this.DQTenableAO = false;
      }
      else{
      this.DQTenableAO = true;
       }

      //  if(this.selectedLanguage_AO.join('|').includes("|"))
      //  {
      //    this.lstClassifiedBy_ao = [];
      //  }
      //  else{
      //    this.lstClassifiedBy_ao = this.templstClassifiedBy_ao;
      //  }
  }

  GetLanguageCheck_IO(tab: string){    
    //this.textConfigForm.get('IOGroup').get('ClassifiedBased').setValue('Select');
    this.check_language = this.envVar.EnableLanguage ? this.selectedLanguage_IO.join('|') : 'English';
    if(this.check_language!='English'){
      if(this.selectedLanguage_IO.join('|').toString().includes('English') && this.textConfigForm.get('IOGroup').get('algorithmModel').value == 3){
        this.textConfigForm.get('IOGroup').get('algorithmModel').setValue('1');
        this.algorithmChange(false,'io', true, true, true,'');
      }
      this.prev_language = this.check_language;
    }
    else{
      if(this.selectedLanguageIO.join('|').toString().includes('English') && this.selectedLanguage_IO.length == 1){
      this.textConfigForm.get('IOGroup').get('algorithmModel').setValue('3');
      this.algorithmChange(false,'io', false, false, false,'regression');
      }
      this.prev_language = this.check_language;
    }   
   this.getStopwords(tab,this.userType,this.proposalId,this.ticketType,this.check_language);
    // this.algorithmChange(false,'io', true, true, true,'')
    if(this.selectedLanguage_IO.join('|').toString().includes('Chinese'))
    {
      this.LemmaDisableIO = true;
      this.EnableLemmaIO = false;
    }
    else{
      this.LemmaDisableIO = false;
    }
    if(this.selectedLanguage_IO.includes('English')){
      this.DQTenableIO = false;
      if(this.selectedLanguage_IO.length != 1){
        this.textConfigForm.get('IOGroup').get('algorithmModel').setValue('2');
      }
      }
      else{
      this.DQTenableIO = true;
      }
      // if(this.selectedLanguage_IO.join('|').includes("|"))
      // {
      //   this.lstClassifiedBy_io = [];
      // }
      // else{
      //   this.lstClassifiedBy_io = this.templstClassifiedBy_io;
      // }
  }

  GetLanguageCheck_Others(tab: string, resetClassified : boolean){
    if(resetClassified){
      this.textConfigForm.get('OthersGroup').get('ClassifiedBased').setValue('Select');
    }
    this.check_language_others = this.envVar.EnableLanguage ? this.selectedLanguage_Other.join('|') : 'English';        
    this.getStopwords(tab,this.userType,this.proposalId,this.ticketType,this.check_language_others);
    if(this.selectedLanguage_Other.join('|').toString().includes('Chinese'))
    {
      this.LemmaDisableOth = true;
      this.EnableLemmaOth = false;
    }
    else{
      this.LemmaDisableOth = false;
    }
    if(this.selectedLanguage_Other.includes('English')){
       this.DQTenableOth = false;
      }
      else{
      this.DQTenableOth = true;
      }

    // if(this.selectedLanguage_Other.join('|').includes("|"))
    // {
    //   this.lstClassifiedBy_others = [];
    // }
    // else{
    //   this.lstClassifiedBy_others = this.templstClassifiedBy_others;
    // }
  }

  getStopwords(tab,userType,proposalId,ticketType,Language){        
    let e2euid = this.SessionService.getE2EUId();
    if (this.isAddkeywordsEnabled_IO == false && tab == "IO") {
      return;
    }
    this.spinner.show();
    var stopkeyWordsRequest = [];
    let values: { E2EUID: string, CMSUID: string, WSUID: string, FDSType: string, Domain: string };
    if (this.selectedDC != null) {     
      this.selectedDC.forEach((x) => {
        let cmsuid = null;
        let wsuid = null;
        if (x.deliveryConstructType == "DS")
          cmsuid = x.deliveryConstructUId;
        else if (x.parentDeliveryConstructType == "DS" || (x.parentDeliveryConstructType == "CMS"))
          cmsuid = x.deliveryConstructUId;          
        if (x.deliveryConstructType == "DC" || (x.parentDeliveryConstructType == "EndToEnd" || x.parentDeliveryConstructType == "CMS"))
          wsuid = x.deliveryConstructUId;         
        if (x.deliveryConstructType == "Client" || x.deliveryConstructType == "EndToEnd") { //check
          values = {
            E2EUID: e2euid,
            CMSUID: null,
            WSUID: null,
            FDSType: (x.deliveryConstructType == "Client" || x.deliveryConstructType == "EndToEnd" || this.envVar.Env == "SAAS_ManualUpload") ? "Client" : x.deliveryConstructType,
            Domain: tab
          };
          stopkeyWordsRequest.push(values);          
        }
        else if (tab == "AO" && x.deliveryConstructType != "Client") {
          values = {
            E2EUID: e2euid,
            CMSUID: cmsuid,
            WSUID: wsuid,
            FDSType: this.envVar.Env == "SAAS_ManualUpload" ? "Client" : (wsuid == null ? "DS" : "DC"),
            Domain: tab
          };
          stopkeyWordsRequest.push(values);          
        }
        else if (tab == "IO") {
          values = {
            E2EUID: e2euid,
            CMSUID: cmsuid,
            WSUID: wsuid,
            FDSType: this.envVar.Env == "SAAS_ManualUpload" ? "Client" : (wsuid == null ? "DS" : "DC"),
            Domain: tab
          };
          stopkeyWordsRequest.push(values);         
        }
        else {
          values = {
            E2EUID: e2euid,
            CMSUID: cmsuid,
            WSUID: wsuid,
            FDSType: this.envVar.Env == "SAAS_ManualUpload" ? "Client" : (wsuid == null ? "DS" : "DC"),
            Domain: tab
          };
          stopkeyWordsRequest.push(values);         
        }
      });
      }
    this.userType = parseInt(this.SessionService.getUserType());
    // this.proposalId = this.SessionService.getE2EUId();
    var EnableLemmaVal = this.enableLemma;
    if (tab == 'AO'){
      EnableLemmaVal = this.EnableLemmaAO;
    }
    else if (tab == 'IO'){
      EnableLemmaVal = this.EnableLemmaIO;
    }
    else if (tab == 'Others'){
      EnableLemmaVal = this.EnableLemmaOth;
    }
    this.iomService.getStopKeywords<any>({ 'StopKeywords': stopkeyWordsRequest, 'userType': userType , 'proposalId': this.SessionService.getE2EUId(), 'ticketType': ticketType, 'Language': this.envVar.EnableLanguage ?  Language : 'English','IsLemmaEnabled': EnableLemmaVal ? 1:0}).pipe(timeout(2400000)).subscribe(response => {
    this.spinner.hide();
    if (tab == "AO") {
      if (response != null && response != "" && response != undefined && response.Message != "Execution Failed" && response.Message != "No Input" && response.Message != "No Service Type") {
        this.enableBox_AO = true;
        this.lstIgnoreKeys = response.toString().replace(/,\s*$/, "").trim().split(',');    
        this.lstIgnoreKeysTemp = response.toString().replace(/,\s*$/, "").trim().split(',');              
        // if(this.lstIgnoreKeys.length == 1)
        // {
        //    var ignoreKey = this.lstIgnoreKeys[0].split(',')[0];
        //    this.lstIgnoreKeys=[];
        //    this.lstIgnoreKeys.push(ignoreKey);
        // }
        this.lstIgnoreKeys = this.lstIgnoreKeys.filter(function (el) { return el; });
        this.LanguageKeywordAO = [];

        var existingstopwords = this.lstIgnoreKeys;
        if(existingstopwords.length>0)
        {
          for (var i = 0; i < existingstopwords.length; i++) {
            this.lstIgnoreKeys[i] = this.lstIgnoreKeys[i].replace(" ","");
            existingstopwords[i] = existingstopwords[i].replace(" ","");
            var Keywords = existingstopwords[i].substring(0, existingstopwords[i].indexOf('('));
            var Language = existingstopwords[i].substring(existingstopwords[i].indexOf('(')+1,existingstopwords[i].indexOf(')'));
            
            if(Keywords != ''){
            let objIndexAO = this.LanguageKeywordAO.findIndex((obj => obj.Language == Language));
              if (objIndexAO != -1) {
              var keywordsTemp: string[] = this.LanguageKeywordAO[objIndexAO].Keywords;
              keywordsTemp.push(Keywords);
              this.LanguageKeywordAO[objIndexAO].Keywords = keywordsTemp;
              }
              else{
              var keywordsTemp: string[] = [];
              keywordsTemp.push(Keywords);
              this.LanguageKeywordAO.push({ Language: Language, Keywords:keywordsTemp });
              }
            }
          }
        }
      }
      else {
        this.lstIgnoreKeys = [];
        this.LanguageKeywordAO = [];
        this.lstIgnoreKeysTemp = [];
      }
    }
    else if (tab == "IO") {
      if (response != null && response != "" && response != undefined && response.Message != "Execution Failed" && response.Message != "No Input" && response.Message != "No Service Type") {
        this.enableBox_IO = true;
        this.lstIgnoreKeys_io = response.toString().replace(/,\s*$/, "").trim().split(',');
        this.lstIgnoreKeys_ioTemp = response.toString().replace(/,\s*$/, "").trim().split(',');         
        // if(this.lstIgnoreKeys_io.length == 1)
        // {
        //   var ignoreKey = this.lstIgnoreKeys_io[0].split(',')[0];
        //    this.lstIgnoreKeys_io=[];
        //    this.lstIgnoreKeys_io.push(ignoreKey);
        // }
        this.lstIgnoreKeys_io = this.lstIgnoreKeys_io.filter(function (el) { return el; });
        this.LanguageKeywordIO = [];
        var existingstopwords=this.lstIgnoreKeys_io;
        if(existingstopwords.length>0)
        {
          for (var i = 0; i < existingstopwords.length; i++) {
            this.lstIgnoreKeys_io[i] = this.lstIgnoreKeys_io[i].replace(" ","");
            existingstopwords[i] = existingstopwords[i].replace(" ","");
            var Keywords = existingstopwords[i].substring(0, existingstopwords[i].indexOf('('));
            var Language = existingstopwords[i].substring(existingstopwords[i].indexOf('(')+1,existingstopwords[i].indexOf(')'));
            
            if(Keywords != ''){
            let objIndexAO = this.LanguageKeywordIO.findIndex((obj => obj.Language == Language));
              if (objIndexAO != -1) {
              var keywordsTemp: string[] = this.LanguageKeywordIO[objIndexAO].Keywords;
              keywordsTemp.push(Keywords);
              this.LanguageKeywordIO[objIndexAO].Keywords = keywordsTemp;
              }
              else{
              var keywordsTemp: string[] = [];
              keywordsTemp.push(Keywords);
              this.LanguageKeywordIO.push({ Language: Language, Keywords:keywordsTemp });
              }
            }
          }
        }
      }
      else {
        this.lstIgnoreKeys_io = [];
        this.lstIgnoreKeys_ioTemp = [];
        this.LanguageKeywordIO = [];
      }
    }
    else {
      if (response != null && response != "" && response != undefined && response.Message != "Execution Failed" && response.Message != "No Input" && response.Message != "No Service Type") {
        this.enableBox_Others = true;
        this.lstIgnoreKeys_others = response.toString().replace(/,\s*$/, "").trim().split(',');
        this.lstIgnoreKeys_othersTemp = response.toString().replace(/,\s*$/, "").trim().split(',');         
        // if(this.lstIgnoreKeys_others.length == 1)
        // {
        //    var ignoreKey = this.lstIgnoreKeys_others[0].split(',')[0];
        //    this.lstIgnoreKeys_others=[];
        //    this.lstIgnoreKeys_others.push(ignoreKey);
        // }
        this.lstIgnoreKeys_others = this.lstIgnoreKeys_others.filter(function (el) { return el; });
        this.LanguageKeywordOthers = [];
        var existingstopwords=this.lstIgnoreKeys_others;
        if(existingstopwords.length>0)
        {
          for (var i = 0; i < existingstopwords.length; i++) {
            this.lstIgnoreKeys_others[i] = this.lstIgnoreKeys_others[i].replace(" ","");
            existingstopwords[i] = existingstopwords[i].replace(" ","");
            var Keywords = existingstopwords[i].substring(0, existingstopwords[i].indexOf('('));
            var Language = existingstopwords[i].substring(existingstopwords[i].indexOf('(')+1,existingstopwords[i].indexOf(')'));
            
            if(Keywords != ''){
            let objIndexAO = this.LanguageKeywordOthers.findIndex((obj => obj.Language == Language));
              if (objIndexAO != -1) {
              var keywordsTemp: string[] = this.LanguageKeywordOthers[objIndexAO].Keywords;
              keywordsTemp.push(Keywords);
              this.LanguageKeywordOthers[objIndexAO].Keywords = keywordsTemp;
              }
              else{
              var keywordsTemp: string[] = [];
              keywordsTemp.push(Keywords);
              this.LanguageKeywordOthers.push({ Language: Language, Keywords:keywordsTemp });
              }
            }
          }
        }
      }
      else {
        this.lstIgnoreKeys_others = [];
        this.lstIgnoreKeys_othersTemp = [];
        this.LanguageKeywordOthers = [];
      }
    }

  });
}

HideCheckboxPopup() {
  if (this.ShowPopup == false) {
    $(".dropdown-menu .new").removeClass('show');
  }
}

ShowCheckboxPopup(tab: string) {
  if(this.ShowPopup==false){
    $(".dropdown-menu .new").addClass('show');
  }    
  this.loadValues(tab);
}

loadValues(tab: string){
  switch (tab) {
    case 'ao':
      setTimeout(() => {    
        if (this.lstFilterMappingConfig_ao != null && this.lstFilterMappingConfig_ao != undefined) {
          if(this.textConfigForm.value.AOGroup.mappingConfigs.length === this.aoArr.length + 1){
            (this.textConfigForm.get('AOGroup').get('mappingConfigs') as FormArray).controls.map(
              control => control.setValue(true));
              this.lstFilterMappingConfig_ao.forEach((x, i) => {
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
                $('#aoSearch_' + x.indexNo).prop('checked', true);
                x.isChecked = true;
              });
          }
          else{
            this.lstFilterMappingConfig_ao.filter(x => !this.aoArr.some(y => x.name === y.fullName)).map(x => x.isChecked = false);
            this.lstFilterMappingConfig_ao.filter(x => this.aoArr.some(y => x.name === y.fullName)).map(x => x.isChecked = true);
            this.lstFilterMappingConfig_ao.forEach((x, i) => {
              if (x.isChecked) {
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
                $('#aoSearch_' + x.indexNo).prop('checked', true);
                this.isClearAll = true;
              }
              else {
                this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = false;
                $('#aoSearch_' + x.indexNo).prop('checked', false);
              }
            });
          }         
        }
      }, 100);
      let allAO = this.SessionService.getSessionStorageItem("selectAllAO");
      if (allAO == "true"){
        this.textConfigForm.value.AOGroup.selectAllConfig = true;          
        $('#selectAllConfigAO').prop('checked', true);
      }
      else{
        this.textConfigForm.value.AOGroup.selectAllConfig = false;          
        $('#selectAllConfigAO').prop('checked', false);
      }
      $('#selectAllSearchAO').prop('checked', false);                        
      break;
    case 'io':
      setTimeout(() => {
        if (this.lstFilterMappingConfig_io != null && this.lstFilterMappingConfig_io != undefined) {
          if(this.textConfigForm.value.IOGroup.mappingConfigs.length === this.ioArr.length + 1){
            (this.textConfigForm.get('IOGroup').get('mappingConfigs') as FormArray).controls.map(
              control => control.setValue(true));
              this.lstFilterMappingConfig_io.forEach((x, i) => {
                this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
                $('#ioSearch_' + x.indexNo).prop('checked', true);
                x.isChecked = true;
              });
          }
          else{
          this.lstFilterMappingConfig_io.filter(x => !this.ioArr.some(y => x.name === y.fullName)).map(x => x.isChecked = false);
          this.lstFilterMappingConfig_io.filter(x => this.ioArr.some(y => x.name === y.fullName)).map(x => x.isChecked = true);
          this.lstFilterMappingConfig_io.forEach((x, i) => {
            if (x.isChecked) {
              this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
              $('#ioSearch_' + x.indexNo).prop('checked', true);
              this.isClearAll = true;
            }
            else {
              this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = false;
              $('#ioSearch_' + x.indexNo).prop('checked', false);
            }
          });
        }
        }
      }, 100);
      let allIO = this.SessionService.getSessionStorageItem("selectAllIO");
      if (allIO == "true") {
        this.textConfigForm.value.IOGroup.selectAllConfig = true;
        $('#selectAllConfigIO').prop('checked', true);
      }
      else {
        this.textConfigForm.value.IOGroup.selectAllConfig = false;          
        $('#selectAllConfigIO').prop('checked', false);
      }
      $('#selectAllSearchIO').prop('checked', false);
      break;
    case 'others':
      setTimeout(() => {
        if (this.lstFilterMappingConfig_others != null && this.lstFilterMappingConfig_others != undefined) {
          if(this.textConfigForm.value.OthersGroup.mappingConfigs.length === this.othArr.length + 1){
            (this.textConfigForm.get('OthersGroup').get('mappingConfigs') as FormArray).controls.map(
              control => control.setValue(true));
              this.lstFilterMappingConfig_others.forEach((x, i) => {
                this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
                $('#othSearch_' + x.indexNo).prop('checked', true);
                x.isChecked = true;
              });
          }
          else{
          this.lstFilterMappingConfig_others.filter(x => !this.othArr.some(y => x.name === y.fullName)).map(x => x.isChecked = false);
          this.lstFilterMappingConfig_others.filter(x => this.othArr.some(y => x.name === y.fullName)).map(x => x.isChecked = true);
          this.lstFilterMappingConfig_others.forEach((x, i) => {
            if (x.isChecked) {
              this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
              $('#othSearch_' + x.indexNo).prop('checked', true);
              this.isClearAll = true;
            }
            else {
              this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = false;
              $('#othSearch_' + x.indexNo).prop('checked', false);
            }
          });
        }
        }
      }, 100);
      let allOth = this.SessionService.getSessionStorageItem("selectAllOth");
      if (allOth == "true") {
        this.textConfigForm.value.OthersGroup.selectAllConfig = true;
        $('#selectAllConfigOth').prop('checked', true);
      }
      else {
        this.textConfigForm.value.OthersGroup.selectAllConfig = false;          
        $('#selectAllConfigOth').prop('checked', false);
      }
      $('#selectAllSearchOth').prop('checked', false);
      break;
    default:
      break;
  }
  this.ShowPopup = true;
}

loadSupportGrpName(tab: string) {
  this.isAvanced = false;    
  this.enableSearch = true;
  this.enableApply = false;
  this.isClearAll = false;
  this.enableSearchAO = false;
  this.enableSearchIO = false;
  this.enableSearchOth = false;
  switch (tab) {
    case 'ao':
      this.textConfigForm.get('AOGroup').get('searchText').setValue('');
      this.enableSearchAO = true;
      this.lstMappingConfig_ao.data.filter(x => this.lstFilterMappingConfig_ao.some(y => y.isChecked == true)).map(x => x.isChecked = true);      
      this.lstFilterMappingConfig_ao =  this.lstMappingConfig_ao.data;
      setTimeout(() => {
        if (this.lstFilterMappingConfig_ao != null && this.lstFilterMappingConfig_ao != undefined) {
          this.lstFilterMappingConfig_ao.filter(x => !this.aoArr.some(y => x.name === y.fullName)).map(x => x.isChecked = false);
          this.lstFilterMappingConfig_ao.filter(x => this.aoArr.some(y => x.name === y.fullName)).map(x => x.isChecked = true);
          this.lstFilterMappingConfig_ao.forEach((x, i) => {
            if (x.isChecked) {
              this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
              $('#aoSearch_' + x.indexNo).prop('checked', true);
              this.isClearAll = true;
            }
            else {
              this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = false;
              $('#aoSearch_' + x.indexNo).prop('checked', false);
            }
          });
        }
      }, 100);
      break;
    case 'io':
      this.textConfigForm.get('IOGroup').get('searchText').setValue('');
      this.enableSearchIO = true;
      this.lstMappingConfig_io.data.filter(x => this.lstFilterMappingConfig_io.some(y => y.isChecked == true)).map(x => x.isChecked = true);      
      this.lstFilterMappingConfig_io =  this.lstMappingConfig_io.data;
      setTimeout(() => {
        if (this.lstFilterMappingConfig_io != null && this.lstFilterMappingConfig_io != undefined) {
          this.lstFilterMappingConfig_io.filter(x => !this.ioArr.some(y => x.name === y.fullName)).map(x => x.isChecked = false);
          this.lstFilterMappingConfig_io.filter(x => this.ioArr.some(y => x.name === y.fullName)).map(x => x.isChecked = true);
          this.lstFilterMappingConfig_io.forEach((x, i) => {
            if (x.isChecked) {
              this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
              $('#ioSearch_' + x.indexNo).prop('checked', true);
              this.isClearAll = true;
            }
            else {
              this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = false;
              $('#ioSearch_' + x.indexNo).prop('checked', false);
            }
          });
        }
      }, 100);
      break;
    case 'others':
      this.textConfigForm.get('OthersGroup').get('searchText').setValue('');
      this.enableSearchOth = true;
      this.lstMappingConfig_others.data.filter(x => this.lstFilterMappingConfig_others.some(y => y.isChecked == true)).map(x => x.isChecked = true);      
      this.lstFilterMappingConfig_others =  this.lstMappingConfig_others.data;
      setTimeout(() => {
        if (this.lstFilterMappingConfig_others != null && this.lstFilterMappingConfig_others != undefined) {
          this.lstFilterMappingConfig_others.filter(x => !this.othArr.some(y => x.name === y.fullName)).map(x => x.isChecked = false);
          this.lstFilterMappingConfig_others.filter(x => this.othArr.some(y => x.name === y.fullName)).map(x => x.isChecked = true);
          this.lstFilterMappingConfig_others.forEach((x, i) => {
            if (x.isChecked) {
              this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
              $('#othSearch_' + x.indexNo).prop('checked', true);
              this.isClearAll = true;
            }
            else {
              this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = false;
              $('#othSearch_' + x.indexNo).prop('checked', false);
            }
          });
        }
      }, 100);
      break;
    default:
      break;
  }
  setTimeout(() => {
    this.loadValues(tab);
  }, 100);
}

  ApplyChanges(tab: string) {
    let all;
    let count;
    switch (tab) {
      case 'ao':        
        $('#selectAllSearchAO').prop('checked', false);
        this.selectedSearchAllAoId.nativeElement.checked = false;
        this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
        this.textConfigForm.get('AOGroup').get('searchText').setValue('');
        count = this.lstFilterMappingConfig_ao.length - 1;
        this.lstFilterMappingConfig_ao = this.lstMappingConfig_ao.data;
        this.searchcheck_ao = true;
        var sao: any = '';
        
        if (this.lstFilterMappingConfig_ao != null) {
          this.lstFilterMappingConfig_ao.forEach((x, i) => {
            if (x.isChecked)
              sao += sao == '' ? x.name : ',' + x.name;
          });
        }

        if(count == 0 && sao == 'All'){
          sao = 'All';
        }

        if (sao != '' && sao != undefined) {          
          bootbox.alert('Selected values has been Applied Successfully');
          this.CancelSearch('ao');
        }
        else if(count == 0){
          bootbox.alert('Entered text is not relevant to the available values');
          break;
        }
        else {
          bootbox.alert('Please select atleast one value');
          break;
        }
        setTimeout(() => {
          this.loadValues(tab);          
          sao = '';
          this.aoArr = [];
          if (this.lstFilterMappingConfig_ao != null) {
            this.lstFilterMappingConfig_ao.forEach((x, i) => {              
                if (x.isChecked){
                  if(x.name != 'All'){
                  sao += sao == '' ? x.name : ',' + x.name;
                  this.aoArr.push({
                    name: x.name.length > 15 ? x.name.substring(0, 15) + '...' : x.name,
                    fullName: x.name
                  })  
                }  
                else{
                  sao = 'All';
                }                               
              }            
            });
          }  
          if ((sao !== '' && sao !== undefined) && (this.textConfigForm.value.AOGroup.mappingConfigs.length - 1) === sao.split(',').filter(value => value !== 'All').length) {
            all = true;
          }
          if(all){
            sao = 'All';
            this.SessionService.setSessionStorageItem("selectAllAO","true");
          }
          else{
            this.SessionService.setSessionStorageItem("selectAllAO","false");
            if(count == 0 && sao == 'All'){
              this.SessionService.setSessionStorageItem("selectAllAO","true");
              this.aoArr.push({
                name: 'All',
                fullName: 'All'
              })  
              sao = 'All';
            } 
          }
          this.selectedSupportGroup_AO = sao;
        }, 100);
        break;
      case 'io':        
        $('#selectAllSearchIO').prop('checked', false);
        this.selectedSearchAllIoId.nativeElement.checked = false;
        this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;
        this.textConfigForm.get('IOGroup').get('searchText').setValue('');
        count = this.lstFilterMappingConfig_io.length - 1;
        this.lstFilterMappingConfig_io = this.lstMappingConfig_io.data;
        this.searchcheck_io = true;
        var sio: any = '';
        if (this.lstFilterMappingConfig_io != null) {
          this.lstFilterMappingConfig_io.forEach((x, i) => {
            if (x.isChecked)
            sio += sio == '' ? x.name : ',' + x.name;
          });
        }
        if (count == 0 && sio == 'All') {
          sio = 'All';
        }
        if (sio != '' && sio != undefined) {          
          bootbox.alert('Selected values has been Applied Successfully');
          this.CancelSearch('io');
        }
        else if(count == 0){
          bootbox.alert('Entered text is not relevant to the available values');
          break;
        }
        else {
          bootbox.alert('Please select atleast one value');
          break;
        }
        setTimeout(() => {
          this.loadValues(tab);
          sio = '';
          this.ioArr = [];
          if (this.lstFilterMappingConfig_io != null) {
            this.lstFilterMappingConfig_io.forEach((x, i) => {
              if (x.isChecked){
                if(x.name != 'All'){
                  sio += sio == '' ? x.name : ',' + x.name;
                  this.ioArr.push({
                    name: x.name.length > 15 ? x.name.substring(0, 15) + '...' : x.name,
                    fullName: x.name
                  }) 
                  }                
                  else{
                    sio = 'All';
                  }   
              }
            });
          }
          if ((sio !== '' && sio !== undefined) && (this.textConfigForm.value.IOGroup.mappingConfigs.length - 1) === sio.split(',').filter(value => value !== 'All').length) {
            all = true;
          }
          if (all) {
            sio = 'All';
            this.SessionService.setSessionStorageItem("selectAllIO", "true");
          }
          else {
            this.SessionService.setSessionStorageItem("selectAllIO", "false");
            if (count == 0 && sio == 'All') {
              this.SessionService.setSessionStorageItem("selectAllIO", "true");
              this.ioArr.push({
                name: 'All',
                fullName: 'All'
              })
              sio = 'All';
            } 
          }
          this.selectedSupportGroup_IO = sio;
        }, 100);
        break;
      case 'others':        
        $('#selectAllSearchOth').prop('checked', false);
        this.selectedSearchAllOthersId.nativeElement.checked = false;  //chk
        this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;
        this.textConfigForm.get('OthersGroup').get('searchText').setValue('');
        count = this.lstFilterMappingConfig_others.length - 1;
        this.lstFilterMappingConfig_others = this.lstMappingConfig_others.data;
        this.searchcheck_others = true;
        var sothers: any = '';
        if (this.lstFilterMappingConfig_others != null) {
          this.lstFilterMappingConfig_others.forEach((x, i) => {
            if (x.isChecked)
            sothers += sothers == '' ? x.name : ',' + x.name;
          });
        }
        if (count == 0 && sothers == 'All') {
          sothers = 'All';
        }
        if (sothers != '' && sothers != undefined) {          
          bootbox.alert('Selected values has been Applied Successfully');
          this.CancelSearch('others');
        }
        else if(count == 0){
          bootbox.alert('Entered text is not relevant to the available values');
          break;
        }
        else {
          bootbox.alert('Please select atleast one value');
          break;
        }
        setTimeout(() => {
          this.loadValues(tab);
          sothers = '';
          this.othArr = [];
          if (this.lstFilterMappingConfig_others != null) {
            this.lstFilterMappingConfig_others.forEach((x, i) => {
              if (x.isChecked){
                if(x.name != 'All'){
                  sothers += sothers == '' ? x.name : ',' + x.name;
                  this.othArr.push({
                    name: x.name.length > 15 ? x.name.substring(0, 15) + '...' : x.name,
                    fullName: x.name                               
                  }) 
                }
                else{
                  sothers = 'All';
                }      
              }
            });
          }
          if ((sothers !== '' && sothers !== undefined) && (this.textConfigForm.value.OthersGroup.mappingConfigs.length - 1) === sothers.split(',').filter(value => value !== 'All').length) {
            all = true;
          }
          if (all) {
            sothers = 'All';
            this.SessionService.setSessionStorageItem("selectAllOth", "true");
          }
          else {
            this.SessionService.setSessionStorageItem("selectAllOth", "false");
            if (count == 0 && sothers == 'All') {
              this.SessionService.setSessionStorageItem("selectAllOth", "true");
              this.othArr.push({
                name: 'All',
                fullName: 'All'
              })
              sothers = 'All';
            } 
          }
          this.selectedSupportGroup_Others = sothers;
        }, 100);
        break;
      default:
        break;
    }
  }


  CancelSearch(tab: string) {
  $(".select-domain").show();  
  $(".suportgrp-section").hide();
  this.enableApply = false;
  this.isClearAll = false;
  this.enableSearch = false;
  this.isAvanced = true;  
  this.lstFilterMappingConfig_aoSearch = null;
  this.lstFilterMappingConfig_ioSearch = null;
  this.lstFilterMappingConfig_othSearch = null;
  let allAO = this.SessionService.getSessionStorageItem("selectAllAO");
    if(allAO == "true"){
      this.textConfigForm.value.AOGroup.selectAllConfig = true;          
      $('#selectAllConfigAO').prop('checked', true);
    }
    else{
      this.textConfigForm.value.AOGroup.selectAllConfig = false;
      $('#selectAllSearchAO').prop('checked', false);
      $('#selectAllConfigAO').prop('checked', false);
    }
    let allIO = this.SessionService.getSessionStorageItem("selectAllIO");
    if (allIO == "true") {
      this.textConfigForm.value.IOGroup.selectAllConfig = true;
      $('#selectAllConfigIO').prop('checked', true);
    }
    else {
      this.textConfigForm.value.IOGroup.selectAllConfig = false;
      $('#selectAllSearchIO').prop('checked', false);
      $('#selectAllConfigIO').prop('checked', false);
    }
    let allOth = this.SessionService.getSessionStorageItem("selectAllOth");
    if (allOth == "true") {
      this.textConfigForm.value.OthersGroup.selectAllConfig = true;
      $('#selectAllConfigOth').prop('checked', true);
    }
    else {
      this.textConfigForm.value.OthersGroup.selectAllConfig = false;
      $('#selectAllSearchOth').prop('checked', false);
      $('#selectAllConfigOth').prop('checked', false);
    }
    setTimeout(() => {
      this.loadValues(tab);  
    },100) 
}

selectAllSearchConfig(tab: string) {
  this.ShowPopup = false;
  let all;
  switch (tab) {
    case 'ao':
      all = this.textConfigForm.value.AOGroup.selectAllSearchConfig;
      if (all) {
        if (this.textConfigForm.value.AOGroup.searchText == "") {

        }
        else {
          if (this.lstFilterMappingConfig_aoSearch != null && this.lstFilterMappingConfig_aoSearch != undefined) {
            this.lstFilterMappingConfig_ao.forEach((x, i) => {
              this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = true;
              $('#aoSearch_' + x.indexNo).prop('checked', true);
              x.isChecked = true;
            });
          }
        }
      }
      else {
        if (this.lstFilterMappingConfig_aoSearch != null && this.lstFilterMappingConfig_aoSearch != undefined) {
          this.lstFilterMappingConfig_ao.forEach((x, i) => {
            this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = false;
            $('#aoSearch_' + x.indexNo).prop('checked', false);
            x.isChecked = false;
          });            
        }
      }

      var sao: any = '';
      if (this.lstFilterMappingConfig_aoSearch != null) {
        this.lstFilterMappingConfig_aoSearch.forEach((x, i) => {
          sao += sao == '' ? x.name : ',' + x.name;
        });
      }

      if (sao !== '' && sao !== undefined && this.enableSearchAO == true) {
        this.enableApply = true;
        this.isClearAll = false;
      }
      break;
    case 'io':
      all = this.textConfigForm.value.IOGroup.selectAllSearchConfig;
      if (all) {
        if (this.textConfigForm.value.IOGroup.searchText == "") {

        }
        else {
          if (this.lstFilterMappingConfig_ioSearch != null && this.lstFilterMappingConfig_ioSearch != undefined) {
            this.lstFilterMappingConfig_io.forEach((x, i) => {
              this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = true;
              $('#ioSearch_' + x.indexNo).prop('checked', true);
              x.isChecked = true;
            });
          }
        }
      }
      else {
        if (this.lstFilterMappingConfig_ioSearch != null && this.lstFilterMappingConfig_ioSearch != undefined) {
          this.lstFilterMappingConfig_io.forEach((x, i) => {
            this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = false;
            $('#ioSearch_' + x.indexNo).prop('checked', false);
            x.isChecked = false;
          });            
        }
      }

      var sio: any = '';
      if (this.lstFilterMappingConfig_ioSearch != null) {
        this.lstFilterMappingConfig_ioSearch.forEach((x, i) => {
          sio += sio == '' ? x.name : ',' + x.name;
        });
      }

      if (sio !== '' && sio !== undefined && this.enableSearchIO == true) {
        this.enableApply = true;
        this.isClearAll = true;
      }
      break;
    case 'others':
      all = this.textConfigForm.value.OthersGroup.selectAllSearchConfig;
      if (all) {
        if (this.textConfigForm.value.OthersGroup.searchText == "") {

        }
        else {
          if (this.lstFilterMappingConfig_othSearch != null && this.lstFilterMappingConfig_othSearch != undefined) {
            this.lstFilterMappingConfig_others.forEach((x, i) => {
              this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = true;
              $('#othSearch_' + x.indexNo).prop('checked', true);
              x.isChecked = true;
            });
          }
        }
      }
      else {
        if (this.lstFilterMappingConfig_othSearch != null && this.lstFilterMappingConfig_othSearch != undefined) {
          this.lstFilterMappingConfig_others.forEach((x, i) => {
            this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = false;
            $('#othSearch_' + x.indexNo).prop('checked', false);
            x.isChecked = false;
          });           
        }
      }
      var sothers: any = '';
      if (this.lstFilterMappingConfig_othSearch != null) {
        this.lstFilterMappingConfig_othSearch.forEach((x, i) => {
          sothers += sothers == '' ? x.name : ',' + x.name;
        });
      }

      if (sothers !== '' && sothers !== undefined && this.enableSearchOth == true) {
        this.enableApply = true;
        this.isClearAll = true;
      }
      break;
    default:
      break;
  }

}

ClearAllvalues(tab: string) {       
  switch (tab) {
    case 'ao':
      this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
      $('#selectAllSearchAO').prop('checked', false);
      this.textConfigForm.get('AOGroup').get('searchText').setValue('');
      this.lstFilterMappingConfig_ao = this.lstMappingConfig_ao.data;
      this.lstFilterMappingConfig_ao.forEach((x, i) => {
        this.textConfigForm.value.AOGroup.mappingConfigs[x.indexNo] = false;
        $('#aoSearch_' + x.indexNo).prop('checked', false);
        x.isChecked = false;
      });
      this.lstFilterMappingConfig_aoSearch = null;
      this.selectedSupportGroup_AO = 'Select ' + this.lstMappingConfig_ao.FilterName;
      this.SessionService.setSessionStorageItem("selectAllAO","false");
      this.selectedAllAoId.nativeElement.checked = false;
      this.textConfigForm.value.AOGroup.selectAllConfig = false;
      break;
    case 'io':
      this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;
      $('#selectAllSearchIO').prop('checked', false);
      this.textConfigForm.get('IOGroup').get('searchText').setValue('');
      this.lstFilterMappingConfig_io = this.lstMappingConfig_io.data;
      this.lstFilterMappingConfig_io.forEach((x, i) => {          
        this.textConfigForm.value.IOGroup.mappingConfigs[x.indexNo] = false;
        $('#ioSearch_' + x.indexNo).prop('checked', false);
        x.isChecked = false;
      });
      this.lstFilterMappingConfig_ioSearch = null;
      this.selectedSupportGroup_IO = 'Select ' + this.lstMappingConfig_io.FilterName;
      this.SessionService.setSessionStorageItem("selectAllIO", "false");
      this.selectedAllIoId.nativeElement.checked = false;
      this.textConfigForm.value.IOGroup.selectAllConfig = false;
      break;
    case 'others':
      this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;
      $('#selectAllSearchOth').prop('checked', false);
      this.textConfigForm.get('OthersGroup').get('searchText').setValue('');
      this.lstFilterMappingConfig_others = this.lstMappingConfig_others.data;
      this.lstFilterMappingConfig_others.forEach((x, i) => {          
        this.textConfigForm.value.OthersGroup.mappingConfigs[x.indexNo] = false;
        $('#othSearch_' + x.indexNo).prop('checked', false);
        x.isChecked = false;
      });
      this.lstFilterMappingConfig_othSearch = null;
      this.selectedSupportGroup_Others = 'Select ' + this.lstMappingConfig_others.FilterName;
      this.SessionService.setSessionStorageItem("selectAllOth", "false");
      this.selectedAllOthersId.nativeElement.checked = false;
      this.textConfigForm.value.OthersGroup.selectAllConfig = false;
      break;
    default:
      break;
  } 
  this.aoArr = [];
  this.ioArr = [];
  this.othArr = [];
  //this.CancelSearch();
}

selectConfigSearch(tab: string, value: string) {
  let all;
  let text;
  this.ShowPopup = false;
  switch (tab) {
    case 'ao':
      var sao: any = '';       
        this.lstFilterMappingConfig_ao.forEach((x, i) => {
          if (x.name == value) {
            x.isChecked = x.isChecked == false ? true : false;
          }
          if (x.isChecked)
            sao += sao == '' ? x.name : ',' + x.name;
        }); 
        
      if (sao.split(',').length == this.textConfigForm.value.AOGroup.mappingConfigs.length) {

      }
      text = this.textConfigForm.value.AOGroup.searchText != undefined && this.textConfigForm.value.AOGroup.searchText != '' ? this.textConfigForm.value.AOGroup.searchText.toString().toLowerCase().trim() : '';
      if ((sao !== '' && sao !== undefined) && (this.textConfigForm.value.AOGroup.mappingConfigs.length - 1) === sao.split(',').filter(value => value !== 'All').length) {
        this.selectedAllAoId.nativeElement.checked = true;
        this.searchcheck_ao = true;
        $(".dropdown-menu .new").removeClass('show');                  
        this.textConfigForm.value.AOGroup.selectAllConfig = true;
        this.SessionService.setSessionStorageItem("selectAllAO","true");          
        if(text != ""){
          this.selectedSearchAllAoId.nativeElement.checked = true;            
          this.textConfigForm.value.AOGroup.selectAllSearchConfig = true;           
        }
        else{
          this.selectedSearchAllAoId.nativeElement.checked = false;            
          this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;   
        }
    }
    else{
      this.selectedAllAoId.nativeElement.checked = false;
      this.SessionService.setSessionStorageItem("selectAllAO","false");
      this.textConfigForm.value.AOGroup.selectAllConfig = false;
    }

      if(this.lstFilterMappingConfig_aoSearch != null && this.lstFilterMappingConfig_aoSearch != undefined){
        if ((sao !== '' && sao !== undefined) && this.lstFilterMappingConfig_aoSearch.length === sao.split(',').filter(value => value !== 'All').length) {
          if(text != ""){
            this.textConfigForm.value.AOGroup.selectAllSearchConfig = true;
            this.selectedSearchAllAoId.nativeElement.checked = true;
            this.searchcheck_ao = true;
          }
         else {
          this.selectedSearchAllAoId.nativeElement.checked = false;
          this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
        }
      }
      else{
        this.selectedSearchAllAoId.nativeElement.checked = false;          
        this.textConfigForm.value.AOGroup.selectAllSearchConfig = false;
      }  
      }
      if (sao !== '' && sao !== undefined && this.enableSearchAO == true) {
        this.enableApply = true;
        this.isClearAll = true;
      }        
      break;
    case 'io':
      var sio: any = '';
        this.lstFilterMappingConfig_io.forEach((x, i) => {
          if (x.name == value) {
            x.isChecked = x.isChecked == false ? true : false;
          }
          if (x.isChecked)
            sio += sio == '' ? x.name : ',' + x.name;
        });

      if (sio.split(',').length == this.textConfigForm.value.IOGroup.mappingConfigs.length) {
        this.searchcheck_io = true;
      }
      text = this.textConfigForm.value.IOGroup.searchText != undefined && this.textConfigForm.value.IOGroup.searchText != '' ? this.textConfigForm.value.IOGroup.searchText.toString().toLowerCase().trim() : '';
      if ((sio !== '' && sio !== undefined) && (this.textConfigForm.value.IOGroup.mappingConfigs.length - 1) === sio.split(',').filter(value => value !== 'All').length) {
        this.selectedAllIoId.nativeElement.checked = true;        
        $(".dropdown-menu .new").removeClass('show');
        this.textConfigForm.value.IOGroup.selectAllConfig = true;
        this.SessionService.setSessionStorageItem("selectAllIO", "true");          
        if(text != ""){
          this.selectedSearchAllIoId.nativeElement.checked = true;            
          this.textConfigForm.value.IOGroup.selectAllSearchConfig = true;           
        }
        else{
          this.selectedSearchAllIoId.nativeElement.checked = false;            
          this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;   
        }
    }
    else{
      this.selectedAllIoId.nativeElement.checked = false;
      this.textConfigForm.value.IOGroup.selectAllConfig = false;          
      this.SessionService.setSessionStorageItem("selectAllIO", "false");
    }
      if(this.lstFilterMappingConfig_ioSearch != null && this.lstFilterMappingConfig_ioSearch != undefined){
        if ((sio !== '' && sio !== undefined) && this.lstFilterMappingConfig_ioSearch.length === sio.split(',').filter(value => value !== 'All').length) {
          if (text != "") {
            this.textConfigForm.value.IOGroup.selectAllSearchConfig = true;
            this.selectedSearchAllIoId.nativeElement.checked = true;
            this.searchcheck_io = true;
          }
         else {
          this.selectedSearchAllIoId.nativeElement.checked = false;
          this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;
        }
      }
      else{
        this.selectedSearchAllIoId.nativeElement.checked = false;
        this.textConfigForm.value.IOGroup.selectAllSearchConfig = false;
      }
      }
      if (sio !== '' && sio !== undefined && this.enableSearchIO == true) {
        this.enableApply = true;
        this.isClearAll = true;
      }
      break;
    case 'others':
      var sothers: any = '';
        this.lstFilterMappingConfig_others.forEach((x, i) => {
          if (x.name == value) {
            x.isChecked = x.isChecked == false ? true : false;
          }
          if (x.isChecked)
            sothers += sothers == '' ? x.name : ',' + x.name;
        });
      if (sothers.split(',').length == this.textConfigForm.value.OthersGroup.mappingConfigs.length) {
        this.searchcheck_others = true;
      } 
      text = this.textConfigForm.value.OthersGroup.searchText != undefined && this.textConfigForm.value.OthersGroup.searchText != '' ? this.textConfigForm.value.OthersGroup.searchText.toString().toLowerCase().trim() : '';
      if ((sothers !== '' && sothers !== undefined) && (this.textConfigForm.value.OthersGroup.mappingConfigs.length - 1) === sothers.split(',').filter(value => value !== 'All').length) {
        this.selectedAllOthersId.nativeElement.checked = true;        
        $(".dropdown-menu .new").removeClass('show');
        this.textConfigForm.value.OthersGroup.selectAllConfig = true;
        this.SessionService.setSessionStorageItem("selectAllOth", "true");          
        if(text != ""){
          this.selectedSearchAllOthersId.nativeElement.checked = true;            
          this.textConfigForm.value.OthersGroup.selectAllSearchConfig = true;           
        }
        else{
          this.selectedSearchAllOthersId.nativeElement.checked = false;            
          this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;   
        }
    }
    else{
      this.selectedAllOthersId.nativeElement.checked = false;
      this.textConfigForm.value.OthersGroup.selectAllConfig = false;
      this.SessionService.setSessionStorageItem("selectAllOth", "false");
    }
      if(this.lstFilterMappingConfig_othSearch != null && this.lstFilterMappingConfig_othSearch != undefined){
        if ((sothers !== '' && sothers !== undefined) && this.lstFilterMappingConfig_othSearch.length === sothers.split(',').filter(value => value !== 'All').length) {
          if (text != "") {
            this.textConfigForm.value.OthersGroup.selectAllSearchConfig = true;
            this.selectedSearchAllOthersId.nativeElement.checked = true;
            this.searchcheck_others = true;
          }
         else {
          this.selectedSearchAllOthersId.nativeElement.checked = false;
          this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;
        }
      }
      else{
        this.selectedSearchAllOthersId.nativeElement.checked = false;
        this.textConfigForm.value.OthersGroup.selectAllSearchConfig = false;
      }
      }

      if (sothers !== '' && sothers !== undefined && this.enableSearchOth == true) {
        this.enableApply = true;
        this.isClearAll = true;
      }
      break;
    default:
      break;
  }
}

GetQualifiedDescription(tab: string) {
this.isQualifiedDescEnabled = false;
if(this.isQualifiedDescEnabled_AO == null)
{
  this.isQualifiedDescEnabled_AO = false;
}

if(this.isQualifiedDescEnabled_IO == null)
{
  this.isQualifiedDescEnabled_IO = false;
}

if(this.isQualifiedDescEnabled_Others == null)
{
  this.isQualifiedDescEnabled_Others = false;
}
this.UserOption = 2;
if(tab=='NA')
{
 this.UserOption = 1;
if(!this.ValidateFormStandardQualified())
{
  this.textConfigFormStandard.get('ClassifiedBased').setValue('Select');
  return false;
}
if (this.textConfigFormStandard.value.ClassifiedBased == 'Select' || this.textConfigFormStandard.value.ClassifiedBased == '' || this.textConfigFormStandard.value.ClassifiedBased == undefined) {
  bootbox.alert('Please select Classified Based on.');
   return false;
}
if (this.textConfigFormStandard.value.ClassifiedBased == 'Short Description' || this.textConfigFormStandard.value.ClassifiedBased == 'Resolution Description' || this.textConfigFormStandard.value.ClassifiedBased == 'Long Description') {
  this.isQualifiedDescEnabled = true;
 return false;
}
}
else if((tab!='NA'))
{
if (!this.ValidateFormForTopKeyWords(tab)) 
{
  if(tab=='AO')
  {
    this.textConfigForm.get('AOGroup').get('ClassifiedBased').setValue('Select');
  }
  else if(tab=='IO')
  {
    this.textConfigForm.get('IOGroup').get('ClassifiedBased').setValue('Select');
  }
  else{
    this.textConfigForm.get('OthersGroup').get('ClassifiedBased').setValue('Select');
  }
  return false;
}
else{
  if(tab=='AO')
  {
    //this.textConfigForm.get('AOGroup').get('ClassifiedBased').setValue('Select');
    if (this.textConfigForm.value.AOGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.AOGroup.ClassifiedBased == '' || this.textConfigForm.value.AOGroup.ClassifiedBased == undefined) {
      bootbox.alert('Please select Classified Based on for Apps.');
      return false;
    }
    if (this.textConfigForm.value.AOGroup.ClassifiedBased == 'Short Description' || this.textConfigForm.value.AOGroup.ClassifiedBased == 'Resolution Description' || this.textConfigForm.value.AOGroup.ClassifiedBased == 'Long Description') {
      this.isQualifiedDescEnabled_AO = true;
     return false;
    }
  }
  else if(tab=='IO')
  {
    //this.textConfigForm.get('IOGroup').get('ClassifiedBased').setValue('Select');
    if (this.textConfigForm.value.IOGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.IOGroup.ClassifiedBased == '' || this.textConfigForm.value.IOGroup.ClassifiedBased == undefined) {
      bootbox.alert('Please select Classified Based on for Infra.');
      return false;
    }
    if (this.textConfigForm.value.IOGroup.ClassifiedBased == 'Short Description' || this.textConfigForm.value.IOGroup.ClassifiedBased == 'Resolution Description' || this.textConfigForm.value.IOGroup.ClassifiedBased == 'Long Description') {
      this.isQualifiedDescEnabled_IO = true;
     return false;
    }
  }
  else{
    //this.textConfigForm.get('OthersGroup').get('ClassifiedBased').setValue('Select');
    if (this.textConfigForm.value.OthersGroup.ClassifiedBased == 'Select' || this.textConfigForm.value.OthersGroup.ClassifiedBased == '' || this.textConfigForm.value.OthersGroup.ClassifiedBased == undefined) {
      bootbox.alert('Please select Classified Based on for Others.');
      return false;
    }
    if (this.textConfigForm.value.OthersGroup.ClassifiedBased == 'Short Description' || this.textConfigForm.value.OthersGroup.ClassifiedBased == 'Resolution Description' || this.textConfigForm.value.OthersGroup.ClassifiedBased == 'Long Description') {
      this.isQualifiedDescEnabled_Others = true;
     return false;
    }
  }
}
}
switch (tab) {  
      case 'AO':
        var ticketType;
        var ApplicationName;
        this.ChartData_AO = null;
        if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
          ticketType = this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType;
        else
          ticketType = this.textConfigForm.value.AOGroup.ticketTypeMulti
            .map((checked, index) => checked ? this.lstTicketType_ao[index].ServiceType : null)
            .filter(value => value !== null).join('~^~');
        if (this.envVar.ClientConfiguration.isMultiSelectAppName == false)
          // ApplicationName = this.aoAnalytics.applicationName = this.textConfigForm.value.AOGroup.appType == 'Select' ? '' : this.textConfigForm.value.AOGroup.appType;
          ApplicationName = 'All';
        else
          ApplicationName = this.aoAnalytics.applicationName = this.textConfigForm.value.AOGroup.applicationType
            .map((checked, index) => checked ? this.lstapplication_ao[index].name : null)
            .filter(value => value !== null).join('~^~');
        this.topKeyWord_AO = new TopKeyWordsFilter(this.BatchId, false,
          this.textConfigForm.value.AOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.startDate) : '',
          this.textConfigForm.value.AOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.AOGroup.endDate) : '',
          this.textConfigForm.value.AOGroup.topWordOption,
          tab,
          this.textConfigForm.value.AOGroup.ClassifiedBased,
          
          ticketType,
          //this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType,
          this.textConfigForm.value.AOGroup.mappingConfigs
            .map((checked, index) => checked ? this.lstMappingConfig_ao.data[index].name : null)
            .filter(value => value !== null).join('~^~'),
          this.selectedDC, "SupportGroupName", this.lstIgnoreKeys?.join(), ApplicationName,this.envVar.EnableLanguage ?  this.selectedLanguage_AO.join('|') : 'English');
        break;
      case 'IO':
        var ticketType;
        var ApplicationName;
        this.ChartData_IO = null;
        if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
          ticketType = this.textConfigForm.value.IOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.IOGroup.ticketType;
        else
          ticketType = this.textConfigForm.value.IOGroup.ticketTypeMulti
            .map((checked, index) => checked ? this.lstTicketType_io[index].ServiceType : null)
            .filter(value => value !== null).join('~^~');
        if (this.envVar.ClientConfiguration.isMultiSelectAppName == false)
          // ApplicationName = this.ioAnalytics.applicationName = this.textConfigForm.value.IOGroup.appType == 'Select' ? '' : this.textConfigForm.value.IOGroup.appType;
          ApplicationName = 'All';
        else
          ApplicationName = this.ioAnalytics.applicationName = this.textConfigForm.value.IOGroup.applicationType
            .map((checked, index) => checked ? this.lstapplication_io[index].name : null)
            .filter(value => value !== null).join('~^~');
        this.topKeyWord_IO = new TopKeyWordsFilter(this.BatchId, false,
          this.textConfigForm.value.IOGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.startDate) : '',
          this.textConfigForm.value.IOGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.IOGroup.endDate) : '',
          this.textConfigForm.value.IOGroup.topWordOption,
          tab,
          this.textConfigForm.value.IOGroup.ClassifiedBased,
          
          ticketType,
          this.textConfigForm.value.IOGroup.mappingConfigs
            .map((checked, index) => checked ? this.lstMappingConfig_io.data[index].name : null)
            .filter(value => value !== null).join('~^~'),
          this.selectedDC, "SupportGroupName", this.lstIgnoreKeys_io?.join(), ApplicationName,this.envVar.EnableLanguage ?  this.selectedLanguage_IO.join('|') : 'English' );
        break;
      case 'OTHERS':
        var ticketType;
        var ApplicationName;
        this.ChartData_Others = null;
        if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false)
          ticketType = this.textConfigForm.value.OthersGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.ticketType;
        else
          ticketType = this.textConfigForm.value.OthersGroup.ticketTypeMulti
            .map((checked, index) => checked ? this.lstTicketType_others[index].ServiceType : null)
            .filter(value => value !== null).join('~^~');
        if (this.envVar.ClientConfiguration.isMultiSelectAppName == false)
          // ApplicationName = this.othersAnalytics.applicationName = this.textConfigForm.value.OthersGroup.appType == 'Select' ? '' : this.textConfigForm.value.OthersGroup.appType;
          ApplicationName = 'All';
        else
          ApplicationName = this.othersAnalytics.applicationName = this.textConfigForm.value.OthersGroup.applicationType
            .map((checked, index) => checked ? this.lstapplication_others[index].name : null)
            .filter(value => value !== null).join('~^~');
        this.topKeyWord_Others = new TopKeyWordsFilter(this.BatchId, false,
          this.textConfigForm.value.OthersGroup.startDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.startDate) : '',
          this.textConfigForm.value.OthersGroup.endDate != '' ? JSON.stringify(this.textConfigForm.value.OthersGroup.endDate) : '',
          this.textConfigForm.value.OthersGroup.topWordOption,
          tab,
          this.textConfigForm.value.OthersGroup.ClassifiedBased,
          
          ticketType,
          this.textConfigForm.value.OthersGroup.mappingConfigs
            .map((checked, index) => checked ? this.lstMappingConfig_others.data[index].name : null)
            .filter(value => value !== null).join('~^~'),
          this.selectedDC, "SupportGroupName", this.lstIgnoreKeys_others?.join(),
          ApplicationName,this.envVar.EnableLanguage ?  this.selectedLanguage_Other.join('|') : 'English' );
        break;
      case 'NA':
        var ticketType;
        var ApplicationName;
        ticketType = this.textConfigFormStandard.value.ticketType == 'Select' ? '' : this.textConfigFormStandard.value.ticketType;
        this.topKeyWordStd = new TopKeyWordsFilter(this.BatchId, false,
          this.textConfigFormStandard.value.startDate != '' ? JSON.stringify(this.textConfigFormStandard.value.startDate) : '',
          this.textConfigFormStandard.value.endDate != '' ? JSON.stringify(this.textConfigFormStandard.value.endDate) : '',
          50,
          'Others',
          this.textConfigFormStandard.value.ClassifiedBased,
          ticketType,
          //this.textConfigForm.value.AOGroup.ticketType == 'Select' ? '' : this.textConfigForm.value.AOGroup.ticketType,
          '',
          this.selectedDC, "SupportGroupName", '', ApplicationName, this.envVar.EnableLanguage ?  this.selectedStdLanguage.join('|') : 'English');
        break;
    }

    if (tab == "NA") {
      // this.checkMinMaxDate();
      let stopwords = '';
      this.spinner.show();
      this.DoTicketPull = true
      this.iomService.GetQualifiedDescription(this.SessionService.getUserName(), "NA", this.UserOption, this.SessionService.getE2EUId(), this.topKeyWordStd, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, parseInt(this.SessionService.getUserType()), stopwords, ApplicationName,this.EnableLemmaAO)
        .pipe(timeout(5400000))
        .subscribe((res: any) => {
          this.spinner.hide();
          if (res != null || res != "") {
            if (res.Result != undefined) {
              if (res.Result.indexOf('The selected value qualifies for categorized description') > -1) {
                if (res.Result.indexOf('The selected value qualifies for categorized description') > -1) {
                  this.isQualifiedDescEnabled = true;
                  bootbox.alert(res.Result);
                  }
                  else{
                    bootbox.alert('Selected value is not qualified for the categorized description.');
                  }
              }
              else {
                if (res.BatchUID != '') {
                  this.BatchId = res.BatchUID;
                }
                bootbox.alert(res.Result);
              }
            }
            else {
              bootbox.alert('Qualified Description Failed.');
            }
          }
        }, (error: HttpErrorResponse) => {
          this.spinner.hide();
          if (error.message != "Timeout has occurred") {
            bootbox.alert('Error occur while Get Qualified Description.');
          }
        });
    }
    else if (tab == "AO") {
      // this.checkMinMaxDate();
      let stopwords = this.lstIgnoreKeys != '' ? this.lstIgnoreKeys.join() : '';
      this.spinner.show();
      
      this.DoTicketPull = true
    
      this.iomService.GetQualifiedDescription(this.SessionService.getUserName(), "AO", this.UserOption, this.SessionService.getE2EUId(), this.topKeyWord_AO, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, parseInt(this.SessionService.getUserType()), stopwords, ApplicationName,this.EnableLemmaAO)
        .pipe(timeout(5400000))
        .subscribe((res: any) => {
          this.spinner.hide();
          if (res != null || res != "") {
            if (res.Result != undefined) {
              if (res.Result.indexOf('The selected value qualifies for categorized description') > -1) {
                if (res.Result.indexOf('The selected value qualifies for categorized description') > -1) {
                  this.isQualifiedDescEnabled_AO = true;
                  bootbox.alert(res.Result);
                  }
                  else{
                    this.isQualifiedDescEnabled_AO = false;
                    bootbox.alert('Selected value is not qualified for the categorized description.');
                  }
              }
              else {
                if (res.BatchUID != '') {
                  this.BatchId = res.BatchUID;
                }
                this.isQualifiedDescEnabled_AO = false;
                bootbox.alert(res.Result);
              }
            }
            else {
              this.isQualifiedDescEnabled_AO = false;
              bootbox.alert('Qualified Description Failed.');
            }
          }
        }, (error: HttpErrorResponse) => {
          this.spinner.hide();
          if (error.message != "Timeout has occurred") {
            this.isQualifiedDescEnabled_AO = false;
            bootbox.alert('Error occur while Get Qualified Description.');
          }
        });
    }
    else if (tab == 'IO') {
      let stopwords = this.lstIgnoreKeys_io != '' ? this.lstIgnoreKeys_io.join() : '';
      this.spinner.show();
      if(this.DoTicketPull == false)
      {
        this.topKeyWord_IO.BatchId=this.SessionService.getSessionStorageItem('BatchIdGetTopKeyword');
      }
      this.iomService.GetQualifiedDescription(this.SessionService.getUserName(), "IO", this.UserOption, this.SessionService.getE2EUId(), this.topKeyWord_IO, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, parseInt(this.SessionService.getUserType()), stopwords, ApplicationName,this.EnableLemmaIO)
        .pipe(timeout(5400000))
        .subscribe((res: any) => {
          this.spinner.hide();
          if (res != null || res != "") {
            if (res.Result != undefined) {
              if (res.Result.indexOf('The selected value qualifies for categorized description') > -1) {
                if (res.Result.indexOf('The selected value qualifies for categorized description') > -1) {
                  this.isQualifiedDescEnabled_IO = true;
                  bootbox.alert(res.Result);
                  }
                  else{
                    this.isQualifiedDescEnabled_IO = false;
                    bootbox.alert('Selected value is not qualified for the categorized description.');
                  }
              }
              else {
                if (res.BatchUID != '') {
                  this.BatchId = res.BatchUID;
                }
                this.isQualifiedDescEnabled_IO = false;
                bootbox.alert(res.Result);
              }
            }
            else {
              this.isQualifiedDescEnabled_IO = false;
              bootbox.alert('Qualified Description Failed.');
            }
          }
        }, (error: HttpErrorResponse) => {
          this.spinner.hide();
          if (error.message != "Timeout has occurred") {
            this.isQualifiedDescEnabled_IO = false;
            bootbox.alert('Error occur while Get Qualified Description.');
          }
        });
    }
    else if (tab == 'OTHERS') {
      let stopwords = this.lstIgnoreKeys_others != '' ? this.lstIgnoreKeys_others.join() : '';
      this.spinner.show();
      if(this.DoTicketPull == false)
      {
      this.topKeyWord_Others.BatchId=this.SessionService.getSessionStorageItem('BatchIdGetTopKeyword');
      }
      this.iomService.GetQualifiedDescription(this.SessionService.getUserName(), "Others", this.UserOption, this.SessionService.getE2EUId(), this.topKeyWord_Others, false, this.DoTicketPull, this.MinStartDate, this.MaxEndDate, parseInt(this.SessionService.getUserType()), stopwords, ApplicationName,this.EnableLemmaOth)
        .pipe(timeout(5400000))
        .subscribe((res: any) => {
          this.spinner.hide();
          if (res != null || res != "") {
            if (res.Result != undefined) {
              if (res.Result.indexOf('The selected value qualifies for categorized description') > -1) {
                if (res.Result.indexOf('The selected value qualifies for categorized description') > -1) {
                  this.isQualifiedDescEnabled_Others = true;
                  bootbox.alert(res.Result);
                  }
                  else{
                    this.isQualifiedDescEnabled_Others = false;
                    bootbox.alert('Selected value is not qualified for the categorized description.');
                  }
              }
              else {
                if (res.BatchUID != '') {
                  this.BatchId = res.BatchUID;
                }
                this.isQualifiedDescEnabled_Others = false;
                bootbox.alert(res.Result);
              }
            }
            else {
              this.isQualifiedDescEnabled_Others = false;
              bootbox.alert('Qualified Description Failed.');
            }
          }
        }, (error: HttpErrorResponse) => {
          this.spinner.hide();
          if (error.message != "Timeout has occurred") {
            this.isQualifiedDescEnabled_Others = false;
            bootbox.alert('Error occur while Get Qualified Description.');
          }
        });
    }
  
  this.prevtab = tab;
}

ResetQualifiedDesc()
{
  this.lstClassifiedBy = [];
  this.textConfigFormStandard.get('ClassifiedBased').setValue('Select');
  this.lstClassifiedBy = this.lstClassifiedByTemp;
  if (this.envVar.ClientConfiguration.isMultiSelectTicketType == false) {
    if (this.textConfigFormStandard.value.ticketType == '7') {
      this.lstClassifiedBy = this.lstClassifiedBy.filter(item => item.name !== 'Resolution Description');
    }
  }
  else {
    if (this.selectedTickettype == '7') {
      this.lstClassifiedBy = this.lstClassifiedBy.filter(item => item.name !== 'Resolution Description');
    }
  }
}

onItemSelect(dropdownName: string, item: any) {
  if(dropdownName =='stdLanguage')
  {
    this.selectedStdLanguage.push(item);
    this.GetLanguageCheck_Std(item);
  }
  else if(dropdownName =='LanguageAO')
  {
    this.ChartData_AO = null;
    this.selectedLanguage_AO.push(item);
    this.GetLanguageCheck_AO('AO', true);
  }
  else if(dropdownName =='LanguageIO')
  {
    this.ChartData_IO = null;
    this.selectedLanguage_IO.push(item);
    this.GetLanguageCheck_IO('IO');
    if(item!='English')
    {
      this.textConfigForm.get('IOGroup').get('algorithmModel').setValue('2');
      this.algorithmChange(true,'io', false, true, true,'')
    }
  }
  else if(dropdownName =='LanguageOther')
  {
    this.ChartData_Others = null;
    this.selectedLanguage_Other.push(item);
    this.GetLanguageCheck_Others('Others', true);
  }
}

onItemSelectAll(dropdownName: string, item: any) {
  if(dropdownName =='stdLanguage')
  {
    this.selectedStdLanguage = [];
    for (var i = 0; i < this.LanguageList.length; i++) {
      this.selectedStdLanguage.push(this.LanguageList[i])
    }
    this.GetLanguageCheck_Std(item);
  }
  else if(dropdownName =='LanguageAO')
  {
    this.ChartData_AO = null;
    this.selectedLanguage_AO = [];
    for (var i = 0; i < this.LanguageList.length; i++) {
      this.selectedLanguage_AO.push(this.LanguageList[i])
    }
    this.GetLanguageCheck_AO('AO', true);
  }
  else if(dropdownName =='LanguageIO')
  {
    this.ChartData_IO = null;
    this.selectedLanguage_IO = [];
    for (var i = 0; i < this.LanguageList.length; i++) {
      this.selectedLanguage_IO.push(this.LanguageList[i])
    }
    this.GetLanguageCheck_IO('IO');
  }
  else if(dropdownName =='LanguageOther')
  {
    this.ChartData_Others = null;
    this.selectedLanguage_Other = [];
    for (var i = 0; i < this.LanguageList.length; i++) {
      this.selectedLanguage_Other.push(this.LanguageList[i])
    }
    this.GetLanguageCheck_Others('Others', true);
  }
}

onItemDeSelect(dropdownName: string, item: any) {
  if(dropdownName =='stdLanguage')
  {
      this.selectedStdLanguage.forEach((value,index)=>{
        if(value==item) this.selectedStdLanguage.splice(index,1);
    });
    this.GetLanguageCheck_Std(item);
  }
  else if(dropdownName =='LanguageAO')
  {
    this.ChartData_AO = null;
      this.selectedLanguage_AO.forEach((value,index)=>{
        if(value==item) this.selectedLanguage_AO.splice(index,1);
    });
    this.GetLanguageCheck_AO('AO', true);
  }
  else if(dropdownName =='LanguageIO')
  {
    this.ChartData_IO = null;
      this.selectedLanguage_IO.forEach((value,index)=>{
        if(value==item) this.selectedLanguage_IO.splice(index,1);
    });
    this.GetLanguageCheck_IO('IO');
  }
  else if(dropdownName =='LanguageOther')
  {
    this.ChartData_Others = null;
      this.selectedLanguage_Other.forEach((value,index)=>{
        if(value==item) this.selectedLanguage_Other.splice(index,1);
    });
    this.GetLanguageCheck_Others('Others', true);
  }
}

onItemDeSelectAll(dropdownName: string, item: any) {
  if(dropdownName =='stdLanguage')
  {
    this.selectedStdLanguage = [];
    this.GetLanguageCheck_Std(item);
  }
  else if(dropdownName =='LanguageAO')
  {
    this.ChartData_AO = null;
    this.selectedLanguage_AO = [];
    this.GetLanguageCheck_AO('AO', true);
  }
  else if(dropdownName =='LanguageIO')
  {
    this.ChartData_IO = null;
    this.selectedLanguage_IO = [];
    this.GetLanguageCheck_IO('IO');
  }
  else if(dropdownName =='LanguageOther')
  {
    this.ChartData_Others = null;
    this.selectedLanguage_Other = [];
    this.GetLanguageCheck_Others('Others', true);
  }
}

GetSelectedLanguage(item: any, tab:string) {
    // this.spinner.show();
    // this.SessionService.setSessionStorageItem("SelectedDDLanguage", item.target.value);
    // this.selectedStdLanguage=item;
    switch (tab) {
      case 'ao':
        this.selectedStdLanguageAO = item.target.value;
        //this.getStopKeyWords('AO', item, false)
        break;
      case 'io':
        this.selectedStdLanguageIO = item.target.value;
        //this.getStopKeyWords('IO', item, false)
        break;
      case 'others':
        this.selectedStdLanguageOthers = item.target.value;
        //this.getStopKeyWords('Others', item, false)
        break;
      default:
        break;
    }
}

pushLanguageWiseKeyword(item:string,tab:string)
{
  switch (tab) {
    case 'ao':
    let objIndexAO = this.LanguageKeywordAO.findIndex((obj => obj.Language == this.selectedStdLanguageAO));
    if (objIndexAO != -1) {
    var keywordsTemp: string[] = this.LanguageKeywordAO[objIndexAO].Keywords;
    keywordsTemp.push(item);
    this.LanguageKeywordAO[objIndexAO].Keywords = keywordsTemp;
     }
    else{
    var keywordsTemp: string[] = [];
    keywordsTemp.push(item);
    this.LanguageKeywordAO.push({ Language: this.selectedStdLanguageAO, Keywords:keywordsTemp });
    }
    break;
    case 'io':
      let objIndexIO = this.LanguageKeywordIO.findIndex((obj => obj.Language == this.selectedStdLanguageIO));
      if (objIndexIO != -1) {
      var keywordsTemp: string[] = this.LanguageKeywordIO[objIndexIO].Keywords;
      keywordsTemp.push(item);
      this.LanguageKeywordIO[objIndexIO].Keywords = keywordsTemp;
       }
      else{
      var keywordsTemp: string[] = [];
      keywordsTemp.push(item);
      this.LanguageKeywordIO.push({ Language: this.selectedStdLanguageIO, Keywords:keywordsTemp });
      }
    break;
    case 'others':
      let objIndex = this.LanguageKeywordOthers.findIndex((obj => obj.Language == this.selectedStdLanguageOthers));
      if (objIndex != -1) {
      var keywordsTemp: string[] = this.LanguageKeywordOthers[objIndex].Keywords;
      keywordsTemp.push(item);
      this.LanguageKeywordOthers[objIndex].Keywords = keywordsTemp;
       }
      else{
      var keywordsTemp: string[] = [];
      keywordsTemp.push(item);
      this.LanguageKeywordOthers.push({ Language: this.selectedStdLanguageOthers, Keywords:keywordsTemp });
      }
    break;
    default:
      break;
  }
}

pullLanguageWiseKeyword(item:string,tab:string)
{
  item = item.substring(0,item.indexOf('('));
  switch (tab) {
    case 'ao':
      let objIndexAO = this.LanguageKeywordAO.findIndex((obj => obj.Keywords.includes(item)));
      if (objIndexAO != -1) {
        var keywordsTemp: string[] = this.LanguageKeywordAO[objIndexAO].Keywords;
        const index: number = keywordsTemp.indexOf(item);
        if (index !== -1) {
            keywordsTemp.splice(index, 1);
        }        
        this.LanguageKeywordAO[objIndexAO].Keywords = keywordsTemp;
      }
      break;
    case 'io':
    let objIndexIO = this.LanguageKeywordIO.findIndex((obj => obj.Keywords.includes(item)));
    if (objIndexIO != -1) {
    var keywordsTemp: string[] = this.LanguageKeywordIO[objIndexIO].Keywords;
    const index: number = keywordsTemp.indexOf(item);
    if (index !== -1) {
        keywordsTemp.splice(index, 1);
    }        
    this.LanguageKeywordIO[objIndexIO].Keywords = keywordsTemp;
    }
    break;
    case 'others':
      let objIndex = this.LanguageKeywordOthers.findIndex((obj => obj.Keywords.includes(item)));
      if (objIndex != -1) {
        var keywordsTemp: string[] = this.LanguageKeywordOthers[objIndex].Keywords;
        const index: number = keywordsTemp.indexOf(item);
        if (index !== -1) {
            keywordsTemp.splice(index, 1);
        }        
        this.LanguageKeywordOthers[objIndex].Keywords = keywordsTemp;
      }
    break;
    default:
      break;
  }
}

}
